
class $c1844ae22deae2c0$export$b229f242afc35ae9 {
    constructor(puppet){
        const self = this;
        this.puppet = puppet;
        this.animated = null;
        this.animeId = randomID();
        // Time/synchronization related variables
        this.frameTime = {};
        this.elapsedTime = {};
        this.loopElapsedTime = {};
        this.loops = {};
        this.internalLoops = {};
        this.ping = {};
        this.pauseBetweenElapsedTime = {};
        this.pauseBetween = {};
        this.shutdown = {};
        if (!(this.puppet == null)) {
            if (this.puppet.hasOwnProperty("animated") && !(this.puppet.animated == null) && typeof this.puppet.animated === "object" && Object.keys(this.puppet.animated).length > 0) {
                this.initAnimatedInternals(this.puppet.animated);
                this.animated = this.puppet.animated; // easy access to the puppet's animodes
            }
            $c1844ae22deae2c0$export$b229f242afc35ae9.addAnimation(self); // ready to tick
        }
    }
    static rgbToValue(r, g, b) {
        return r << 16 | g << 8 | b;
    }
    static valueToRgb(bin) {
        const r = bin >> 16;
        const g = bin >> 8 & 0xff;
        const b = bin & 0xff;
        return [
            r,
            g,
            b
        ];
    }
    static oscillation(elapsed, loopDuration, syncShift, val1, val2, func, isSync, xpi = $c1844ae22deae2c0$export$b229f242afc35ae9.twoPi) {
        return (val1 - val2) * (func(xpi * (isSync ? $c1844ae22deae2c0$export$b229f242afc35ae9.getSynchronizedTime(loopDuration, syncShift) : elapsed / loopDuration + syncShift)) + 1) / 2 + val2;
    }
    static colOscillation(elapsed, loopDuration, syncShift, val1, val2, isSync, xpi = $c1844ae22deae2c0$export$b229f242afc35ae9.twoPi) {
        const rgbValue1 = $c1844ae22deae2c0$export$b229f242afc35ae9.valueToRgb(val1);
        const rgbValue2 = $c1844ae22deae2c0$export$b229f242afc35ae9.valueToRgb(val2);
        return $c1844ae22deae2c0$export$b229f242afc35ae9.rgbToValue(Math.floor($c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(elapsed, loopDuration, syncShift, rgbValue1[0], rgbValue2[0], Math.cos, isSync, xpi)), Math.floor($c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(elapsed, loopDuration, syncShift, rgbValue1[1], rgbValue2[1], Math.cos, isSync, xpi)), Math.floor($c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(elapsed, loopDuration, syncShift, rgbValue1[2], rgbValue2[2], Math.cos, isSync, xpi)));
    }
    static getSynchronizedTime(loopDuration, syncShift) {
        return $c1844ae22deae2c0$export$b229f242afc35ae9._lastTime / loopDuration + syncShift;
    }
    static getSynchronizedRotation(loopDuration, syncShift) {
        return 360 * (($c1844ae22deae2c0$export$b229f242afc35ae9._lastTime + syncShift) % loopDuration) / loopDuration;
    }
    static getPuppetsByParams(params) {
        let puppetArray = [];
        $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.forEach((anime, id)=>{
            if (anime.puppet.placeableId === params.placeableId && anime.puppet.filterId === params.filterId && (!anime.puppet.hasOwnProperty("filterInternalId") || anime.puppet.filterInternalId === params.filterInternalId)) puppetArray.push(anime.puppet);
        });
        return puppetArray;
    }
    static addAnimation(anime) {
        $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.set(anime.animeId, anime);
        $c1844ae22deae2c0$export$b229f242afc35ae9._resumeAnimation();
    }
    static removeAnimation(placeableId) {
        $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.forEach((anime, id)=>{
            if (anime.puppet.placeableId === placeableId) $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.delete(id);
        });
        if ($c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.size === 0) $c1844ae22deae2c0$export$b229f242afc35ae9._suspendAnimation();
    }
    static removeAnimationByFilterId(placeableId, filterId) {
        $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.forEach((anime, id)=>{
            if (anime.puppet.placeableId === placeableId && anime.puppet.filterId === filterId) $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.delete(id);
        });
        if ($c1844ae22deae2c0$export$b229f242afc35ae9._animeMap.size === 0) $c1844ae22deae2c0$export$b229f242afc35ae9._suspendAnimation();
    }
    static resetAnimation() {
        $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap = new Map();
        $c1844ae22deae2c0$export$b229f242afc35ae9._suspended = true;
    }
    static tick() {
        $c1844ae22deae2c0$export$b229f242afc35ae9._lastTime = canvas.app.ticker.lastTime;
        $c1844ae22deae2c0$export$b229f242afc35ae9._frameTime = $c1844ae22deae2c0$export$b229f242afc35ae9._lastTime - $c1844ae22deae2c0$export$b229f242afc35ae9._prevTime;
        for (const [id, anime] of $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap)if (anime.puppet.enabled) {
            if (anime.puppet.hasOwnProperty("preComputation") && anime.puppet.placeableImg != null) anime.puppet.preComputation();
            if (anime.puppet.hasOwnProperty("animated") && !(anime.puppet.animated == null)) anime.animate($c1844ae22deae2c0$export$b229f242afc35ae9._frameTime);
        }
        $c1844ae22deae2c0$export$b229f242afc35ae9._prevTime = $c1844ae22deae2c0$export$b229f242afc35ae9._lastTime;
    }
    static _suspendAnimation() {
        if ($c1844ae22deae2c0$export$b229f242afc35ae9._activated && !$c1844ae22deae2c0$export$b229f242afc35ae9._suspended && !(0, $97b1237a45b106ea$export$4876a704e2bf90fb)()) $c1844ae22deae2c0$export$b229f242afc35ae9._detachFromTicker();
        $c1844ae22deae2c0$export$b229f242afc35ae9._suspended = true;
    }
    static _resumeAnimation() {
        if ($c1844ae22deae2c0$export$b229f242afc35ae9._activated && $c1844ae22deae2c0$export$b229f242afc35ae9._suspended && !(0, $97b1237a45b106ea$export$4876a704e2bf90fb)()) $c1844ae22deae2c0$export$b229f242afc35ae9._attachToTicker();
        $c1844ae22deae2c0$export$b229f242afc35ae9._suspended = false;
    }
    static activateAnimation() {
        if (!$c1844ae22deae2c0$export$b229f242afc35ae9._activated && !$c1844ae22deae2c0$export$b229f242afc35ae9._suspended && !(0, $97b1237a45b106ea$export$4876a704e2bf90fb)()) $c1844ae22deae2c0$export$b229f242afc35ae9._attachToTicker();
        $c1844ae22deae2c0$export$b229f242afc35ae9._activated = true;
    }
    static deactivateAnimation() {
        if ($c1844ae22deae2c0$export$b229f242afc35ae9._activated && !$c1844ae22deae2c0$export$b229f242afc35ae9._suspended && !(0, $97b1237a45b106ea$export$4876a704e2bf90fb)()) $c1844ae22deae2c0$export$b229f242afc35ae9._detachFromTicker();
        $c1844ae22deae2c0$export$b229f242afc35ae9._activated = false;
    }
    static _attachToTicker() {
        canvas.app.ticker.add($c1844ae22deae2c0$export$b229f242afc35ae9.tick, this, PIXI.UPDATE_PRIORITY.LOW + 1);
        $c1844ae22deae2c0$export$b229f242afc35ae9._lastTime = canvas.app.ticker.lastTime;
        $c1844ae22deae2c0$export$b229f242afc35ae9._prevTime = $c1844ae22deae2c0$export$b229f242afc35ae9._lastTime;
    }
    static _detachFromTicker() {
        canvas.app.ticker.remove($c1844ae22deae2c0$export$b229f242afc35ae9.tick, this);
        $c1844ae22deae2c0$export$b229f242afc35ae9._lastTime = 0;
        $c1844ae22deae2c0$export$b229f242afc35ae9._prevTime = 0;
    }
    static getAnimeMap() {
        return $c1844ae22deae2c0$export$b229f242afc35ae9._animeMap;
    }
    initAnimatedInternals(animated) {
        Object.keys(animated).forEach((effect)=>{
            // Internals init
            this.initInternals(effect);
        });
    }
    initInternals(effect) {
        this.elapsedTime[effect] = 0;
        this.loopElapsedTime[effect] = 0;
        this.pauseBetweenElapsedTime[effect] = 0;
        this.loops[effect] = 0;
        this.internalLoops[effect] = 0;
        this.frameTime[effect] = 0;
        this.pauseBetween[effect] = false;
        this.ping[effect] = false;
        this.shutdown[effect] = false;
    }
    hasInternals(effect) {
        return this.elapsedTime.hasOwnProperty(effect);
    }
    animate(frameTime) {
        for (const effect of Object.keys(this.puppet.animated))if (this.animated[effect].active && this.cycleCheck(effect, frameTime)) {
            if (this[this.animated[effect].animType] != null) this[this.animated[effect].animType](effect);
            if (this.shutdown[effect]) {
                this.animated[effect].active = false;
                this.shutdown[effect] = false;
                // persists the value of an effect which is terminated.
                this.persistTerminatedEffect(effect);
            } else {
                this.loopElapsedTime[effect] += frameTime;
                this.elapsedTime[effect] += frameTime;
            }
        }
        this.autoDisableCheck();
    }
    cycleCheck(effect, frameTime) {
        this.frameTime[effect] = frameTime;
        if (this.isPauseBetweenLoop(effect, frameTime)) return false;
        if (this.loopElapsedTime[effect] > this.animated[effect].loopDuration) {
            this.loopElapsedTime[effect] -= this.animated[effect].loopDuration;
            this.ping[effect] = true;
            if (this.animated[effect].loops !== Infinity) {
                this.loops[effect]++;
                this.internalLoops[effect]++;
            }
            if (this.loops[effect] >= this.animated[effect].loops) {
                // correction to stop exactly on the target value when the last loop end.
                this.elapsedTime[effect] = this.internalLoops[effect] * this.animated[effect].loopDuration;
                this.loops[effect] = 0;
                this.loopElapsedTime[effect] = 0;
                this.shutdown[effect] = true;
            } else if (this.animated[effect].pauseBetweenDuration > 0) {
                this.elapsedTime[effect] = this.animated[effect].loopDuration;
                this.pauseBetween[effect] = true;
            }
        }
        return true;
    }
    async persistTerminatedEffect(effect) {
        if (!(this.puppet.filterOwner === game.data.userId)) return;
        let animeInfo;
        let doInit = true;
        let flag = this.puppet.targetPlaceable.document.getFlag("tokenmagic", "animeInfo");
        if (flag) // fastest than array.find
        for (const animeinfo of flag.values()){
            if (animeinfo.tmFilterId === this.puppet.filterId && animeinfo.tmFilterInternalId === this.puppet.filterInternalId && animeinfo.tmFilterEffect === effect) {
                if (animeinfo && animeinfo instanceof Object) {
                    animeinfo.tmFilterEffectValue = this.puppet[effect];
                    doInit = false;
                    break;
                }
            }
        }
        if (doInit) {
            animeInfo = [
                {
                    tmFilterId: this.puppet.filterId,
                    tmFilterInternalId: this.puppet.filterInternalId,
                    tmFilterEffect: effect,
                    tmFilterEffectValue: this.puppet[effect]
                }
            ];
            if (flag) flag = flag.concat(animeInfo);
            else flag = animeInfo;
        }
        flag = duplicate(flag);
        await this.puppet.targetPlaceable._TMFXsetAnimeFlag(flag);
    }
    autoDisableCheck() {
        if (!(this.puppet.autoDisable || this.puppet.autoDestroy)) return;
        if (!(this.puppet.filterOwner === game.data.userId)) return;
        if (this.puppet.enabled === false && !this.puppet.autoDestroy) return;
        if (Object.values(this.animated).every((animeEffect)=>animeEffect.active === false)) this.disableOrDestroy();
    }
    async disableOrDestroy() {
        if (this.puppet == null) return;
        const placeable = this.puppet.targetPlaceable;
        if (placeable == null) return;
        if (this.puppet.autoDestroy) await window.TokenMagic.deleteFilters(placeable, this.puppet.filterId);
        else {
            let params = {};
            params.filterType = this.puppet.filterType;
            params.filterId = this.puppet.filterId;
            params.enabled = false;
            await window.TokenMagic.updateFiltersByPlaceable(placeable, [
                params
            ]);
        }
    }
    isPauseBetweenLoop(effect, frametime) {
        if (this.pauseBetween[effect] && this.animated[effect].pauseBetweenDuration > 0) {
            this.pauseBetweenElapsedTime[effect] += frametime;
            if (this.pauseBetweenElapsedTime[effect] < this.animated[effect].pauseBetweenDuration) return true;
            else {
                this.pauseBetweenElapsedTime[effect] = 0;
                return this.pauseBetween[effect] = false;
            }
        }
        return false;
    }
    pauseBetweenCheck(effect, frametime) {
        if (this.pauseStart[effect] && this.animated[effect].pauseStartDuration > 0) {
            this.pauseStartElapsedTime[effect] += frametime;
            if (this.pauseStartElapsedTime[effect] < this.animated[effect].pauseStartDuration) return false;
            else {
                this.pauseStart[effect] = false;
                return true;
            }
        }
    }
    moveToward(effect) {
        this.puppet[effect] = (this.animated[effect].val1 - this.animated[effect].val2) / this.animated[effect].loopDuration * this.elapsedTime[effect];
    }
    colorOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.colOscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, false);
    }
    halfColorOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.colOscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, false, Math.PI);
    }
    syncColorOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.colOscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, true);
    }
    cosOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, Math.cos, false);
    }
    halfCosOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, Math.cos, false, Math.PI);
    }
    sinOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, Math.sin, false);
    }
    halfSinOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, Math.sin, false, Math.PI);
    }
    chaoticOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift + Math.random() * this.animated[effect].chaosFactor, this.animated[effect].val1, this.animated[effect].val2, Math.cos, false);
    }
    syncCosOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, Math.cos, true);
    }
    syncSinOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift, this.animated[effect].val1, this.animated[effect].val2, Math.sin, true);
    }
    syncChaoticOscillation(effect) {
        this.puppet[effect] = $c1844ae22deae2c0$export$b229f242afc35ae9.oscillation(this.elapsedTime[effect], this.animated[effect].loopDuration, this.animated[effect].syncShift + Math.random() * this.animated[effect].chaosFactor, this.animated[effect].val1, this.animated[effect].val2, Math.cos, true);
    }
    rotation(effect) {
        const computedRotation = 360 * this.elapsedTime[effect] / this.animated[effect].loopDuration;
        this.puppet[effect] = this.animated[effect].clockWise ? computedRotation : 360 - computedRotation;
    }
    syncRotation(effect) {
        const computedRotation = $c1844ae22deae2c0$export$b229f242afc35ae9.getSynchronizedRotation(this.animated[effect].loopDuration, this.animated[effect].syncShift);
        this.puppet[effect] = this.animated[effect].clockWise ? computedRotation : 360 - computedRotation;
    }
    randomNumber(effect) {
        const randomNumber = Math.random() * (this.animated[effect].val2 - this.animated[effect].val1) + this.animated[effect].val1;
        if (this.animated[effect].wantInteger) this.puppet[effect] = Math.floor(randomNumber);
        else this.puppet[effect] = randomNumber;
    }
    randomNumberPerLoop(effect) {
        if (this._ringing(effect)) this.randomNumber(effect);
    }
    randomColor(effect) {
        this.puppet[effect] = Math.floor(Math.random() * 16777215);
    }
    randomColorPerLoop(effect) {
        if (this._ringing(effect)) this.randomColor(effect);
    }
    move(effect) {
        this.puppet[effect] += this.animated[effect].speed * this.frameTime[effect];
    }
    _ringing(effect) {
        if (this.ping[effect]) {
            this.ping[effect] = false;
            return true;
        }
        return false;
    }
}
$c1844ae22deae2c0$export$b229f242afc35ae9._lastTime = 0;
$c1844ae22deae2c0$export$b229f242afc35ae9._prevTime = 0;
$c1844ae22deae2c0$export$b229f242afc35ae9._frameTime = 0;
$c1844ae22deae2c0$export$b229f242afc35ae9._animeMap = new Map();
$c1844ae22deae2c0$export$b229f242afc35ae9.twoPi = Math.PI * 2;
$c1844ae22deae2c0$export$b229f242afc35ae9._activated = false;
$c1844ae22deae2c0$export$b229f242afc35ae9._suspended = true;




const $165cdb672a404ae7$export$7395e4cb572e863b = 0.5;
const $165cdb672a404ae7$export$680af52575be3523 = "NOFX";
const $165cdb672a404ae7$export$2f8ff78910784c41 = 10000;


var $df3c2368c99a47ef$export$5b94be486bc63144 = (0, $165cdb672a404ae7$export$2f8ff78910784c41);
PlaceableObject.prototype.TMFXaddFilters = async function(paramsArray, replace = false) {
    await (0, $97b1237a45b106ea$export$480e4c19201e4e74).addFilters(this, paramsArray, replace);
};
PlaceableObject.prototype.TMFXupdateFilters = async function(paramsArray) {
    await (0, $97b1237a45b106ea$export$480e4c19201e4e74).updateFiltersByPlaceable(this, paramsArray);
};
PlaceableObject.prototype.TMFXaddUpdateFilters = async function(paramsArray) {
    await (0, $97b1237a45b106ea$export$480e4c19201e4e74).addUpdateFilters(this, paramsArray);
};
PlaceableObject.prototype.TMFXdeleteFilters = async function(filterId = null) {
    await (0, $97b1237a45b106ea$export$480e4c19201e4e74).deleteFilters(this, filterId);
};
PlaceableObject.prototype.TMFXhasFilterType = function(filterType) {
    return (0, $97b1237a45b106ea$export$480e4c19201e4e74).hasFilterType(this, filterType);
};
PlaceableObject.prototype.TMFXhasFilterId = function(filterId) {
    return (0, $97b1237a45b106ea$export$480e4c19201e4e74).hasFilterId(this, filterId);
};
PlaceableObject.prototype._TMFXsetFlag = async function(flag) {
    if ((0, $97b1237a45b106ea$export$ae4b89d79d01bd2b)()) (0, $97b1237a45b106ea$export$24d33a6f4bffea69)(this, flag, (0, $97b1237a45b106ea$export$157d7b8c087faa7b).SET_FLAG);
    else await this.document.setFlag("tokenmagic", "filters", flag);
};
PlaceableObject.prototype._TMFXsetAnimeFlag = async function(flag) {
    if ((0, $97b1237a45b106ea$export$ae4b89d79d01bd2b)()) (0, $97b1237a45b106ea$export$24d33a6f4bffea69)(this, flag, (0, $97b1237a45b106ea$export$157d7b8c087faa7b).SET_ANIME_FLAG);
    else await this.document.setFlag("tokenmagic", "animeInfo", flag);
};
PlaceableObject.prototype._TMFXunsetFlag = async function() {
    if ((0, $97b1237a45b106ea$export$ae4b89d79d01bd2b)()) (0, $97b1237a45b106ea$export$24d33a6f4bffea69)(this, null, (0, $97b1237a45b106ea$export$157d7b8c087faa7b).SET_FLAG);
    else await this.document.unsetFlag("tokenmagic", "filters");
};
PlaceableObject.prototype._TMFXunsetAnimeFlag = async function() {
    if ((0, $97b1237a45b106ea$export$ae4b89d79d01bd2b)()) (0, $97b1237a45b106ea$export$24d33a6f4bffea69)(this, null, (0, $97b1237a45b106ea$export$157d7b8c087faa7b).SET_ANIME_FLAG);
    else await this.document.unsetFlag("tokenmagic", "animeInfo");
};
PlaceableObject.prototype._TMFXgetSprite = function() {
    const type = this._TMFXgetPlaceableType();
    switch(type){
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TOKEN:
            return this.mesh;
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TILE:
            return this.mesh ?? this.bg;
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TEMPLATE:
            return this.template;
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).DRAWING:
            return this.hasText ? this.text : this.shape;
        default:
            return null;
    }
};
PlaceableObject.prototype._TMFXgetPlaceablePadding = function() {
    // get the placeable padding, by taking into account all filters and options
    let accPadding = 0;
    const filters = this._TMFXgetSprite().filters;
    if (filters instanceof Array) for (const filter of filters){
        if (!filter.enabled) continue;
        if (canvas.app.renderer.filter.useMaxPadding) accPadding = Math.max(accPadding, filter.padding);
        else accPadding += filter.padding;
    }
    return accPadding;
};
PlaceableObject.prototype._TMFXcheckSprite = function() {
    const type = this._TMFXgetPlaceableType();
    switch(type){
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TOKEN:
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TILE:
            return !(this.mesh == null);
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TEMPLATE:
            return !(this.template == null);
        case (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).DRAWING:
            return !(this.shape == null);
        default:
            return null;
    }
};
PlaceableObject.prototype._TMFXgetMaxFilterRank = function() {
    const sprite = this._TMFXgetSprite();
    if (sprite == null) return $df3c2368c99a47ef$export$5b94be486bc63144++;
    if (sprite.filters == null) return $df3c2368c99a47ef$export$5b94be486bc63144++;
    else {
        let maxRank = Math.max(...sprite.filters.map((f)=>f.rank), (0, $165cdb672a404ae7$export$2f8ff78910784c41));
        $df3c2368c99a47ef$export$5b94be486bc63144 = Math.max(maxRank, $df3c2368c99a47ef$export$5b94be486bc63144) + 1;
        return $df3c2368c99a47ef$export$5b94be486bc63144;
    }
};
PlaceableObject.prototype._TMFXsetRawFilters = function(filters) {
    function insertFilter(filters) {
        function filterZOrderCompare(a, b) {
            if (a.zOrder < b.zOrder) return -1;
            if (a.zOrder > b.zOrder) return 1;
            return 0;
        }
        function filterRankCompare(a, b) {
            if (a.rank < b.rank) return -1;
            if (a.rank > b.rank) return 1;
            return 0;
        }
        if (!isZOrder) {
            if (!filters.hasOwnProperty("rank")) {
                let maxRank = Math.max(...sprite.filters.map((f)=>f.rank), (0, $165cdb672a404ae7$export$2f8ff78910784c41));
                filters.rank = maxRank + 1;
            }
        }
        sprite.filters.push(filters);
        isZOrder ? sprite.filters.sort(filterZOrderCompare) : sprite.filters.sort(filterRankCompare);
    }
    function addFilter(filters) {
        if (!isZOrder && !filters.hasOwnProperty("rank")) filters.rank = (0, $165cdb672a404ae7$export$2f8ff78910784c41);
        sprite.filters = [
            filters
        ];
    }
    const isZOrder = (0, $97b1237a45b106ea$export$222530a21fa4a417)();
    const sprite = this._TMFXgetSprite();
    if (sprite == null) return false;
    if (filters == null) sprite.filters = null;
    else sprite.filters == null ? addFilter(filters) : insertFilter(filters);
    return true;
};
PlaceableObject.prototype._TMFXunsetRawFilters = function() {
    return this._TMFXsetRawFilters(null);
};
PlaceableObject.prototype._TMFXgetPlaceableType = function() {
    if ([
        (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TOKEN,
        (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TEMPLATE,
        (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TILE,
        (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).DRAWING
    ].includes(this.constructor.embeddedName)) return this.constructor.embeddedName;
    return (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).NOT_SUPPORTED;
};


PIXI.Filter.prototype.setTMParams = function(params) {
    this.autoDisable = false;
    this.autoDestroy = false;
    this.gridPadding = 0;
    this.boundsPadding = new PIXI.Point(0, 0);
    this.currentPadding = 0;
    this.recalculatePadding = true;
    this.dummy = false;
    foundry.utils.mergeObject(this, params);
    if (!this.dummy) {
        this.rawPadding = this.rawPadding ?? this.padding ?? 0;
        this.originalPadding = Math.max(this.rawPadding, (0, $97b1237a45b106ea$export$a3e1d0865041c250)());
        this.assignPlaceable();
        this.activateTransform();
        Object.defineProperty(this, "padding", {
            get: function() {
                if (this.recalculatePadding) this.calculatePadding();
                return this.currentPadding;
            },
            set: function(padding) {
                this.rawPadding = padding;
                this.originalPadding = Math.max(padding, (0, $97b1237a45b106ea$export$a3e1d0865041c250)());
            }
        });
    } else this.apply = function(filterManager, input, output, clear) {
        filterManager.applyFilter(this, input, output, clear);
    };
};
PIXI.Filter.prototype.getPlaceable = function() {
    return (0, $97b1237a45b106ea$export$5008448b4c27fa2b)(this.placeableId, this.placeableType);
};
PIXI.Filter.prototype.getPlaceableType = function() {
    return this.placeableType;
};
PIXI.Filter.prototype.calculatePadding = function() {
    const target = this.placeableImg;
    let width;
    let height;
    {
        const ang = !this.sticky && this.placeableType !== (0, $97b1237a45b106ea$export$f2f6f02affe07ab5).TOKEN ? target.rotation : 0;
        const sin = Math.sin(ang);
        const cos = Math.cos(ang);
        width = Math.abs(target.width * cos) + Math.abs(target.height * sin);
        height = Math.abs(target.width * sin) + Math.abs(target.height * cos);
    }
    if (this.gridPadding > 0) {
        const gridSize = canvas.dimensions.size;
        this.boundsPadding.x = this.boundsPadding.y = (this.gridPadding - 1) * gridSize;
        this.boundsPadding.x += (gridSize - 1 - (width + gridSize - 1) % gridSize) / 2;
        this.boundsPadding.y += (gridSize - 1 - (height + gridSize - 1) % gridSize) / 2;
    } else this.boundsPadding.x = this.boundsPadding.y = this.rawPadding;
    {
        const ang = this.sticky ? target.rotation : 0;
        const sin = Math.sin(ang);
        const cos = Math.cos(ang);
        this.currentPadding = Math.max(Math.abs(this.boundsPadding.x * cos) + Math.abs(this.boundsPadding.y * sin), Math.abs(this.boundsPadding.x * sin) + Math.abs(this.boundsPadding.y * cos)) + (this.originalPadding - this.rawPadding);
    }
    this.boundsPadding.x += (width - target.width) / 2;
    this.boundsPadding.y += (height - target.height) / 2;
    const scale = this.targetPlaceable.worldTransform.a;
    this.boundsPadding.x *= scale;
    this.boundsPadding.y *= scale;
    this.currentPadding *= scale;
};
PIXI.Filter.prototype.assignPlaceable = function() {
    this.targetPlaceable = this.getPlaceable();
    this.targetPlaceable != null ? this.placeableImg = this.targetPlaceable._TMFXgetSprite() : this.placeableImg = null;
};
PIXI.Filter.prototype.activateTransform = function() {
    this.preComputation = this.filterTransform;
    this.filterTransform();
    const apply = this.apply;
    this.apply = function(filterManager, input, output, clear, state) {
        if ("handleTransform" in this) this.handleTransform(state);
        return apply.apply(this, arguments);
    };
};
PIXI.Filter.prototype.filterTransform = function() {
    if (this.hasOwnProperty("zIndex")) this.targetPlaceable.zIndex = this.zIndex;
};
PIXI.Filter.prototype.normalizeTMParams = function() {
    if (this.hasOwnProperty("animated") && !(this.animated == null)) // Normalize animations properties
    Object.keys(this.animated).forEach((effect)=>{
        if (this.animated[effect].active == null || typeof this.animated[effect].active != "boolean") this.animated[effect].active = true;
        if (this.animated[effect].loops == null || typeof this.animated[effect].loops != "number" || this.animated[effect].loops <= 0) this.animated[effect].loops = Infinity;
        if (this.animated[effect].loopDuration == null || typeof this.animated[effect].loopDuration != "number" || this.animated[effect].loopDuration <= 0) this.animated[effect].loopDuration = 3000;
        if (this.animated[effect].clockWise == null || typeof this.animated[effect].clockWise != "boolean") this.animated[effect].clockWise = true;
        if (this.animated[effect].pauseBetweenDuration == null || typeof this.animated[effect].pauseBetweenDuration != "number" || this.animated[effect].pauseBetweenDuration <= 0) this.animated[effect].pauseBetweenDuration = 0;
        if (this.animated[effect].syncShift == null || typeof this.animated[effect].syncShift != "number" || this.animated[effect].syncShift < 0) this.animated[effect].syncShift = 0;
        if (this.animated[effect].val1 == null || typeof this.animated[effect].val1 != "number") this.animated[effect].val1 = 0;
        if (this.animated[effect].val2 == null || typeof this.animated[effect].val2 != "number") this.animated[effect].val2 = 0;
        if (this.anime[this.animated[effect].animType] === undefined) this.animated[effect].animType = null;
        if (this.animated[effect].speed == null || typeof this.animated[effect].speed != "number") this.animated[effect].speed = 0;
        if (this.animated[effect].chaosFactor == null || typeof this.animated[effect].chaosFactor != "number") this.animated[effect].chaosFactor = 0.25;
        if (this.animated[effect].wantInteger == null || typeof this.animated[effect].wantInteger != "boolean") this.animated[effect].wantInteger = false;
        if (!this.anime.hasInternals(effect)) this.anime.initInternals(effect);
        this.anime.animated = this.animated;
    });
};


class $2fe05231a5671b9f$export$1545cd3bbac349ce extends PIXI.filters.AdjustmentFilter {
    constructor(params){
        super();
        this.enabled = false;
        this.gamma = 1;
        this.saturation = 1;
        this.contrast = 1;
        this.brightness = 1;
        this.red = 1;
        this.green = 1;
        this.blue = 1;
        this.alpha = 1;
        this.zOrder = 30;
        this.animating = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




class $f1f93c519987627d$export$1efdcfd4cb16ac29 extends PIXI.filters.AsciiFilter {
    constructor(params){
        super();
        this.size = 8;
        this.zOrder = 310;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




class $4d02ab9fc92d64ef$export$e7bbc116d34f17bc extends PIXI.filters.AdvancedBloomFilter {
    constructor(params){
        super();
        this.enabled = false;
        this.threshold = 0.5;
        this.bloomScale = 1.0;
        this.brightness = 1.0;
        this.blur = 4.0;
        this.quality = 4.0;
        this.zOrder = 40;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




class $a0121c7d42a6541e$export$d75528d01a211954 extends PIXI.filters.DotFilter {
    constructor(params){
        super();
        this.scale = 1;
        this.angle = 5;
        this.grayscale = true;
        this.zOrder = 330;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}





class $463c3c68cacec30e$export$2d59c37be5e749a7 extends PIXI.filters.DisplacementFilter {
    constructor(params){
        // Loading distortion sprite
        var displacementSpriteMask;
        var spriteMaskPath;
        spriteMaskPath = params.hasOwnProperty("maskPath") ? (0, $97b1237a45b106ea$export$3bebb302ab08af33)(params.maskPath) : "modules/tokenmagic/fx/assets/distortion-1.png";
        displacementSpriteMask = PIXI.Sprite.from(spriteMaskPath);
        super(displacementSpriteMask);
        // Configuring distortion sprite
        this.sprite = displacementSpriteMask;
        this.wrapMode = PIXI.WRAP_MODES.REPEAT;
        this.position = new PIXI.Point();
        this.skew = new PIXI.Point();
        this.pivot = new PIXI.Point();
        this.anchorSet = 0.5;
        this.transition = null;
        this.padding = 15; // conf
        this.enabled = false;
        this.maskSpriteX = 0;
        this.maskSpriteY = 0;
        this.maskSpriteScaleX = 4;
        this.maskSpriteScaleY = 4;
        this.maskSpriteSkewX = 0;
        this.maskSpriteSkewY = 0;
        this.maskSpriteRotation = 0;
        this.zOrder = 4000;
        this.sticky = true;
        this.animated = {};
        this.setTMParams(params);
        this.maskPath = spriteMaskPath;
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
            this.sprite.anchor.set(this.anchorSet);
            this.sprite.texture.baseTexture.wrapMode = this.wrapMode;
        }
    }
    set maskSpriteX(value) {
        this.position.x = value;
    }
    set maskSpriteY(value) {
        this.position.y = value;
    }
    get maskSpriteX() {
        return this.position.x;
    }
    get maskSpriteY() {
        return this.position.y;
    }
    set maskSpriteScaleX(value) {
        this.scale.x = value;
    }
    set maskSpriteScaleY(value) {
        this.scale.y = value;
    }
    get maskSpriteScaleX() {
        return this.scale.x;
    }
    get maskSpriteScaleY() {
        return this.scale.y;
    }
    set maskSpriteRotation(value) {
        this.rotation = value;
    }
    get maskSpriteRotation() {
        return this.rotation;
    }
    set maskSpriteSkewX(value) {
        this.skew.x = value;
    }
    get maskSpriteSkewX() {
        return this.skew.x;
    }
    set maskSpriteSkewY(value) {
        this.skew.y = value;
    }
    get maskSpriteSkewY() {
        return this.skew.y;
    }
    set maskSpritePivotX(value) {
        this.pivot.x = value;
    }
    get maskSpritePivotX() {
        return this.pivot.x;
    }
    set maskSpritePivotY(value) {
        this.pivot.y = value;
    }
    get maskSpritePivotY() {
        return this.pivot.y;
    }
    handleTransform() {
        this.sprite.position.x = this.targetPlaceable.x + this.placeableImg.x + this.position.x;
        this.sprite.position.y = this.targetPlaceable.y + this.placeableImg.y + this.position.y;
        this.sprite.skew.x = this.skew.x;
        this.sprite.skew.x = this.skew.y;
        this.sprite.rotation = this.rotation;
        this.sprite.pivot.x = this.pivot.x;
        this.sprite.pivot.y = this.pivot.y;
        if (this.sticky) this.sprite.rotation += this.placeableImg.rotation;
        this.sprite.transform.updateTransform(canvas.stage.transform);
    }
    apply(filterManager, input, output, clear) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        this.uniforms.scale.x = this.scale.x;
        this.uniforms.scale.y = this.scale.y;
        const wt = this.maskSprite.worldTransform;
        this.uniforms.rotation[0] = wt.a;
        this.uniforms.rotation[1] = wt.b;
        this.uniforms.rotation[2] = wt.c;
        this.uniforms.rotation[3] = wt.d;
        filterManager.applyFilter(this, input, output, clear);
    }
}




class $11a39396e5d8589b$export$2094be6cc744d7bc extends PIXI.filters.OldFilmFilter {
    constructor(params){
        super();
        this.enabled = false;
        this.vignetting = 0;
        this.noise = 0.08;
        this.scratch = 0.1;
        this.scratchDensity = 0.1;
        this.seed = 0;
        this.zOrder = 60;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




class $8224c68d08cc6843$export$3ea2d657d9f1c2fe extends PIXI.filters.GlowFilter {
    constructor(params){
        super();
        this.padding = 15;
        this.enabled = false;
        this.innerStrength = 0;
        this.outerStrength = 6.5;
        this.color = 0x0020ff;
        this.quality = 1;
        this.alpha = 1;
        this.zOrder = 70;
        this.animated = {};
        this.setTMParams(params);
        // Imposed value. Should not be a shader uniform
        this.distance = 10;
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




class $5b47cd38a348aa0c$export$c04494508d798797 extends PIXI.filters.OutlineFilter {
    constructor(params){
        super();
        this.blendMode = PIXI.BLEND_MODES.NORMAL;
        this.padding = 5;
        this.enabled = false;
        this.thickness = 3;
        this.color = 0x000000;
        this.quality = 1;
        this.zOrder = 50;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




class $e609518cea3498ff$export$bcacf43f99a4009b extends PIXI.filters.BevelFilter {
    constructor(params){
        super();
        this.blendMode = PIXI.BLEND_MODES.NORMAL;
        this.padding = 10;
        this.enabled = false;
        this.rotation = 0;
        this.thickness = 5;
        this.lightColor = 0xffffff;
        this.lightAlpha = 0.95;
        this.shadowColor = 0x000000;
        this.shadowAlpha = 0.95;
        this.zOrder = 90;
        this.quality = 1;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




const $44fa44dcb802915a$var$_tempRect = new PIXI.Rectangle();
class $44fa44dcb802915a$export$c042bd0ff4d3251b extends PIXI.Filter {
    constructor(...args){
        super(...args);
        if (!this.uniforms.filterMatrix || !this.uniforms.filterMatrixInverse) this.uniforms.filterMatrix = new PIXI.Matrix();
        if (!this.uniforms.filterMatrixInverse) this.uniforms.filterMatrixInverse = new PIXI.Matrix();
    }
    apply(filterManager, input, output, clear) {
        const filterMatrix = this.uniforms.filterMatrix;
        if (filterMatrix) {
            const { sourceFrame: sourceFrame, destinationFrame: destinationFrame, target: target } = filterManager.activeState;
            filterMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y);
            const worldTransform = PIXI.Matrix.TEMP_MATRIX;
            const localBounds = target.getLocalBounds($44fa44dcb802915a$var$_tempRect);
            if (this.sticky) {
                worldTransform.copyFrom(target.transform.worldTransform);
                worldTransform.invert();
                const rotation = target.transform.rotation;
                const sin = Math.sin(rotation);
                const cos = Math.cos(rotation);
                const scaleX = Math.hypot(cos * worldTransform.a + sin * worldTransform.c, cos * worldTransform.b + sin * worldTransform.d);
                const scaleY = Math.hypot(-sin * worldTransform.a + cos * worldTransform.c, -sin * worldTransform.b + cos * worldTransform.d);
                localBounds.pad(scaleX * this.boundsPadding.x, scaleY * this.boundsPadding.y);
            } else {
                const transform = target.transform;
                worldTransform.a = transform.scale.x;
                worldTransform.b = 0;
                worldTransform.c = 0;
                worldTransform.d = transform.scale.y;
                worldTransform.tx = transform.position.x - transform.pivot.x * transform.scale.x;
                worldTransform.ty = transform.position.y - transform.pivot.y * transform.scale.y;
                worldTransform.prepend(target.parent.transform.worldTransform);
                worldTransform.invert();
                const scaleX = Math.hypot(worldTransform.a, worldTransform.b);
                const scaleY = Math.hypot(worldTransform.c, worldTransform.d);
                localBounds.pad(scaleX * this.boundsPadding.x, scaleY * this.boundsPadding.y);
            }
            filterMatrix.prepend(worldTransform);
            filterMatrix.translate(-localBounds.x, -localBounds.y);
            filterMatrix.scale(1.0 / localBounds.width, 1.0 / localBounds.height);
            const filterMatrixInverse = this.uniforms.filterMatrixInverse;
            if (filterMatrixInverse) {
                filterMatrixInverse.copyFrom(filterMatrix);
                filterMatrixInverse.invert();
            }
        }
        filterManager.applyFilter(this, input, output, clear);
    }
}


const $af3e207060dec559$export$93b7586d956c930e = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float alpha;
uniform vec3 color;

uniform vec2 shift;
uniform vec4 inputSize;

void main(void){
    vec4 sample = texture2D(uSampler, vTextureCoord - shift * inputSize.zw);

    // Premultiply alpha
    sample.rgb = color.rgb * sample.a;

    // alpha user alpha
    sample *= alpha;

    gl_FragColor = sample;
}
`;


// Custom vertex shader with filterLocalCoord()
const $15c633ba44c21f75$export$c6eb01d07cc2e1e8 = `
precision mediump float;

attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;
uniform vec4 inputSize;
uniform vec4 outputFrame;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0., 1.);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
    vFilterCoord = (filterMatrix * vec3(vTextureCoord, 1.0)).xy;
}
`;



class $23cf46a81404e9ef$export$f371526a665ed48 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    shadowOnly;
    angle = 45;
    _distance = 5;
    _resolution = PIXI.settings.FILTER_RESOLUTION;
    _tintFilter;
    _blurFilter;
    constructor(options = {}){
        super();
        const opt = options ? {
            ...$23cf46a81404e9ef$export$f371526a665ed48.defaults,
            ...options
        } : $23cf46a81404e9ef$export$f371526a665ed48.defaults;
        const { kernels: kernels, blur: blur, quality: quality, resolution: resolution } = opt;
        this._tintFilter = new PIXI.Filter((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $af3e207060dec559$export$93b7586d956c930e));
        this._tintFilter.uniforms.color = new Float32Array(4);
        this._tintFilter.uniforms.shift = new PIXI.Point();
        this._tintFilter.resolution = resolution;
        this._blurFilter = kernels ? new PIXI.filters.KawaseBlurFilter(kernels) : new PIXI.filters.KawaseBlurFilter(blur, quality);
        this._pixelSize = 1.0;
        this.resolution = resolution;
        const { shadowOnly: shadowOnly, rotation: rotation, distance: distance, alpha: alpha, color: color } = opt;
        this.shadowOnly = shadowOnly;
        this.rotation = rotation;
        this.distance = distance;
        this.alpha = alpha;
        this.color = color;
    }
    apply(filterManager, input, output, clear) {
        this._updateShiftAndScale();
        const target = filterManager.getFilterTexture();
        this._tintFilter.apply(filterManager, input, target, 1);
        this._blurFilter.apply(filterManager, target, output, clear);
        if (this.shadowOnly !== true) filterManager.applyFilter(this, input, output, 0);
        filterManager.returnFilterTexture(target);
    }
    _updateShiftAndScale() {
        const scale = this.targetPlaceable?.worldTransform.a ?? 1.0;
        this._tintFilter.uniforms.shift.set(this.distance * Math.cos(this.angle) * scale, this.distance * Math.sin(this.angle) * scale);
        this._pixelSize = Math.max(1.0, 1.0 * scale);
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._resolution = value;
        if (this._tintFilter) this._tintFilter.resolution = value;
        if (this._blurFilter) this._blurFilter.resolution = value;
    }
    get distance() {
        return this._distance;
    }
    set distance(value) {
        this._distance = value;
    }
    get rotation() {
        return this.angle / PIXI.DEG_TO_RAD;
    }
    set rotation(value) {
        this.angle = value * PIXI.DEG_TO_RAD;
    }
    get alpha() {
        return this._tintFilter.uniforms.alpha;
    }
    set alpha(value) {
        this._tintFilter.uniforms.alpha = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this._tintFilter.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this._tintFilter.uniforms.color);
    }
    get kernels() {
        return this._blurFilter.kernels;
    }
    set kernels(value) {
        this._blurFilter.kernels = value;
    }
    get blur() {
        return this._blurFilter.blur;
    }
    set blur(value) {
        this._blurFilter.blur = value;
    }
    get quality() {
        return this._blurFilter.quality;
    }
    set quality(value) {
        this._blurFilter.quality = value;
    }
    get _pixelSize() {
        return this._blurFilter.pixelSize;
    }
    set _pixelSize(value) {
        this._blurFilter.pixelSize = value;
    }
}
$23cf46a81404e9ef$export$f371526a665ed48.defaults = {
    rotation: 45,
    distance: 5,
    color: 0x000000,
    alpha: 0.5,
    shadowOnly: false,
    kernels: null,
    blur: 2,
    quality: 3,
    resolution: PIXI.settings.FILTER_RESOLUTION
};


class $5ba7aae303e84dac$export$3fa21fd22495d321 extends (0, $23cf46a81404e9ef$export$f371526a665ed48) {
    constructor(params){
        super();
        this.enabled = false;
        this.rotation = 45;
        this.distance = 5;
        this.color = 0x000000;
        this.alpha = 0.5;
        this.shadowOnly = false;
        this.blur = 2;
        this.quality = 3;
        this.padding = 10;
        this.zOrder = 110;
        this.animated = {};
        this.resolution = game.settings.get("core", "pixelRatioResolutionScaling") ? window.devicePixelRatio : PIXI.settings.FILTER_RESOLUTION;
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
        this.autoFit = false;
    }
}




class $0643f21646f7ec8f$export$f4e603bceef0312b extends PIXI.filters.TwistFilter {
    constructor(params){
        super();
        this.enabled = false;
        this.radiusPercent = 50;
        this.angle = 4;
        this.zOrder = 240;
        this.animated = {};
        this.offset = [
            0,
            0
        ];
        this.autoFit = false;
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    handleTransform() {
        this.offset[0] = this.placeableImg.worldTransform.tx;
        this.offset[1] = this.placeableImg.worldTransform.ty;
        this.radius = Math.max(this.placeableImg.width, this.placeableImg.height) * this.targetPlaceable.worldTransform.a * this.radiusPercent / 200;
    }
}




class $cb3547a2fc8518c6$export$767afdf6d9357594 extends PIXI.filters.ZoomBlurFilter {
    constructor(params){
        super();
        this.enabled = false;
        this.strength = 0.1;
        this.radiusPercent = 50;
        this.innerRadiusPercent = 10;
        this.zOrder = 300;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    handleTransform(state) {
        this.center[0] = 0.5 * state.sourceFrame.width;
        this.center[1] = 0.5 * state.sourceFrame.height;
        this.radius = Math.max(this.placeableImg.width, this.placeableImg.height) * this.targetPlaceable.worldTransform.a * this.radiusPercent / 200;
        this.innerRadius = Math.max(this.placeableImg.width, this.placeableImg.height) * this.targetPlaceable.worldTransform.a * this.innerRadiusPercent / 200;
    }
}





class $c669851898d451b5$export$680aca7df3d87905 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    blurXFilter;
    blurYFilter;
    _repeatEdgePixels;
    constructor(strength = 8, quality = 4, resolution = PIXI.settings.FILTER_RESOLUTION, kernelSize = 5){
        super();
        this.blurXFilter = new $c669851898d451b5$export$7c9ef492c949f871(true, strength, quality, resolution, kernelSize);
        this.blurYFilter = new $c669851898d451b5$export$7c9ef492c949f871(false, strength, quality, resolution, kernelSize);
        this.resolution = resolution;
        this.quality = quality;
        this.blur = strength;
        this.repeatEdgePixels = false;
    }
    apply(filterManager, input, output, clearMode) {
        const xStrength = Math.abs(this.blurXFilter.strength);
        const yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            const renderTarget = filterManager.getFilterTexture();
            this.blurXFilter.apply(filterManager, input, renderTarget, PIXI.CLEAR_MODES.CLEAR);
            this.blurYFilter.apply(filterManager, renderTarget, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        } else if (yStrength) this.blurYFilter.apply(filterManager, input, output, clearMode);
        else this.blurXFilter.apply(filterManager, input, output, clearMode);
    }
    updatePadding() {
        if (this._repeatEdgePixels) this.padding = 0;
        else this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
    }
    get blur() {
        return this.blurXFilter.blur;
    }
    set blur(value) {
        this.blurXFilter.blur = this.blurYFilter.blur = value;
        this.updatePadding();
    }
    get quality() {
        return this.blurXFilter.quality;
    }
    set quality(value) {
        this.blurXFilter.quality = this.blurYFilter.quality = value;
    }
    get blurX() {
        return this.blurXFilter.blur;
    }
    set blurX(value) {
        this.blurXFilter.blur = value;
        this.updatePadding();
    }
    get blurY() {
        return this.blurYFilter.blur;
    }
    set blurY(value) {
        this.blurYFilter.blur = value;
        this.updatePadding();
    }
    get blendMode() {
        return this.blurYFilter.blendMode;
    }
    set blendMode(value) {
        this.blurYFilter.blendMode = value;
    }
    get repeatEdgePixels() {
        return this._repeatEdgePixels;
    }
    set repeatEdgePixels(value) {
        this._repeatEdgePixels = value;
        this.updatePadding();
    }
}
class $c669851898d451b5$export$7c9ef492c949f871 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    horizontal;
    strength;
    passes;
    _quality;
    constructor(horizontal, strength = 8, quality = 4, resolution = PIXI.settings.FILTER_RESOLUTION, kernelSize = 5){
        const vertSrc = $c669851898d451b5$export$7a7fb9d9d09c33af(kernelSize, horizontal);
        const fragSrc = $c669851898d451b5$export$1b0dcf101eb6a1c9(kernelSize);
        super(// vertex shader
        vertSrc, // fragment shader
        fragSrc);
        this.horizontal = horizontal;
        this.resolution = resolution;
        this._quality = 0;
        this.quality = quality;
        this.blur = strength;
    }
    apply(filterManager, input, output, clearMode) {
        if (output) {
            if (this.horizontal) this.uniforms.strength = 1 / output.width * (output.width / input.width);
            else this.uniforms.strength = 1 / output.height * (output.height / input.height);
        } else if (this.horizontal) this.uniforms.strength = 1 / filterManager.renderer.width * (filterManager.renderer.width / input.width);
        else this.uniforms.strength = 1 / filterManager.renderer.height * (filterManager.renderer.height / input.height);
        // screen space!
        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes;
        if (this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            const renderTarget = filterManager.getFilterTexture();
            const renderer = filterManager.renderer;
            let flip = input;
            let flop = renderTarget;
            this.state.blend = false;
            filterManager.applyFilter(this, flip, flop, PIXI.CLEAR_MODES.CLEAR);
            for(let i = 1; i < this.passes - 1; i++){
                filterManager.bindAndClear(flip, PIXI.CLEAR_MODES.BLIT);
                this.uniforms.uSampler = flop;
                const temp = flop;
                flop = flip;
                flip = temp;
                renderer.shader.bind(this);
                renderer.geometry.draw(5);
            }
            this.state.blend = true;
            filterManager.applyFilter(this, flop, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        }
    }
    get blur() {
        return this.strength;
    }
    set blur(value) {
        this.padding = 1 + Math.abs(value) * 2;
        this.strength = value;
    }
    get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value;
        this.passes = value;
    }
}
const $c669851898d451b5$var$GAUSSIAN_VALUES = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        0.0093,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        0.002406,
        0.009255,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        0.000489,
        0.002403,
        0.009246,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
};
const $c669851898d451b5$var$fragTemplate = [
    "varying vec2 vBlurTexCoords[%size%];",
    "uniform sampler2D uSampler;",
    "void main(void)",
    "{",
    "    gl_FragColor = vec4(0.0);",
    "    %blur%",
    "}"
].join("\n");
function $c669851898d451b5$export$1b0dcf101eb6a1c9(kernelSize) {
    const kernel = $c669851898d451b5$var$GAUSSIAN_VALUES[kernelSize];
    const halfLength = kernel.length;
    let fragSource = $c669851898d451b5$var$fragTemplate;
    let blurLoop = "";
    const template = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;";
    let value;
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        value = i;
        if (i >= halfLength) value = kernelSize - i - 1;
        blur = blur.replace("%value%", kernel[value].toString());
        blurLoop += blur;
        blurLoop += "\n";
    }
    fragSource = fragSource.replace("%blur%", blurLoop);
    fragSource = fragSource.replace("%size%", kernelSize.toString());
    return fragSource;
}
const $c669851898d451b5$var$vertTemplate = `
    attribute vec2 aVertexPosition;
    uniform mat3 projectionMatrix;
    uniform float strength;
    varying vec2 vBlurTexCoords[%size%];
    uniform vec4 inputSize;
    uniform vec4 outputFrame;
    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;
        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }
    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }
    void main(void)
    {
        gl_Position = filterVertexPosition();
        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function $c669851898d451b5$export$7a7fb9d9d09c33af(kernelSize, x) {
    const halfLength = Math.ceil(kernelSize / 2);
    let vertSource = $c669851898d451b5$var$vertTemplate;
    let blurLoop = "";
    let template;
    if (x) template = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);";
    else template = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        blur = blur.replace("%sampleIndex%", `${i - (halfLength - 1)}.0`);
        blurLoop += blur;
        blurLoop += "\n";
    }
    vertSource = vertSource.replace("%blur%", blurLoop);
    vertSource = vertSource.replace("%size%", kernelSize.toString());
    return vertSource;
}
function $c669851898d451b5$export$5a54b7935b71e7fb(gl) {
    const maxVaryings = PIXI.gl.getParameter(PIXI.gl.MAX_VARYING_VECTORS);
    let kernelSize = 15;
    while(kernelSize > maxVaryings)kernelSize -= 2;
    return kernelSize;
}


class $b8712d076a565747$export$efc74ab3983784c5 extends (0, $c669851898d451b5$export$680aca7df3d87905) {
    constructor(params){
        super();
        this.enabled = false;
        this.blur = 2;
        this.quality = 4;
        this.zOrder = 290;
        this.repeatEdgePixels = false;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get blur() {
        return this.strengthX;
    }
    set blur(value) {
        this.strengthX = this.strengthY = value;
    }
    get blurX() {
        return this.strengthX;
    }
    set blurX(value) {
        this.strengthX = value;
    }
    get blurY() {
        return this.strengthY;
    }
    set blurY(value) {
        this.strengthY = value;
    }
    calculatePadding() {
        const scale = this.targetPlaceable.worldTransform.a;
        this.blurXFilter.blur = scale * this.strengthX;
        this.blurYFilter.blur = scale * this.strengthY;
        this.updatePadding();
        super.calculatePadding();
    }
}




class $207c96b47058a247$export$985076e41ccfd508 extends PIXI.filters.ShockwaveFilter {
    constructor(params){
        super();
        this.enabled = false;
        this.time = 0;
        this.amplitude = 5;
        this.wavelength = 100;
        this.speed = 50.0;
        this.brightness = 1.5;
        this.radius = 200;
        this.zOrder = 220;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    handleTransform(state) {
        this.center[0] = 0.5 * state.sourceFrame.width;
        this.center[1] = 0.5 * state.sourceFrame.height;
    }
}




class $cde275935cddb40a$export$c1f4d37fd591fb01 extends PIXI.filters.BulgePinchFilter {
    constructor(params){
        super();
        this.strength = 0;
        this.radiusPercent = 100;
        this.zOrder = 140;
        this.autoFit = false;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
        // Anchor point
        this.center = [
            0.5,
            0.5
        ];
    }
    handleTransform() {
        this.radius = Math.max(this.placeableImg.width, this.placeableImg.height) * this.targetPlaceable.worldTransform.a * this.radiusPercent / 200;
    }
}


const $95883fdd65c72900$export$1cb17df05ce7da23 = `
precision mediump float;
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float alphaTolerance;

void main(void) {
    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a <= alphaTolerance) {
        pixel = vec4(0.);
    } 
    gl_FragColor = pixel;
}
`;





class $d6a2679398073147$export$228231731d6adde3 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { alphaTolerance: alphaTolerance } = Object.assign({}, $d6a2679398073147$export$228231731d6adde3.defaults, params);
        // using the default vertex shader and the specific fragment shader
        super(undefined, (0, $95883fdd65c72900$export$1cb17df05ce7da23));
        Object.assign(this, {
            alphaTolerance: alphaTolerance
        });
        this.zOrder = 10;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get alphaTolerance() {
        return this.uniforms.alphaTolerance;
    }
    set alphaTolerance(value) {
        this.uniforms.alphaTolerance = value;
    }
}
$d6a2679398073147$export$228231731d6adde3.defaults = {
    alphaTolerance: 0.8
};


const $bede2880f372c574$export$9d94b322741e1813 = `
precision mediump float;
precision mediump int;

uniform sampler2D uSampler;
uniform float time;
uniform vec2 dimensions;
uniform vec2 anchor;
uniform vec4 color;
uniform float divisor;
uniform bool alphaDiscard;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

float PI = 3.14159265359;
float speed = 1.2;
float width = 0.5;
float subdivide = 512.0;

void main() {

    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a==0.) {
       gl_FragColor = pixel;
       return;
    }

    vec2 uv = (vFilterCoord - anchor) / dimensions;    
    float len = length(uv *0.5),
   		angle = ( atan(uv.x, uv.y) / ( 2. * PI) ) + 1.5,
    	wobble = 48. + 24. * cos(time/5.),
    	white = fract((angle) * divisor + sin((sqrt(len) * wobble) - time * speed));
    
    white  = 2.* cos(white / (PI * 0.1));
    white *= floor(fract(angle * divisor + sin(time / speed - (len * 1.2) * wobble)) *subdivide) / subdivide;
    
    vec4 color1 = smoothstep(0., 1., white * color);
    vec4 result = mix(pixel, color1, color1.a);
    if (alphaDiscard && all(lessThanEqual(result.rgb,vec3(0.05)))) discard;
    gl_FragColor = result*pixel.a;
}
`;






class $56e6cd37bbebe026$export$1992e0dceaf7be8 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, divisor: divisor, alpha: alpha, anchorX: anchorX, anchorY: anchorY, dimX: dimX, dimY: dimY, alphaDiscard: alphaDiscard } = Object.assign({}, $56e6cd37bbebe026$export$1992e0dceaf7be8.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $bede2880f372c574$export$9d94b322741e1813));
        this.uniforms.color = new Float32Array([
            1.0,
            0.4,
            0.1,
            0.55
        ]);
        this.uniforms.anchor = new Float32Array([
            0.5,
            0.5
        ]);
        this.uniforms.dimensions = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            divisor: divisor,
            alpha: alpha,
            anchorX: anchorX,
            anchorY: anchorY,
            dimX: dimX,
            dimY: dimY,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 120;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get divisor() {
        return this.uniforms.divisor;
    }
    set divisor(value) {
        this.uniforms.divisor = value;
    }
    get alpha() {
        return this.uniforms.color[3];
    }
    set alpha(value) {
        if (value >= 0 && value <= 1) this.uniforms.color[3] = value;
    }
    get anchorX() {
        return this.uniforms.anchor[0];
    }
    set anchorX(value) {
        this.uniforms.anchor[0] = value;
    }
    get anchorY() {
        return this.uniforms.anchor[1];
    }
    set anchorY(value) {
        this.uniforms.anchor[1] = value;
    }
    get dimX() {
        return this.uniforms.dimensions[0];
    }
    set dimX(value) {
        this.uniforms.dimensions[0] = value;
    }
    get dimY() {
        return this.uniforms.dimensions[1];
    }
    set dimY(value) {
        this.uniforms.dimensions[1] = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
}
$56e6cd37bbebe026$export$1992e0dceaf7be8.defaults = {
    time: 0.0,
    color: 0xff8010,
    divisor: 16,
    alpha: 0.55,
    anchorX: 0.5,
    anchorY: 0.5,
    dimX: 100,
    dimY: 100,
    alphaDiscard: false
};


const $18eb4ad38bd7a0da$export$cfdade87b894d58e = `
precision mediump float;

uniform float time;
uniform vec3 color;
uniform float density;
uniform vec2 dimensions;
uniform sampler2D uSampler;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

// generates pseudo-random based on screen position
float random(vec2 pos) 
{
	return fract(sin(dot(pos.xy, vec2(12.9898, 78.233))) * 43758.5453123);
}

// perlin noise
float noise(vec2 pos) 
{
	vec2 i = floor(pos);
	vec2 f = fract(pos);
	float a = random(i + vec2(0.0, 0.0));
	float b = random(i + vec2(1.0, 0.0));
	float c = random(i + vec2(0.0, 1.0));
	float d = random(i + vec2(1.0, 1.0));
	vec2 u = f * f * (3.0 - 2.0 * f);
	return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

// fractional brownian motion
float fbm(vec2 pos) 
{
	float v = 0.0;
	float a = 0.5;
	vec2 shift = vec2(100.);
	mat2 rot = mat2(cos(0.5), sin(0.5), -sin(0.5), cos(0.5));
	for (int i=0; i<16; i++) 
	{
		v = (sin(v*1.07)) + ( a * noise(pos) );
		pos = rot * pos * 1.9 + shift;
		a *= 0.5;
	}
	return v;
}

mat4 contrastMatrix(float contrast)
{
	float t = ( 1.0 - contrast ) * 0.5;
    
    return mat4( contrast, 0, 0, 0,
                 0, contrast, 0, 0,
                 0, 0, contrast, 0,
                 t, t, t, 1 );
}

vec4 fog()
{
	vec2 p = (vFilterCoord.xy * 8. - vFilterCoord.xy) * dimensions;
	
	float time2 = time * 0.0025;
	
	vec2 q = vec2(0.0);
	q.x = fbm(p);
	q.y = fbm(p);
	vec2 r = vec2(-1.0);
	r.x = fbm(p * q + vec2(1.7, 9.2) + .15 * time2);
	r.y = fbm(p * q + vec2(9.3, 2.8) + .35 * time2);
	float f = fbm(p*.2 + r*3.102);

	vec4 fogPixel = mix(
		vec4(color,1.0),
		vec4(1.5, 1.5, 1.5, 1.5),
		clamp(length(r.x), 0.4, 1.)
	);

	return (f *f * f + 0.6 * f * f + 0.5 * f) * fogPixel;
}

void main(void) 
{
    vec4 pixel = texture2D(uSampler, vTextureCoord);

    // to avoid computation on an invisible pixel.
    if (pixel.a == 0.) {
		gl_FragColor = pixel;
		return;
    }

	vec4 fogPixel = contrastMatrix(3.0)*fog();
    gl_FragColor = mix(pixel, fogPixel, 1.*density) * pixel.a;
}
`;





class $2a5c150fd96450c6$export$f17580ed76af4408 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, density: density, dimX: dimX, dimY: dimY } = Object.assign({}, $2a5c150fd96450c6$export$f17580ed76af4408.defaults, params);
        // specific vertex and fragment shaders
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $18eb4ad38bd7a0da$export$cfdade87b894d58e));
        this.uniforms.color = new Float32Array([
            1.0,
            0.4,
            0.1,
            0.55
        ]);
        this.uniforms.dimensions = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            density: density,
            dimX: dimX,
            dimY: dimY
        });
        this.zOrder = 190;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get density() {
        return this.uniforms.density;
    }
    set density(value) {
        this.uniforms.density = value;
    }
    get dimX() {
        return this.uniforms.dimensions[0];
    }
    set dimX(value) {
        this.uniforms.dimensions[0] = value;
    }
    get dimY() {
        return this.uniforms.dimensions[1];
    }
    set dimY(value) {
        this.uniforms.dimensions[1] = value;
    }
}
$2a5c150fd96450c6$export$f17580ed76af4408.defaults = {
    time: 0.0,
    color: 0xffffff,
    density: 0.5,
    dimX: 1.0,
    dimY: 1.0
};


const $0ce59d28206e7914$export$562c6f8151c36426 = `
precision mediump float;

uniform float time;
uniform vec3 color;
uniform bool alphaDiscard;
uniform sampler2D uSampler;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

const float PI = 3.14159265;
const mat3 rotationMatrix = mat3(1.0,0.0,0.0,0.0,0.47,-0.88,0.0,0.88,0.47);
	
float hash(float p)
{
    return fract(sin(dot(vec2(p*0.00010,0.),vec2(12.9898,78.233))) * 43758.5453);
}

float noise( vec3 x )
{
    vec3 p = floor(x);
    vec3 f = fract(x);
    f = f*f*(3.0-2.0*f);
    float n = p.x + p.y*57.0 + 113.0*p.z;
    return mix(mix(mix( hash(n+0.0  ), hash(n+1.0),f.x),mix( hash(n+57.0 ), hash(n+58.0 ),f.x),f.y),
           mix(mix( hash(n+113.0), hash(n+114.0),f.x),mix( hash(n+170.0), hash(n+171.0),f.x),f.y),f.z);
} 

vec4 map( vec3 p )
{
	float d = 0.2 - p.y;	
	vec3 q = p  - vec3(0.0,1.0,0.0)*time;
	float f  = 0.5*noise( q ); q = q*2.02 - vec3(0.25,0.25,0.25)*time*0.4;
	f += 0.25*noise( q ); 
    q = q*2.03 - vec3(0.0,1.0,0.0)*time*0.2;
	f += 0.125*noise( q ); 
	d = clamp( d + 4.5*f, 0.0, 1.0 );
	vec3 col = mix( vec3(0.9,0.9,0.9), vec3(0.1,0.1,0.1), d ) + 0.05*sin(p);
	return vec4( col, d );
}

vec3 cloudify( vec3 ro, vec3 rd )
{
	vec4 s = vec4(0.);
	float t = 0.0;
    vec3 col = color*0.75;
    vec3 p;
    vec4 k;

	for( int i=0; i<90; i++ )
	{
		if( s.a > 0.97 ) break;
		p = ro + t*rd;
		k = map( p );
		k.rgb *= mix( col, color, clamp( (p.y-0.2)*0.5, 0.0, 1.0 ) );
		k.a *= 0.5;
		k.rgb *= k.a;
		s = s + k*(1.0-s.a);	
		t += 0.05;
	}
	return clamp( s.xyz, 0.0, 1.0 );
}

vec4 xfog()
{
	vec3 vo = vec3(0.0,4.9,-40.);
	vec3 vd = normalize(vec3(vFilterCoord.xy, 1.)) * rotationMatrix * 2.25;
	vec3 volume = cloudify( vo, vd );
	volume *= volume;
	return vec4( volume, 1.0 );
}

void main() 
{
    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a == 0.) discard;
    vec4 result = max( xfog(), pixel) * pixel.a;
    if (alphaDiscard && all(lessThanEqual(result.rgb,vec3(0.15)))) discard;
    gl_FragColor = result;
}
`;





class $6ca08fc9db20c2ac$export$da3eec8748131849 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, alphaDiscard: alphaDiscard } = Object.assign({}, $6ca08fc9db20c2ac$export$da3eec8748131849.defaults, params);
        // specific vertex and fragment shaders
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $0ce59d28206e7914$export$562c6f8151c36426));
        this.uniforms.color = new Float32Array([
            1.0,
            0.4,
            0.1,
            0.55
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 230;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
}
$6ca08fc9db20c2ac$export$da3eec8748131849.defaults = {
    time: 0.0,
    color: 0xffffff,
    alphaDiscard: false
};


const $9d3851927d6e6827$export$196e9e3d20e4131 = `
precision mediump float;
precision mediump int;

#define INTENSITY 5

const float PI = 3.14159265358979323846264;

uniform sampler2D uSampler;
uniform vec4 color;
varying vec2 vFilterCoord;
varying vec2 vTextureCoord;
uniform float time;
uniform int blend;

vec4 blenderVec3(int blend, vec4 fColv4, vec4 sColv4)
{
    vec3 fCol = vec3(fColv4);
    vec3 sCol = vec3(sColv4);
    if ( blend == 1) { fCol = fCol * sCol; }
    else if (blend == 2) { fCol = (1. - (1. - fCol) * (1. - sCol)); }
    else if (blend == 3) { fCol = min(fCol, sCol); }
    else if (blend == 4) { fCol = max(fCol, sCol); }
    else if (blend == 5) { fCol = abs(fCol - sCol); }
    else if (blend == 6) { fCol = 1. - abs(1. - fCol - sCol); }
    else if (blend == 7) { fCol = fCol + sCol - (2. * fCol * sCol); }
    else if (blend == 8) { fCol = all(lessThanEqual(fCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 9) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 10) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol + fCol * fCol * (1. - 2. * sCol)) : sqrt(fCol) * (2. * sCol - 1.) + (2. * fCol) * (1. - sCol); }
    else if (blend == 11) { fCol = fCol / (1.0 - sCol); }
    else if (blend == 12) { fCol = 1.0 - (1.0 - fCol) / sCol; }
    else if (blend == 13) { fCol = fCol + sCol; }
    else { fCol = fCol + sCol; }
    
    return vec4(fCol,1.0);
}

float Perlin(vec3 P)
{
    vec3 Pi = floor(P);
    vec3 Pf = P - Pi;
    vec3 Pf_min1 = Pf - 1.0;

    Pi.xyz = Pi.xyz - floor(Pi.xyz * (1.0 / 69.0)) * 69.0;
    vec3 Pi_inc1 = step(Pi, vec3(69.0 - 1.5)) * (Pi + 1.0);

    vec4 Pt = vec4(Pi.xy, Pi_inc1.xy) + vec2(50.0, 161.0).xyxy;
    Pt *= Pt;
    Pt = Pt.xzxz * Pt.yyww;
    const vec3 SOMELARGEFLOATS = vec3(635.298681, 682.357502, 668.926525);
    const vec3 ZINC = vec3(48.500388, 65.294118, 63.934599);
    vec3 lowz_mod = vec3(1.0 / (SOMELARGEFLOATS + Pi.zzz * ZINC));
    vec3 highz_mod = vec3(1.0 / (SOMELARGEFLOATS + Pi_inc1.zzz * ZINC));
    vec4 hashx0 = fract(Pt * lowz_mod.xxxx);
    vec4 hashx1 = fract(Pt * highz_mod.xxxx);
    vec4 hashy0 = fract(Pt * lowz_mod.yyyy);
    vec4 hashy1 = fract(Pt * highz_mod.yyyy);
    vec4 hashz0 = fract(Pt * lowz_mod.zzzz);
    vec4 hashz1 = fract(Pt * highz_mod.zzzz);

    vec4 grad_x0 = hashx0 - 0.49999;
    vec4 grad_y0 = hashy0 - 0.49999;
    vec4 grad_z0 = hashz0 - 0.49999;
    vec4 grad_x1 = hashx1 - 0.49999;
    vec4 grad_y1 = hashy1 - 0.49999;
    vec4 grad_z1 = hashz1 - 0.49999;
    vec4 grad_results_0 = inversesqrt(grad_x0 * grad_x0 + grad_y0 * grad_y0 + grad_z0 * grad_z0) * (vec2(Pf.x, Pf_min1.x).xyxy * grad_x0 + vec2(Pf.y, Pf_min1.y).xxyy * grad_y0 + Pf.zzzz * grad_z0);
    vec4 grad_results_1 = inversesqrt(grad_x1 * grad_x1 + grad_y1 * grad_y1 + grad_z1 * grad_z1) * (vec2(Pf.x, Pf_min1.x).xyxy * grad_x1 + vec2(Pf.y, Pf_min1.y).xxyy * grad_y1 + Pf_min1.zzzz * grad_z1);

    vec3 blend = Pf * Pf * Pf * (Pf * (Pf * 6.0 - 15.0) + 10.0);
    vec4 res0 = mix(grad_results_0, grad_results_1, blend.z);
    vec4 blend2 = vec4(blend.xy, vec2(1.0 - blend.xy));
    float final = dot(res0, blend2.zxzx * blend2.wwyy);
    return (final * 1.1547005383792515290182975610039);  // scale things to a strict -1.0->1.0 range  *= 1.0/sqrt(0.75)
}

float fbm(vec3 p)
{
    float v = 0.0;
    v += Perlin(p * 0.9) * 1.5 * cos(PI * time * 0.48);
    v += Perlin(p * 3.99) * 0.5 * sin(PI * time * 0.4);
    v += Perlin(p * 8.01) * 0.4 * cos(PI * time * 0.4);
    v += Perlin(p * 15.05) * 0.05 * sin(PI * time * 0.8);

    return v;
}

vec4 electric() {
    vec3 noiseVec = vec3(vFilterCoord, 1.);
    vec3 color = vec3(0.0);
    for (int i = 0; i < INTENSITY; ++i ) {
        noiseVec = noiseVec.yxz;
        float t = abs(2.0 / (fbm(noiseVec + vec3(0.0, time / float(i + 4), 0.0)) * 120.0));
        color += t * vec3(float(i + 1) * 0.1 + 0.1, 0.5, 2.0);
    }
    return vec4(color, 1.);
}

void main() {
 
    vec4 pixel = texture2D(uSampler, vTextureCoord);
    
    // to avoid computation of invisible pixels
    if (pixel.a==0.) {
       gl_FragColor = pixel;
       return;
    }
    
    vec4 electric = electric();
    electric *= color;

    gl_FragColor = blenderVec3(blend,pixel,electric)*pixel.a;
}
`;






class $5a0c0cac6edacb2c$export$22f86bc7a100befc extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, blend: blend, color: color } = Object.assign({}, $5a0c0cac6edacb2c$export$22f86bc7a100befc.defaults, params);
        var shaderFragment;
        if (params.hasOwnProperty("intensity") && typeof params.intensity === "number") {
            var intensityVal = Math.floor(params.intensity);
            shaderFragment = (0, $9d3851927d6e6827$export$196e9e3d20e4131).replace("#define INTENSITY 5", "#define INTENSITY " + intensityVal);
        } else shaderFragment = (0, $9d3851927d6e6827$export$196e9e3d20e4131);
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), shaderFragment);
        this.uniforms.color = new Float32Array([
            1.0,
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.blend = 2;
        Object.assign(this, {
            time: time,
            blend: blend,
            color: color
        });
        this.zOrder = 160;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
        this.quality = 0.5;
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
}
$5a0c0cac6edacb2c$export$22f86bc7a100befc.defaults = {
    time: 0.0,
    blend: 1,
    color: 0xffffff
};


const $79b15a82cea589ba$export$9f7639465b88ec7f = `
precision mediump float;
precision mediump int;

uniform vec3 color;
uniform vec2 anchor;
uniform float time;
uniform bool inward;
uniform float frequency;
uniform float strength;
uniform float minIntensity;
uniform float maxIntensity;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;
uniform sampler2D uSampler;

void main() {

    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a==0.) {
       gl_FragColor = pixel;
       return;
    }

    float speed = inward ? 1.0 : -1.0;

    vec2 centeredUVs = vFilterCoord - anchor;
    float dist = length(centeredUVs);
    float sinVal = sin((time * speed) + (dist * frequency));
    
    float sinValNormalized = sinVal * 0.5 + 0.5;
    float lerp = ((maxIntensity - minIntensity) * sinValNormalized) + minIntensity;
    
    float rotationAmount = strength * sinVal;

    float sinX = sin ( rotationAmount );
    float cosX = cos ( rotationAmount );
    mat2 rotationMatrix = mat2( cosX, -sinX, sinX, cosX);
    vec2 newTextureCoord = vTextureCoord - vec2(0.5,0.5);

    newTextureCoord = vec2(newTextureCoord * rotationMatrix ); 
    newTextureCoord = newTextureCoord + vec2(0.5, 0.5);     
    vec4 col = texture2D(uSampler, newTextureCoord);
    
    col.rgb = col.rgb * color * lerp;
    if (col.r != 0. && col.g != 0. && col.b != 0.) {
       col.a = pixel.a;
    }

    gl_FragColor = col * pixel.a;
}
`;






class $6c6b7c04c1d5fa2e$export$4eeb783ef7c17da8 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, inward: inward, frequency: frequency, strength: strength, minIntensity: minIntensity, maxIntensity: maxIntensity, anchorX: anchorX, anchorY: anchorY } = Object.assign({}, $6c6b7c04c1d5fa2e$export$4eeb783ef7c17da8.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $79b15a82cea589ba$export$9f7639465b88ec7f));
        this.uniforms.color = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.anchor = new Float32Array([
            0.5,
            0.5
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            inward: inward,
            frequency: frequency,
            strength: strength,
            minIntensity: minIntensity,
            maxIntensity: maxIntensity,
            anchorX: anchorX,
            anchorY: anchorY
        });
        this.zOrder = 280;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get inward() {
        return this.uniforms.inward;
    }
    set inward(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.inward = value;
    }
    get anchorX() {
        return this.uniforms.anchor[0];
    }
    set anchorX(value) {
        this.uniforms.anchor[0] = value;
    }
    get anchorY() {
        return this.uniforms.anchor[1];
    }
    set anchorY(value) {
        this.uniforms.anchor[1] = value;
    }
    get frequency() {
        return this.uniforms.frequency;
    }
    set frequency(value) {
        this.uniforms.frequency = value;
    }
    get strength() {
        return this.uniforms.strength;
    }
    set strength(value) {
        this.uniforms.strength = value;
    }
    get minIntensity() {
        return this.uniforms.minIntensity;
    }
    set minIntensity(value) {
        this.uniforms.minIntensity = value;
    }
    get maxIntensity() {
        return this.uniforms.maxIntensity;
    }
    set maxIntensity(value) {
        this.uniforms.maxIntensity = value;
    }
}
$6c6b7c04c1d5fa2e$export$4eeb783ef7c17da8.defaults = {
    time: 0,
    color: 0xffffff,
    inward: false,
    frequency: 35,
    strength: 0.01,
    minIntensity: 1.2,
    maxIntensity: 3.5,
    anchorX: 0.5,
    anchorY: 0.5
};


const $a6aa0c1b3663277e$export$a47a7c04f1bc8ac = `
precision mediump float;

uniform float time;
uniform float amplitude;
uniform float intensity;
uniform int fireBlend;
uniform int blend;
uniform bool alphaDiscard;
uniform vec2 anchor;
uniform vec3 color;

uniform sampler2D uSampler;
varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

float rand(vec2 n) 
{ 
	return fract(cos(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

vec4 blenderVec3(int blend, vec4 fColv4, vec4 sColv4)
{
    vec3 fCol = vec3(fColv4);
    vec3 sCol = vec3(sColv4);
    if ( blend == 1) { fCol = fCol * sCol; }
    else if (blend == 2) { fCol = (1. - (1. - fCol) * (1. - sCol)); }
    else if (blend == 3) { fCol = min(fCol, sCol); }
    else if (blend == 4) { fCol = max(fCol, sCol); }
    else if (blend == 5) { fCol = abs(fCol - sCol); }
    else if (blend == 6) { fCol = 1. - abs(1. - fCol - sCol); }
    else if (blend == 7) { fCol = fCol + sCol - (2. * fCol * sCol); }
    else if (blend == 8) { fCol = all(lessThanEqual(fCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 9) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 10) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol + fCol * fCol * (1. - 2. * sCol)) : sqrt(fCol) * (2. * sCol - 1.) + (2. * fCol) * (1. - sCol); }
    else if (blend == 11) { fCol = fCol / (1.0 - sCol); }
    else if (blend == 12) { fCol = 1.0 - (1.0 - fCol) / sCol; }
    else if (blend == 13) { fCol = fCol + sCol; }
    else { fCol = fCol + sCol; }
    
    return vec4(fCol,1.0);
}

float noise(vec2 n) 
{
	const vec2 d = vec2(0.0, 1.0);
	vec2 b = floor(n);
	vec2 f = smoothstep(vec2(0.), vec2(1.0), fract(n));
	return mix(mix(rand(b), rand(b + d.yx), f.x), 
	       mix(rand(b + d.xy), rand(b + d.yy), f.x), f.y);
}

float fbm(vec2 n) 
{
	float total = 0.0, amp = amplitude;
	for (int i = 0; i < 7; i++) {
		total += noise(n) * amp;
		n += n;
		amp *= 0.5;
	}
	return total;
}

vec4 fire() 
{
    const vec3 c1 = vec3(0.1, 0.0, 0.);
	const vec3 c2 = vec3(0.7, 0.0, 0.);
	const vec3 c3 = vec3(0.2, 0.0, 0.);
	const vec3 c4 = vec3(1.0, 0.9, 0.);
	const vec3 c5 = vec3(0.1);
	const vec3 c6 = vec3(0.9);
    vec2 uv = vFilterCoord - anchor;
	vec2 p = uv.xy * 8.0;
	float q = fbm(p - time * 0.1);
	vec2 r = vec2(fbm(p + q + time * 0.7 - p.x - p.y), fbm(p + q - time * 0.4));
	vec3 c = mix(c1, c2, fbm(p + r)) + mix(c3, c4, r.x) - mix(c5, c6, r.y);
	return vec4(c * cos(1.57/(intensity-0.03) * uv.y), 1.0);
}

vec4 fireBlending()
{
    vec4 fire = fire();
    vec4 tint = vec4(color,1.0);
    return blenderVec3(fireBlend,fire,tint);
}

vec4 resultBlending(vec4 pixel, vec4 fire)
{
    vec4 result = blenderVec3(blend,pixel,fire);
    return result;
}

void main() 
{
    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a==0.) {
       gl_FragColor = pixel;
       return;
    }

    vec4 result = resultBlending(pixel, fireBlending())*pixel.a;
    if (alphaDiscard && all(lessThanEqual(result.rgb,vec3(0.50)))) discard;
	gl_FragColor = result;
}
`;






class $f77ec43cfcb845eb$export$fd0af22b8dd4eb46 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, amplitude: amplitude, intensity: intensity, fireBlend: fireBlend, blend: blend, anchorX: anchorX, anchorY: anchorY, alphaDiscard: alphaDiscard } = Object.assign({}, $f77ec43cfcb845eb$export$fd0af22b8dd4eb46.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $a6aa0c1b3663277e$export$a47a7c04f1bc8ac));
        this.uniforms.color = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.anchor = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            amplitude: amplitude,
            intensity: intensity,
            fireBlend: fireBlend,
            blend: blend,
            anchorX: anchorX,
            anchorY: anchorY,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 150;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get amplitude() {
        return this.uniforms.amplitude;
    }
    set amplitude(value) {
        this.uniforms.amplitude = value;
    }
    get intensity() {
        return this.uniforms.intensity;
    }
    set intensity(value) {
        this.uniforms.intensity = value;
    }
    get fireBlend() {
        return this.uniforms.fireBlend;
    }
    set fireBlend(value) {
        this.uniforms.fireBlend = Math.floor(value);
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get anchorX() {
        return this.uniforms.anchor[0];
    }
    set anchorX(value) {
        this.uniforms.anchor[0] = value;
    }
    get anchorY() {
        return this.uniforms.anchor[1];
    }
    set anchorY(value) {
        this.uniforms.anchor[1] = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
}
$f77ec43cfcb845eb$export$fd0af22b8dd4eb46.defaults = {
    time: 0,
    color: 0xffffff,
    amplitude: 1,
    intensity: 1,
    fireBlend: 1,
    blend: 2,
    anchorX: 1,
    anchorY: 1,
    alphaDiscard: false
};


const $a8a639be76f4582e$export$73c22863fbcd15d3 = `
precision mediump float;
precision mediump int;

uniform float time;
uniform vec2 dimensions;
uniform int blend;
uniform vec3 color;
uniform sampler2D uSampler;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

#define TWOPI 6.28318530718

vec4 toGray(in vec4 color)
{
  float average = (color.r + color.g + color.b) * 0.33333334;
  return vec4(average, average, average, 1.0);
}

vec4 colorize(in vec4 grayscale, in vec4 color)
{
    return (grayscale * color);
}

vec4 blenderVec3(int blend, vec4 fColv4, vec4 sColv4)
{
    vec3 fCol = vec3(fColv4);
    vec3 sCol = vec3(sColv4);
    if ( blend == 1) { fCol = fCol * sCol; }
    else if (blend == 2) { fCol = (1. - (1. - fCol) * (1. - sCol)); }
    else if (blend == 3) { fCol = min(fCol, sCol); }
    else if (blend == 4) { fCol = max(fCol, sCol); }
    else if (blend == 5) { fCol = abs(fCol - sCol); }
    else if (blend == 6) { fCol = 1. - abs(1. - fCol - sCol); }
    else if (blend == 7) { fCol = fCol + sCol - (2. * fCol * sCol); }
    else if (blend == 8) { fCol = all(lessThanEqual(fCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 9) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 10) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol + fCol * fCol * (1. - 2. * sCol)) : sqrt(fCol) * (2. * sCol - 1.) + (2. * fCol) * (1. - sCol); }
    else if (blend == 11) { fCol = fCol / (1.0 - sCol); }
    else if (blend == 12) { fCol = 1.0 - (1.0 - fCol) / sCol; }
    else if (blend == 13) { fCol = fCol + sCol; }
    else { fCol = fCol + sCol; }
    
    return vec4(fCol,1.0);
}

vec4 fog(vec2 fragCoord)
{
    float t = time * 0.26 + 23.0;
    vec2 uv = fragCoord.xy * dimensions.xy;

    vec2 p = mod(uv * TWOPI, TWOPI) - 250.0;
    vec2 i = vec2(p);
    float c = 0.75;
    float intensity = 0.014;

    for (int n = 0; n < 4; n++) {
        float t = t * (1.0 - (3.5 / float(n + 1)));
        i = p + vec2(cos(t - i.x) + sin(t + i.y), sin(t - i.y) + cos(t + i.x));
        c += 1.0 / length(vec2(.5 * p.x / (sin(0.40 * i.x + t) / intensity), p.y / (cos(i.y + t) / intensity)));
    }

    c *= 0.16666667;
    c = 1.17 - pow(c, 1.4);
    vec3 colour = vec3(pow(abs(c), 8.0));

    return vec4(colour * colour, 1.);
}


void main() 
{
    vec4 pixel = texture2D(uSampler,vTextureCoord);

    // to avoid computation on an invisible pixel.
    if (pixel.a==0.) {
        gl_FragColor = pixel;
        return;
    }

    // fog generation.
    vec4 fog = colorize(
               toGray(
                 fog(vFilterCoord.xy) 
               + fog(-vFilterCoord.xy * 0.65))
                    ,vec4(color/3., 1.)) * 0.9;

    // we put the fog and the pixel into the blender, and we serve, adjusted by the pixel alpha.
	gl_FragColor = blenderVec3(blend, fog, pixel) * pixel.a;
}
`;






class $223f1247ddebb00e$export$60b593b6124d1ebc extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, blend: blend, dimX: dimX, dimY: dimY } = Object.assign({}, $223f1247ddebb00e$export$60b593b6124d1ebc.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $a8a639be76f4582e$export$73c22863fbcd15d3));
        this.uniforms.color = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.dimensions = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            blend: blend,
            dimX: dimX,
            dimY: dimY
        });
        this.zOrder = 210;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get dimX() {
        return this.uniforms.dimensions[0];
    }
    set dimX(value) {
        this.uniforms.dimensions[0] = value;
    }
    get dimY() {
        return this.uniforms.dimensions[1];
    }
    set dimY(value) {
        this.uniforms.dimensions[1] = value;
    }
}
$223f1247ddebb00e$export$60b593b6124d1ebc.defaults = {
    time: 0,
    color: 0xffffff,
    blend: 2,
    dimX: 1,
    dimY: 1
};


const $0e44befc9eaab3bf$export$9fa5c76e40adf3ca = `
precision mediump float;

uniform float time;
uniform float scale;
uniform float glint;
uniform float billowy;
uniform float tintIntensity;
uniform vec2 shift;
uniform vec3 waterColor;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;
uniform sampler2D uSampler;
uniform mat3 filterMatrixInverse;

const float timeSpeed = 3.;

#define TWOPI 6.28318531

float randomVal (float inVal)
{
    return fract(sin(mod(dot(vec2(inVal, 2523.2361) , vec2(12.9898,78.233)), TWOPI)) * 43758.5453)-0.5;
}

vec2 randomVec2 (float inVal)
{
    return normalize(vec2(randomVal(inVal), randomVal(inVal+151.523)));
}

float makeWaves(vec2 uv, float theTime, float offset)
{
    float result = 0.0;
    float direction = 0.0;
    float sineWave = 0.0;
    vec2 randVec = vec2(0.0,0.0);
    float i;
    for(int n = 0; n < 16; n++)
    {
        i = float(n)+offset;
        randVec = randomVec2(float(i));
  		direction = (uv.x*randVec.x+uv.y*randVec.y);
        sineWave = sin(mod(direction*randomVal(i+1.6516)+theTime*timeSpeed, TWOPI));
        sineWave = smoothstep(0.2,1.,sineWave);
    	result += randomVal(i+123.0)*sineWave;
    }
    return result;
}

vec4 water( vec2 fragCoord )
{
    vec4 fragColor;
	vec2 uv = fragCoord.xy * 0.5;
    
    vec2 uv2 = uv * scale;
    
    uv *= 2.0;

    float result = 0.0;
    float result2 = 0.0;
    
    result = makeWaves( uv2+vec2(time*timeSpeed,0.0), time, 0.1);
    result2 = makeWaves( uv2-vec2(time*0.8*timeSpeed,0.0), time*0.8+1.06, 0.26);
    
    result *= 0.2;
    
    result = smoothstep(0.35,1.1,1.0-abs(result));
    result2 = smoothstep(0.35,1.1,1.0-abs(result2));
    
    result = 2.0*smoothstep(0.35,1.8,(result+result2)*glint);

    vec2 p = vec2(result, result2)*0.019 + (cos( mod(  uv*1.1 - sin(mod(uv.yx + time*timeSpeed/20., TWOPI)), TWOPI) )*0.012);
    uv.x -= shift.x;
    uv.y -= shift.y;
    uv += p * billowy;
    vec4 pixel = texture2D( uSampler , (filterMatrixInverse * vec3(uv, 1.0)).xy );
	return (vec4(result)*0.9 + pixel)*pixel.a;
}

void main() {
    vec4 water = water(vFilterCoord);
    vec4 result = mix(vec4(waterColor,1.0),water,1./(tintIntensity+1.000000001))*water.a;
    gl_FragColor = result;
}
`;






class $a0aac33c68ab6b34$export$bf2c97ada2c2b329 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, scale: scale, glint: glint, billowy: billowy, color: color, shiftX: shiftX, shiftY: shiftY, tintIntensity: tintIntensity } = Object.assign({}, $a0aac33c68ab6b34$export$bf2c97ada2c2b329.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $0e44befc9eaab3bf$export$9fa5c76e40adf3ca));
        this.uniforms.waterColor = new Float32Array([
            0.0,
            0.18,
            0.54
        ]);
        this.uniforms.shift = new Float32Array([
            0.0,
            0.0
        ]);
        Object.assign(this, {
            time: time,
            scale: scale,
            glint: glint,
            billowy: billowy,
            color: color,
            shiftX: shiftX,
            shiftY: shiftY,
            tintIntensity: tintIntensity
        });
        this.zOrder = 170;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.waterColor);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.waterColor);
    }
    get scale() {
        return this.uniforms.scale;
    }
    set scale(value) {
        this.uniforms.scale = value;
    }
    get glint() {
        return this.uniforms.glint;
    }
    set glint(value) {
        this.uniforms.glint = value;
    }
    get billowy() {
        return this.uniforms.billowy;
    }
    set billowy(value) {
        this.uniforms.billowy = value;
    }
    get tintIntensity() {
        return this.uniforms.tintIntensity;
    }
    set tintIntensity(value) {
        this.uniforms.tintIntensity = value;
    }
    get shiftX() {
        return this.uniforms.shift[0];
    }
    set shiftX(value) {
        this.uniforms.shift[0] = value;
    }
    get shiftY() {
        this.uniforms.shift[1];
    }
    set shiftY(value) {
        this.uniforms.shift[1] = value;
    }
}
$a0aac33c68ab6b34$export$bf2c97ada2c2b329.defaults = {
    time: 0,
    glint: 0.5,
    scale: 70,
    billowy: 0.5,
    color: 0x0020a9,
    shiftX: 0,
    shiftY: 0,
    tintIntensity: 0.2
};


const $c90d8ed2baf3fb09$export$cc1bb59c1623a9ed = `
precision mediump float;
precision mediump int;

uniform float time;
uniform vec2 scale;
uniform vec3 color;
uniform int blend;
uniform sampler2D uSampler;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

#define F4 0.309016994374947451
#define PI 3.14159
#define SPEED 0.01

vec4 blenderVec3(int blend, vec4 fColv4, vec4 sColv4)
{
    vec3 fCol = vec3(fColv4);
    vec3 sCol = vec3(sColv4);
    if ( blend == 1) { fCol = fCol * sCol; }
    else if (blend == 2) { fCol = (1. - (1. - fCol) * (1. - sCol)); }
    else if (blend == 3) { fCol = min(fCol, sCol); }
    else if (blend == 4) { fCol = max(fCol, sCol); }
    else if (blend == 5) { fCol = abs(fCol - sCol); }
    else if (blend == 6) { fCol = 1. - abs(1. - fCol - sCol); }
    else if (blend == 7) { fCol = fCol + sCol - (2. * fCol * sCol); }
    else if (blend == 8) { fCol = all(lessThanEqual(fCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 9) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 10) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol + fCol * fCol * (1. - 2. * sCol)) : sqrt(fCol) * (2. * sCol - 1.) + (2. * fCol) * (1. - sCol); }
    else if (blend == 11) { fCol = fCol / (1.0 - sCol); }
    else if (blend == 12) { fCol = 1.0 - (1.0 - fCol) / sCol; }
    else if (blend == 13) { fCol = fCol + sCol; }
    else { fCol = fCol + sCol; }
    
    return vec4(fCol,1.0);
}

vec4 mod289(vec4 x) 
{
    return x - floor(x * (1.0 / 289.0)) * 289.0;
}

float mod289(float x) 
{
    return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 permute(vec4 x) 
{
    return mod289(((x*34.0)+1.0)*x);
}

float permute(float x) 
{
    return mod289(((x*34.0)+1.0)*x);
}

vec4 taylorInvSqrt(vec4 r) 
{
    return 1.79284291400159 - 0.85373472095314 * r;
}

float taylorInvSqrt(float r) 
{
    return 1.79284291400159 - 0.85373472095314 * r;
}

vec4 grad4(float j, vec4 ip) 
{
    const vec4 ones = vec4(1.0, 1.0, 1.0, -1.0);
    vec4 p,s;

    p.xyz = floor( fract (vec3(j) * ip.xyz) * 7.0) * ip.z - 1.0;
    p.w = 1.5 - dot(abs(p.xyz), ones.xyz);
    s = vec4(lessThan(p, vec4(0.0)));
    p.xyz = p.xyz + (s.xyz*2.0 - 1.0) * s.www;

    return p;
}

float snoise(vec4 v) 
{
    const vec4  C = vec4( 0.138196601125011,
                          0.276393202250021,
                          0.414589803375032,
                         -0.447213595499958);

    vec4 i  = floor(v + dot(v, vec4(F4)) );
    vec4 x0 = v -   i + dot(i, C.xxxx);

    vec4 i0;
    vec3 isX = step( x0.yzw, x0.xxx );
    vec3 isYZ = step( x0.zww, x0.yyz );
      
    i0.x = isX.x + isX.y + isX.z;
    i0.yzw = 1.0 - isX;
      
    i0.y += isYZ.x + isYZ.y;
    i0.zw += 1.0 - isYZ.xy;
    i0.z += isYZ.z;
    i0.w += 1.0 - isYZ.z;

    vec4 i3 = clamp( i0, 0.0, 1.0 );
    vec4 i2 = clamp( i0-1.0, 0.0, 1.0 );
    vec4 i1 = clamp( i0-2.0, 0.0, 1.0 );

    vec4 x1 = x0 - i1 + C.xxxx;
    vec4 x2 = x0 - i2 + C.yyyy;
    vec4 x3 = x0 - i3 + C.zzzz;
    vec4 x4 = x0 + C.wwww;
    
    i = mod289(i);
    float j0 = permute( permute( permute( permute(i.w) + i.z) + i.y) + i.x);
    vec4 j1 = permute( permute( permute( permute (
                        i.w + vec4(i1.w, i2.w, i3.w, 1.0 ))
                    + i.z + vec4(i1.z, i2.z, i3.z, 1.0 ))
                + i.y + vec4(i1.y, i2.y, i3.y, 1.0 ))
            + i.x + vec4(i1.x, i2.x, i3.x, 1.0 ));

    vec4 ip = vec4(1.0/294.0, 1.0/49.0, 1.0/7.0, 0.0) ;

    vec4 p0 = grad4(j0,   ip);
    vec4 p1 = grad4(j1.x, ip);
    vec4 p2 = grad4(j1.y, ip);
    vec4 p3 = grad4(j1.z, ip);
    vec4 p4 = grad4(j1.w, ip);

    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
    p0 *= norm.x;
    p1 *= norm.y;
    p2 *= norm.z;
    p3 *= norm.w;
    p4 *= taylorInvSqrt(dot(p4,p4));

    vec3 m0 = max(0.6 - vec3(dot(x0,x0), dot(x1,x1), dot(x2,x2)), 0.0);
    vec2 m1 = max(0.6 - vec2(dot(x3,x3), dot(x4,x4)            ), 0.0);
    m0 = m0 * m0;
    m1 = m1 * m1;
    return 49.0 * ( dot(m0*m0, vec3( dot( p0, x0 ), dot( p1, x1 ), dot( p2, x2 )))
            + dot(m1*m1, vec2( dot( p3, x3 ), dot( p4, x4 ) ) ) ) ;

}

float surface( vec4 coord ) 
{
	float n = 0.0;

	n += 0.25 * abs( snoise( coord * 4.0 ) );
	n += 0.5 * abs( snoise( coord * 8.0 ) );
	n += 0.25 * abs( snoise( coord * 16.0 ) );
	n += 0.125 * abs( snoise( coord * 32.0 ) );
	
	return n;
}

void main() 
{
    vec4 pixel = texture2D(uSampler,vTextureCoord);

    // to avoid computation on an invisible pixel
    if (pixel.a == 0.) {
        gl_FragColor = pixel;
        return;
    }

    vec2 uv = vFilterCoord - vec2(0.375*scale.x,0.375*scale.y);
    float s = uv.x * scale.x;
    float t = uv.y * scale.y;
    
    float multiplier = 1.0 / ( 2.0 * PI );
    float nx = cos( s * 2.0 * PI ) * multiplier;
    float ny = cos( t * 2.0 * PI ) * multiplier;
    float nz = sin( s * 2.0 * PI ) * multiplier;
    float nw = sin( t * 2.0 * PI ) * multiplier;

    float surf = surface( vec4( nx, ny, nz, nw ) + time * SPEED );
    vec4 result = vec4( color * vec3( surf ), 1.0 );
    
    gl_FragColor = blenderVec3(blend,pixel,result) * pixel.a;
}
`;






class $a08c1e6a648373ca$export$2ba7369b7ae4551b extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, blend: blend, dimX: dimX, dimY: dimY } = Object.assign({}, $a08c1e6a648373ca$export$2ba7369b7ae4551b.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $c90d8ed2baf3fb09$export$cc1bb59c1623a9ed));
        this.uniforms.color = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.scale = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            blend: blend,
            dimX: dimX,
            dimY: dimY
        });
        this.zOrder = 200;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get dimX() {
        return this.uniforms.scale[0];
    }
    set dimX(value) {
        this.uniforms.scale[0] = value;
    }
    get dimY() {
        return this.uniforms.scale[1];
    }
    set dimY(value) {
        this.uniforms.scale[1] = value;
    }
}
$a08c1e6a648373ca$export$2ba7369b7ae4551b.defaults = {
    time: 0,
    color: 0xffffff,
    blend: 13,
    dimX: 1,
    dimY: 1
};


const $98647ce0a9afc699$export$74eae7f690aa2952 = `
precision mediump float;

uniform float time;
uniform int blend;
uniform int shieldType;
uniform vec3 color;
uniform vec2 posLight;
uniform vec3 ambientColor;
uniform float intensity;
uniform float lightColorAlpha;
uniform float lightSize;
uniform float scale;
uniform float radius;
uniform float hideRadius;
uniform float discardThreshold;
uniform bool chromatic;
uniform bool alphaDiscard;
uniform sampler2D uSampler;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

#define SQRT5B20 0.30901699
#define PI 3.14159265
#define TWOPI 6.28318531
#define SPEED 0.01
#define MU_TWOPI 0.15915494309
#define MU_289 0.00346020761
#define MU_3 0.33333333334
#define MU_1_5 0.66666666667

vec3 hsvToRgb(vec3 hsVcolor)
{
    vec4 K = vec4(1., 2.0 * MU_3, 1.0 * MU_3, 3.0);
    vec3 p = abs(fract(hsVcolor.xxx + K.xyz) 
             * 6.0 - K.www);
    return hsVcolor.z 
           * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), hsVcolor.y);
}

vec3 multihue(vec2 uv) 
{
    float h = 0.5 + atan(uv.y, uv.x) * MU_TWOPI;
    vec3 hsv = vec3(h, 1., 1.);
    return hsvToRgb(hsv);
}

float random(vec2 n) 
{ 
	return fract(cos(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

vec2 random2(vec2 p) 
{
    return fract(sin(vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3))))*43758.5453);
}

float bornedCos(float minimum, float maximum)
{
    return (maximum-minimum)*(cos(PI*time*0.10 + 1.)*0.5)+minimum;
}

float bornedSin(float minimum, float maximum)
{
    return (maximum-minimum)*(sin(PI*time*0.10 + 1.)*0.5)+minimum;
}

vec4 mod289(vec4 x) 
{
    return x - floor(x * MU_289) * 289.0;
}

float mod289(float x) 
{
    return x - floor(x * MU_289) * 289.0;
}

vec4 permute(vec4 x) 
{
    return mod289(((x*34.0)+1.0)*x);
}

float permute(float x) 
{
    return mod289(((x*34.0)+1.0)*x);
}

vec4 taylorInvSqrt(vec4 r) 
{
    return 1.79284291400159 - 0.85373472095314 * r;
}

float taylorInvSqrt(float r) 
{
    return 1.79284291400159 - 0.85373472095314 * r;
}

vec4 grad4(float j, vec4 ip) 
{
    const vec4 ones = vec4(1.0, 1.0, 1.0, -1.0);
    vec4 p,s;

    p.xyz = floor( fract (vec3(j) * ip.xyz) * 7.0) * ip.z - 1.0;
    p.w = 1.5 - dot(abs(p.xyz), ones.xyz);
    s = vec4(lessThan(p, vec4(0.0)));
    p.xyz = p.xyz + (s.xyz*2.0 - 1.0) * s.www;

    return p;
}

float snoise(vec4 v) 
{
    const vec4  C = vec4( 0.138196601125011,
                          0.276393202250021,
                          0.414589803375032,
                         -0.447213595499958);

    vec4 i  = floor(v + dot(v, vec4(SQRT5B20)) );
    vec4 x0 = v -   i + dot(i, C.xxxx);

    vec4 i0;
    vec3 isX = step( x0.yzw, x0.xxx );
    vec3 isYZ = step( x0.zww, x0.yyz );
      
    i0.x = isX.x + isX.y + isX.z;
    i0.yzw = 1.0 - isX;
      
    i0.y += isYZ.x + isYZ.y;
    i0.zw += 1.0 - isYZ.xy;
    i0.z += isYZ.z;
    i0.w += 1.0 - isYZ.z;

    vec4 i3 = clamp( i0, 0.0, 1.0 );
    vec4 i2 = clamp( i0-1.0, 0.0, 1.0 );
    vec4 i1 = clamp( i0-2.0, 0.0, 1.0 );

    vec4 x1 = x0 - i1 + C.xxxx;
    vec4 x2 = x0 - i2 + C.yyyy;
    vec4 x3 = x0 - i3 + C.zzzz;
    vec4 x4 = x0 + C.wwww;
    
    i = mod289(i);
    float j0 = permute( permute( permute( permute(i.w) + i.z) + i.y) + i.x);
    vec4 j1 = permute( permute( permute( permute (
                        i.w + vec4(i1.w, i2.w, i3.w, 1.0 ))
                    + i.z + vec4(i1.z, i2.z, i3.z, 1.0 ))
                + i.y + vec4(i1.y, i2.y, i3.y, 1.0 ))
            + i.x + vec4(i1.x, i2.x, i3.x, 1.0 ));

    vec4 ip = vec4(1.0/294.0, 1.0/49.0, 1.0/7.0, 0.0) ;

    vec4 p0 = grad4(j0,   ip);
    vec4 p1 = grad4(j1.x, ip);
    vec4 p2 = grad4(j1.y, ip);
    vec4 p3 = grad4(j1.z, ip);
    vec4 p4 = grad4(j1.w, ip);

    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
    p0 *= norm.x;
    p1 *= norm.y;
    p2 *= norm.z;
    p3 *= norm.w;
    p4 *= taylorInvSqrt(dot(p4,p4));

    vec3 m0 = max(0.6 - vec3(dot(x0,x0), dot(x1,x1), dot(x2,x2)), 0.0);
    vec2 m1 = max(0.6 - vec2(dot(x3,x3), dot(x4,x4)            ), 0.0);
    m0 = m0 * m0;
    m1 = m1 * m1;
    return 49.0 * ( dot(m0*m0, vec3( dot( p0, x0 ), dot( p1, x1 ), dot( p2, x2 )))
            + dot(m1*m1, vec2( dot( p3, x3 ), dot( p4, x4 ) ) ) ) ;

}

float surface( vec4 coord ) 
{
	float n = 0.0;

	n += 0.25 * abs( snoise( coord * 4.0 ) );
	n += 0.5 * abs( snoise( coord * 8.0 ) );
	n += 0.25 * abs( snoise( coord * 16.0 ) );
	n += 0.125 * abs( snoise( coord * 32.0 ) );
	
	return n;
}

vec4 ambientLight(vec4 pixel, vec2 fragCoord, vec2 posLg) 
{
  vec3 lightColor = (color+vec3(2.)) * MU_3;
  vec2 position = posLg;
  
  float maxDistance = lightSize;
  float distance = distance(fragCoord-posLg, position);
  float value = 1.0 - smoothstep(-0.2, maxDistance, distance);
  
  vec3 ambient = pixel.rgb * color * intensity;
  vec3 light = (lightColor*lightColorAlpha) * clamp(value, 0.0, 1.0);
  vec3 intensity = ambient + light;
  vec3 final = pixel.rgb * intensity;

  return vec4(final, 1.0);
}

vec3 toGray(vec3 color)
{
  float average = (color.r + color.g + color.b)*0.3333333;
  return vec3(average, average, average);
}

vec3 colorize(vec3 grayscale, vec3 color)
{
    return (grayscale * color);
}

vec4 blenderVec3(int blend, vec4 fColv4, vec4 sColv4)
{
    vec3 fCol = vec3(fColv4);
    vec3 sCol = vec3(sColv4);
    if ( blend == 1) { fCol = fCol * sCol; }
    else if (blend == 2) { fCol = (1. - (1. - fCol) * (1. - sCol)); }
    else if (blend == 3) { fCol = min(fCol, sCol); }
    else if (blend == 4) { fCol = max(fCol, sCol); }
    else if (blend == 5) { fCol = abs(fCol - sCol); }
    else if (blend == 6) { fCol = 1. - abs(1. - fCol - sCol); }
    else if (blend == 7) { fCol = fCol + sCol - (2. * fCol * sCol); }
    else if (blend == 8) { fCol = all(lessThanEqual(fCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 9) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 10) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol + fCol * fCol * (1. - 2. * sCol)) : sqrt(fCol) * (2. * sCol - 1.) + (2. * fCol) * (1. - sCol); }
    else if (blend == 11) { fCol = fCol / (1.0 - sCol + 0.00001); }
    else if (blend == 12) { fCol = 1.0 - (1.0 - fCol) / sCol + 0.00001; }
    else if (blend == 13) { fCol = fCol + sCol; return vec4(fCol,0.6); }
    else if (blend == 14) { return mix(fColv4,sColv4,1.-fColv4.a); }
    else if (blend == 15) { return mix(fColv4,sColv4,fColv4.a); }
    else { fCol = fCol + sCol; }
    
    return vec4(fCol,(fColv4.a+sColv4.a)*0.5);
}

float hexDist(vec2 p) 
{
	p = abs(p);
	
    float c = dot(p, normalize(vec2(1,1.73)));
    c = max(c, p.x);
    
    return c;
}

vec4 hexCoords(vec2 uv) 
{
	const vec2 r = vec2(1, 1.73);
    const vec2 h = r*.5;
    
    vec2 a = mod(uv, r)-h;
    vec2 b = mod(uv-h, r)-h;
    vec2 gv = dot(a, a) < dot(b,b) ? a : b;
    
    float x = atan(gv.x, gv.y);
    float y = .65-hexDist(gv);
    vec2 id = uv-gv;
    return vec4(x, y, id.x,id.y);
}

vec4 hexa(vec2 fragCoord)
{
    float t = time;
    
    vec2 uv = fragCoord;
    vec2 uv1 = uv + vec2(0, sin(uv.x*1. +t)*.25);
    
    vec2 uv2 = .5*uv1 + .5*uv + vec2(sin(uv.y*5. + t)*.05, 0);
    float a = 1. + t*0.1;
    float c = cos(a);
    float s = sin(a);
    uv2 *= mat2(c, -s, s, c);
    
    vec3 col = color;
    col += (smoothstep(abs(uv2.y)*MU_1_5, 3.99, hexCoords(uv2*15.).y) * 40.*(sin(t)+1.));
    col += (smoothstep(abs(uv2.x)*MU_1_5, 3.99, hexCoords(uv2*15.).y) * 40.*(cos(t)+1.));

    return vec4(colorize(toGray(clamp(col,0.,2.)),color),1.);
}

vec4 voronoi( in vec2 x, float step1, float step2 ) 
{
    vec2 n = floor(x);
    vec2 f = fract(x);

    vec2 mg, mr;
    float md = 8.0;
    for (int j= -1; j <= 1; j++) {
        for (int i= -1; i <= 1; i++) {
            vec2 g = vec2(float(i),float(j));
            vec2 o = random2( n + g );
            o = 0.5 + 0.5*sin( time + 6.2831*o );

            vec2 r = g + o - f;
            float d = dot(r,r);

            if( d<md ) {
                md = d;
                mr = r;
                mg = g;
            }
        }
    }

    md = 8.0;
    for (int j= -2; j <= 1; j++) {
        for (int i= -2; i <= 1; i++) {
            vec2 g = mg + vec2(float(i),float(j));
            vec2 o = random2( n + g );
            o = 0.5 + 0.5*sin( time + 6.2831*o );

            vec2 r = g + o - f;

            if ( dot(mr-r,mr-r)>0.000001 ) {
                md = min(md, dot( 0.6*(mr+r), normalize(r-mr) ));
            }
        }
    }
    vec3 intermediate = vec3(md, mr);
    vec3 final = (intermediate.x*(0.4 + .5*sin(64.0*intermediate.x))*color);
    final = mix( color, final, smoothstep( step1, step2, intermediate.x*18. ) );
    return vec4(final,1.);
}

float noise(vec2 n) 
{
	const vec2 d = vec2(0.0, 1.0);
	vec2 b = floor(n);
	vec2 f = smoothstep(vec2(0.), vec2(1.0), fract(n));
	return mix(mix(random(b), random(b + d.yx), f.x), 
	       mix(random(b + d.xy), random(b + d.yy), f.x), f.y);
}

float fbm(vec2 n) 
{
	float total = 0.0, amp = 1.;
	for (int i = 0; i < 7; i++) {
		total += noise(n) * amp;
		n += n;
		amp *= 0.5;
	}
	return total;
}

float fbm2(vec2 n) 
{
	float total = 0.0, amp = 1.;
	for (int i = 0; i < 2; i++) {
		total += noise(n) * amp;
		n += n;
		amp *= 0.5;
	}
	return total;
}

vec4 ripples(vec2 suv) 
{
    suv.x += time*0.5;
    vec3 c1 = vec3(0.);
    vec3 c2 = vec3(c1);
    vec3 c3 = vec3(c1);
    vec3 c4 = vec3(color.r*5., color.g*3.333, color.b*2.);
    vec3 c5 = vec3(c3);
    vec3 c6 = vec3(c1);
    vec2 p = suv;
    float q = 2.*fbm2(p + time*2.);
    vec2 r = vec2(fbm2(p + q + ( time  ) - p.x - p.y), fbm2(p + p + ( time )));
    r.x += bornedCos(-0.3,-0.2);
    r.y += 200.*bornedSin(-1.9,1.9);
    
    vec3 c = color * (
        mix( c1, c2, fbm( p + r ) ) + mix( c3, c4, r.x ) - mix( c5, c6, r.y )
    );
    return vec4(c,1.);
}

vec4 fire(vec2 suv) 
{
    vec3 c1 = color+vec3(0.1, 0.0, 0.)*0.666667;
	vec3 c2 = color+vec3(0.7, 0.0, 0.)*0.666667;
	vec3 c3 = color+vec3(0.2, 0.0, 0.)*0.666667;
	vec3 c4 = color+vec3(1.0, 0.9, 0.)*0.666667;
	vec3 c5 = vec3(0.1);
	vec3 c6 = vec3(0.9);
    vec2 uv = suv - vec2(0.92,0.26);
	vec2 p = uv.xy * 8.0;
	float q = fbm(p - time * 0.1);
	vec2 r = vec2(fbm(p + q + time * 0.7 - p.x - p.y), fbm(p + q - time * 0.4));
	vec3 c = mix(c1, c2, fbm(p + r)) + mix(c3, c4, r.x) - mix(c5, c6, r.y);
	return vec4(c * cos(1.57/(1.-0.03) * uv.y), 1.0);
}

vec4 surface4d(vec2 suv)
{
    float s = suv.x + 0.61;
    float t = suv.y + 0.5;
    float nx = cos( s * TWOPI ) * MU_TWOPI;
    float ny = cos( t * TWOPI ) * MU_TWOPI;
    float nz = sin( s * TWOPI ) * MU_TWOPI;
    float nw = sin( t * TWOPI ) * MU_TWOPI;

    float surf = surface( vec4( nx, ny, nz, nw ) + time * 0.03 );
    return vec4( color * vec3( surf ), 1.0 );
}

vec4 noisy(vec2 suv)
{
    vec4 noiseColor;
    noiseColor.rgb = (color.rgb * noise(suv + fbm(suv) + time*0.5));
    noiseColor.a = 1.;
    return clamp(noiseColor,0.,1.);
}

vec2 circuit(vec2 p) {
	p = fract(p);
	float r = 0.3;
	float v = 0.0, g = 1.0;
	float d;
	
	const int iter = 7;
	for(int i = 0; i < iter; i ++)
	{
		d = p.x - r;
		g += pow(clamp(1.0 - abs(d), 0.0, 1.0), 200.0);
		
		if(d > 0.0) {
			p.x = (p.x - r) / (1.8 - r);
		}
		else {
			p.x = p.x;
		}
		p = p.yx;
	}
	v /= float(iter);
	return vec2(g, v);
}

vec4 denseSmoke(vec2 suv)
{
    vec4 noiseColor;
    vec2 uv;
    uv.x = (fbm(suv*2.)-suv.x);
    uv.y = (suv.y+fbm(suv*2.));
    noiseColor.rgb = (color.rgb * min(fbm(uv - time*0.5),fbm(uv)*1.5));
    noiseColor.a = 1.0;
    return clamp(noiseColor,0.,1.);
}

vec4 dancingFume(vec2 suv)
{
    vec4 noiseColor;
    vec2 uv;
    uv.x += noise(suv)+fbm(suv);
    uv.y += noise(suv)+fbm(suv);
    uv *= 0.5;
    noiseColor.rgb = (color.rgb * fbm((uv + suv*0.15) - time));
    noiseColor.a = 1.0;
    return clamp(noiseColor,0.,1.);
}

vec4 hugeSmoke(vec2 suv)
{
    vec4 noiseColor;
    vec2 uv;
    uv.x += sin(suv.y)+fbm(suv);
    uv.y += cos(suv.x)+fbm(suv);
    uv *= 0.5;
    noiseColor.rgb = (color.rgb * fbm((uv + suv) - time));
    noiseColor.a = 1.0;
    return clamp(noiseColor,0.,1.);
}

vec4 grid(vec2 suv)
{
    vec2 uv = suv + vec2(0.,-1.5);
	vec2 cid2 = floor(uv);
	float cid = (cid2.y + cid2.x);

	vec2 dg = circuit(uv);
	float d = dg.x;
	vec3 col1 = (0.5-vec3(max(min(d, 2.0) - 1., 0.))) * color * 2.;
    col1.rgb = sqrt(col1.rgb*0.5);
	vec3 col2 = vec3(max(d - 1.0, 0.0)) * color * 30. ;

	float f = max(0.7 - mod(sin(-uv.y) - cos(-uv.x) + (time * 1.) + (dg.y * 0.2), 0.9), 0.0) * 1.;
	col2 *= f;

    return vec4(col1 + col2, 1.0);
}

vec4 galaxy(vec2 suv)
{
    vec2 uv = suv*0.166666667 
        + vec2(bornedCos(0.0,0.7),
               bornedSin(0.0,0.7));

    float t = 0.44 * time 
            + (( 0.25 + 0.05 * sin( time * 0.44 )) 
            / ( length( uv.xy ) + 0.2 )) * 2.2;
    
    float si = sin( t * 1.5 );
    float co = cos( t * 0.66666667 );
    mat2 matrix = mat2( -co, si, si, co );
    
    float c;
    float v1 = 0.0;
    float v2 = 0.0;
    vec3 uv2 = vec3( uv, 0.0 );
    
    for( int i = 0; i < 50; i++ ) {
        float s = float( i ) * 0.035;
        vec3 p = s * uv2;
        p.xy *= matrix;
        p += vec3( .22,.3, s - 1.5 - sin( t * 0.13 ) * 0.1 );

        for( int i = 0; i < 6; i++ ) {
            p = abs( p ) / dot( p, p ) - 0.659;
        }

        v1 += dot( p,p ) * 0.0045 * ( 1.8 + sin( length( uv.xy * 13.0 ) + 0.5 - t * 0.2 ) );
        v2 += dot( p,p ) * 0.0045 * ( 1.5 + sin( length( uv.xy * 13.5 ) + 2.2 - t * 0.3 ) );
        c = length( p.xy * 0.5 ) * 1.05;
    }
    
    float len = length( uv );
    v1 *= smoothstep( 0.7, 0.0, len );
    v2 *= smoothstep( 0.6, 0.0, len );
    
    float r = clamp( c, 0.0, 1.0 );
    float g = clamp( ( v1 + c ) * 0.25, 0.0, 1.0 );
    float b = clamp( v2, 0.0, 1.0 );
    vec3 col = color * vec3( r, g, b ) + smoothstep( 0.15, 0.0, len ) * 0.9;

    return clamp(vec4( col, 1.0 ),0.,1.);
}

vec2 getSphere(out float alpha, out float r)
{
  vec2 tc = vFilterCoord.xy;
  vec2 p = (-1.0 + 2. * tc) * (1.01 / radius);
  r = dot(p,p);
  r > 0.943 ? alpha = max(min(40.*log(1./r),1.),0.) : alpha = 1.;
  float f = (1.0-sqrt(1.0-r))/(r);
  vec2 uv;
  uv.x = p.x*f;
  uv.y = p.y*f;
  return uv;
}

void computeHideAlpha(out float alpha)
{
  vec2 tc = vFilterCoord.xy;
  vec2 p = (-1.0 + 2. * tc) * (1.01 / hideRadius);
  float r = dot(p,p);
  r > 0.9 ? alpha = 1.-max(min(40.*log(1./r),1.),0.) : alpha = 0.;
}

void main()
{
    float a, r, hideAlpha;
    vec4 result;
    vec4 pixel = texture2D(uSampler, vTextureCoord);

    if (hideRadius > 0.) computeHideAlpha(hideAlpha);
    else hideAlpha = 1.;

    if (pixel.a == 0. && hideAlpha == 0.) {
        discard;
    }

    vec2 uv = getSphere(a, r);

    if (shieldType <= 1) {
        result = ripples(15.*uv*scale);
    } else if (shieldType == 2) {
        result = hexa(uv*scale);
    } else if (shieldType == 3) {
        result = fire(uv/1.5*scale);
    } else if (shieldType == 4) {
        result = voronoi(uv*scale*3.+0.3*cos(time),0.29,0.0);
    } else if (shieldType == 5) {
        result = voronoi(uv*scale*3.+0.3*cos(time),0.0019,1.);
    } else if (shieldType == 6) {
        result = 3.*surface4d(uv*scale);
    } else if (shieldType == 7) {
        result = noisy(uv*20.*scale);
    } else if (shieldType == 8) {
        result = denseSmoke(uv*10.*scale);
    } else if (shieldType == 9) {
        result = dancingFume(uv*20.*scale);
    } else if (shieldType == 10) {
        result = hugeSmoke(uv*5.*scale);
    } else if (shieldType == 11) {
        result = grid(uv*5.*scale);
    } else if (shieldType == 12) {
        result = galaxy(uv*5.*scale);
    } else if (shieldType != 1) {
        result = vec4(color,1.);
    }

    vec4 colorized;
    vec3 chromaOption;
    if (chromatic) {
        vec2 vHue = uv;
        vHue.x -= bornedCos(-0.,+2.2);
        vHue.y -= bornedSin(-0.,+2.2);
        chromaOption = multihue(vHue);
    } else {
        chromaOption = color;
    }
    colorized = (vec4(
                    colorize(
                        toGray(result.rgb), chromaOption), result.a) + result)*0.5;
    vec4 preRenderedResult = clamp(ambientLight(clamp(colorized, 0., 1.)*intensity, uv, posLight-vec2(0.5,0.5)),0.,1.);
    vec4 final = vec4(preRenderedResult.rgb * hideAlpha, 1.);

    if (alphaDiscard && all(lessThanEqual(final.rgb,vec3(discardThreshold)))) {
        if (pixel.a == 0.) discard;
        else {
            gl_FragColor = pixel;
            return;
        }
    }

    gl_FragColor =
            r > 1.0
                ? pixel*(1.-a)
                : (pixel.a < 1. 
                        ? mix( blenderVec3(13, pixel, final), blenderVec3(blend, pixel, final), pixel.a)
                        : blenderVec3(blend, pixel, final) * a);
}
`;






class $7eae9962e69f7347$export$8353bd967bf6b04d extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, lightAlpha: lightAlpha, blend: blend, shieldType: shieldType, posLightX: posLightX, posLightY: posLightY, lightSize: lightSize, scale: scale, intensity: intensity, radius: radius, hideRadius: hideRadius, chromatic: chromatic, discardThreshold: discardThreshold, alphaDiscard: alphaDiscard } = Object.assign({}, $7eae9962e69f7347$export$8353bd967bf6b04d.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $98647ce0a9afc699$export$74eae7f690aa2952));
        this.uniforms.color = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.posLight = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            lightAlpha: lightAlpha,
            blend: blend,
            shieldType: shieldType,
            posLightX: posLightX,
            posLightY: posLightY,
            lightSize: lightSize,
            scale: scale,
            intensity: intensity,
            radius: radius,
            hideRadius: hideRadius,
            chromatic: chromatic,
            discardThreshold: discardThreshold,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 2000;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get lightAlpha() {
        return this.uniforms.lightColorAlpha;
    }
    set lightAlpha(value) {
        this.uniforms.lightColorAlpha = value;
    }
    get shieldType() {
        return this.uniforms.shieldType;
    }
    set shieldType(value) {
        this.uniforms.shieldType = Math.floor(value);
    }
    get posLightX() {
        return this.uniforms.posLight[0];
    }
    set posLightX(value) {
        this.uniforms.posLight[0] = value;
    }
    get posLightY() {
        return this.uniforms.posLight[1];
    }
    set posLightY(value) {
        this.uniforms.posLight[1] = value;
    }
    get lightSize() {
        return this.uniforms.lightSize;
    }
    set lightSize(value) {
        this.uniforms.lightSize = value;
    }
    get scale() {
        return this.uniforms.scale;
    }
    set scale(value) {
        this.uniforms.scale = value;
    }
    get intensity() {
        return this.uniforms.intensity;
    }
    set intensity(value) {
        this.uniforms.intensity = value;
    }
    get radius() {
        return this.uniforms.radius;
    }
    set radius(value) {
        this.uniforms.radius = value;
    }
    get hideRadius() {
        return this.uniforms.hideRadius;
    }
    set hideRadius(value) {
        this.uniforms.hideRadius = value;
    }
    get discardThreshold() {
        return this.uniforms.discardThreshold;
    }
    set discardThreshold(value) {
        this.uniforms.discardThreshold = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
    get chromatic() {
        return this.uniforms.chromatic;
    }
    set chromatic(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.chromatic = value;
    }
}
$7eae9962e69f7347$export$8353bd967bf6b04d.defaults = {
    time: 0,
    color: 0xbbbbbb,
    lightAlpha: 1.0,
    blend: 2,
    shieldType: 1,
    posLightX: 0.65,
    posLightY: 0.25,
    lightSize: 0.483,
    scale: 1,
    intensity: 1,
    radius: 1,
    hideRadius: 0,
    chromatic: false,
    discardThreshold: 0.25,
    alphaDiscard: false
};


const $1896fe3fb3382f00$export$29635fcc44af7f32 = `
precision mediump float;

uniform float time;
uniform float alphaImg;
uniform float alphaChr;
uniform float ampX;
uniform float ampY;
uniform int blend;
uniform int nbImage;
uniform sampler2D uSampler;
uniform vec4 inputClamp;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

const float PI = 3.14159265;

float bornedCos(float mi, float ma) {
    return (ma-mi)*(cos(2.*PI*time*0.2+1.)*0.5)+mi;
}

float bornedSin(float mi, float ma) {
    return (ma-mi)*(sin(2.*PI*time*0.2+1.)*0.5)+mi;
}

vec4 blender(int blend, vec4 fCol, vec4 sCol)
{
    if ( blend == 1) { fCol.rgb = fCol.rgb * sCol.rgb; }
    else if (blend == 2) { fCol.rgb = (1. - (1. - fCol.rgb) * (1. - sCol.rgb)); }
    else if (blend == 3) { fCol.rgb = min(fCol.rgb, sCol.rgb); }
    else if (blend == 4) { fCol.rgb = max(fCol.rgb, sCol.rgb); }
    else if (blend == 5) { fCol.rgb = abs(fCol.rgb - sCol.rgb); }
    else if (blend == 6) { fCol.rgb = 1. - abs(1. - fCol.rgb - sCol.rgb); }
    else if (blend == 7) { fCol.rgb = fCol.rgb + sCol.rgb - (2. * fCol.rgb * sCol.rgb); }
    else if (blend == 8) { fCol.rgb = all(lessThanEqual(fCol.rgb, vec3(0.5, 0.5, 0.5))) ? (2. * fCol.rgb * sCol.rgb) : (1. - 2. * (1. - fCol.rgb) * (1. - sCol.rgb)); }
    else if (blend == 9) { fCol.rgb = all(lessThanEqual(sCol.rgb, vec3(0.5, 0.5, 0.5))) ? (2. * fCol.rgb * sCol.rgb) : (1. - 2. * (1. - fCol.rgb) * (1. - sCol.rgb)); }
    else if (blend == 10) { fCol.rgb = all(lessThanEqual(sCol.rgb, vec3(0.5, 0.5, 0.5))) ? (2. * fCol.rgb * sCol.rgb + fCol.rgb * fCol.rgb * (1. - 2. * sCol.rgb)) : sqrt(fCol.rgb) * (2. * sCol.rgb - 1.) + (2. * fCol.rgb) * (1. - sCol.rgb); }
    else if (blend == 11) { fCol.rgb = fCol.rgb / (1.0 - sCol.rgb); }
    else if (blend == 12) { fCol.rgb = 1.0 - (1.0 - fCol.rgb) / (sCol.rgb)+0.001; }
    else if (blend == 13) { fCol.rgb = fCol.rgb + sCol.rgb; }
    else if (blend == 14) { fCol.rgb = (max(fCol.rgb,sCol.rgb)-(min(fCol.rgb,sCol.rgb)))+abs(fCol.rgb-sCol.rgb);}
    else { fCol.rgb = clamp(fCol.rgb + sCol.rgb,0.,1.); }

    fCol.a = max(fCol.a,sCol.a);
    return fCol;
}

vec4 renderMirror(vec2 translation, vec4 prevpix)
{
    vec2 displaced = vTextureCoord + translation;
    return blender(blend, prevpix, 
                   texture2D(uSampler, clamp(displaced, inputClamp.xy, inputClamp.zw)));
}

void main() 
{
    float x = ampX * bornedCos(0.,1.);
    float y = ampY * bornedSin(0.,1.);
    vec4 renderedPixel;
    vec2 translation;

    if (nbImage >= 1) {
        translation = vec2(x,y);
        renderedPixel = texture2D(uSampler, clamp(vTextureCoord + translation, inputClamp.xy, inputClamp.zw));
    }
    if (nbImage >= 2) {
        translation = 0.90*vec2(-x,y*0.5);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    if (nbImage >= 3) {
        translation = 0.70*vec2(x,-y);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    if (nbImage >= 4) {
        translation = 0.80*vec2(-x*0.6,-y);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    if (nbImage >= 5) {
        translation = 1.20*vec2(-x,y*0.4);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    if (nbImage >= 6) {
        translation = 1.10*vec2(x,-y);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    if (nbImage >= 7) {
        translation = 0.6*vec2(-x*0.4,-y);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    if (nbImage >= 8) {
        translation = 1.3*vec2(-x,y*0.70);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    if (nbImage >= 9) {
        translation = vec2(x*0.5,y*0.85);
        renderedPixel = renderMirror(translation, renderedPixel);
    }
    renderedPixel = renderedPixel*alphaImg;
    gl_FragColor = blender(blend,texture2D(uSampler, vTextureCoord)*alphaChr , renderedPixel);
}
`;






class $8d8f4cc819ce08c5$export$7f3e808c6a96411c extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, blend: blend, alphaImg: alphaImg, alphaChr: alphaChr, nbImage: nbImage, ampX: ampX, ampY: ampY } = Object.assign({}, $8d8f4cc819ce08c5$export$7f3e808c6a96411c.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $1896fe3fb3382f00$export$29635fcc44af7f32));
        Object.assign(this, {
            time: time,
            blend: blend,
            alphaImg: alphaImg,
            alphaChr: alphaChr,
            nbImage: nbImage,
            ampX: ampX,
            ampY: ampY
        });
        this.zOrder = 100;
        this.autoFit = false;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get alphaImg() {
        return this.uniforms.alphaImg;
    }
    set alphaImg(value) {
        this.uniforms.alphaImg = value;
    }
    get alphaChr() {
        return this.uniforms.alphaChr;
    }
    set alphaChr(value) {
        this.uniforms.alphaChr = value;
    }
    get nbImage() {
        return this.uniforms.nbImage;
    }
    set nbImage(value) {
        this.uniforms.nbImage = Math.floor(value);
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get ampX() {
        return this.uniforms.ampX;
    }
    set ampX(value) {
        this.uniforms.ampX = value;
    }
    get ampY() {
        return this.uniforms.ampY;
    }
    set ampY(value) {
        this.uniforms.ampY = value;
    }
}
$8d8f4cc819ce08c5$export$7f3e808c6a96411c.defaults = {
    time: 0,
    blend: 4,
    alphaImg: 0.5,
    alphaChr: 1.0,
    nbImage: 4,
    ampX: 0.15,
    ampY: 0.15
};


const $cf403162ff153641$export$b460b340f858a038 = `
precision mediump float;
precision mediump int;

uniform sampler2D uSampler;
uniform float time;
uniform float intensity;
uniform float divisor;
uniform int blend;
uniform vec2 dimensions;
uniform vec2 anchor;
uniform vec3 color;

varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

const float MU_TWOPI = 0.15915494309;
const float MU_PI5 = 1.59154943092;
const float MU_256 = 0.00390625;

vec4 blender(int blend, vec4 fColv4, vec4 sColv4)
{
    vec3 fCol = vec3(fColv4);
    vec3 sCol = vec3(sColv4);

    if ( blend <= 1) { fCol = fCol * sCol; }
    else if (blend == 2) { fCol = (1. - (1. - fCol) * (1. - sCol)); }
    else if (blend == 3) { fCol = min(fCol, sCol); }
    else if (blend == 4) { fCol = max(fCol, sCol); }
    else if (blend == 5) { fCol = abs(fCol - sCol); }
    else if (blend == 6) { fCol = 1. - abs(1. - fCol - sCol); }
    else if (blend == 7) { fCol = fCol + sCol - (2. * fCol * sCol); }
    else if (blend == 8) { fCol = all(lessThanEqual(fCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 9) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 10) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol + fCol * fCol * (1. - 2. * sCol)) : sqrt(fCol) * (2. * sCol - 1.) + (2. * fCol) * (1. - sCol); }
    else if (blend == 11) { fCol = fCol / (1.0 - sCol); }
    else if (blend == 12) { fCol = 1.0 - (1.0 - fCol) / sCol; }
    else if (blend == 13) { fCol = max(fCol,sCol)-(min(fCol,sCol)*0.5)+abs(fCol-sCol);}
    else if (blend >= 14) { fCol = fCol + sCol; }

    return vec4(fCol,fColv4.a);
}

void main() {

    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a==0.) {
       gl_FragColor = pixel;
       return;
    }

    vec2 uv = (vFilterCoord - anchor) / dimensions;

    float len = length(uv * 0.5);
   	float angle = atan(uv.x, uv.y) * MU_TWOPI;
    float beam = fract((angle) * divisor + sin((sqrt(len) * 0.2) - (time*0.5)));
    
    beam  = 2.* cos(beam * MU_PI5);
    beam *= floor(fract(angle * divisor + sin(time - (len * 1.2) * 0.2)) *256.) * MU_256;
    
    float fractburn = fract(beam);

    vec4 color1 = smoothstep(0.0, 1., (beam*(intensity*0.1) + pixel * vec4(color,1.)) / (fractburn == 0. ? fractburn+0.1 : fractburn) * 0.3 );
    vec4 result = blender(blend, pixel, color1);

    gl_FragColor = result*pixel.a;
}
`;






class $5b05583cddbffe38$export$a909c602e4f39889 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, divisor: divisor, intensity: intensity, blend: blend, anchorX: anchorX, anchorY: anchorY, dimX: dimX, dimY: dimY } = Object.assign({}, $5b05583cddbffe38$export$a909c602e4f39889.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $cf403162ff153641$export$b460b340f858a038));
        this.uniforms.color = new Float32Array([
            1.0,
            0.4,
            0.1
        ]);
        this.uniforms.anchor = new Float32Array([
            0.5,
            -1
        ]);
        this.uniforms.dimensions = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            divisor: divisor,
            intensity: intensity,
            blend: blend,
            anchorX: anchorX,
            anchorY: anchorY,
            dimX: dimX,
            dimY: dimY
        });
        this.zOrder = 130;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get divisor() {
        return this.uniforms.divisor;
    }
    set divisor(value) {
        this.uniforms.divisor = value;
    }
    get intensity() {
        return this.uniforms.intensity;
    }
    set intensity(value) {
        this.uniforms.intensity = value;
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get anchorX() {
        return this.uniforms.anchor[0];
    }
    set anchorX(value) {
        this.uniforms.anchor[0] = value;
    }
    get anchorY() {
        return this.uniforms.anchor[1];
    }
    set anchorY(value) {
        this.uniforms.anchor[1] = value;
    }
    get dimX() {
        return this.uniforms.dimensions[0];
    }
    set dimX(value) {
        this.uniforms.dimensions[0] = value;
    }
    get dimY() {
        return this.uniforms.dimensions[1];
    }
    set dimY(value) {
        this.uniforms.dimensions[1] = value;
    }
}
$5b05583cddbffe38$export$a909c602e4f39889.defaults = {
    time: 0.0,
    color: 0xff8010,
    divisor: 40,
    intensity: 0.1,
    blend: 8,
    anchorX: 0.5,
    anchorY: -1,
    dimX: 1,
    dimY: 1
};


const $aa280a975796e7bf$export$28b3a3501a7f949 = `
precision mediump float;
precision mediump int;

uniform sampler2D uSampler;
uniform mat3 filterMatrixInverse;
uniform float time;
uniform float intensity;
uniform float scale;
uniform int blend;
uniform bool spectral;
uniform bool alphaDiscard;
uniform vec3 color;

varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

#define PI 3.14159265359

#define NUM_OCTAVES 3

float rand(vec2 n) { 
	return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

float noise(vec2 p){
	vec2 ip = floor(p);
	vec2 u = fract(p);
	u = u*u*(3.0-2.0*u);
	
	float res = mix(
		mix(rand(ip),rand(ip+vec2(1.0,0.0)),u.x),
		mix(rand(ip+vec2(0.0,1.0)),rand(ip+vec2(1.0,1.0)),u.x),u.y);
	return res*res;
}

float fbm(vec2 x) {
	float v = 0.0;
	float a = 0.5;
	vec2 shift = vec2(100);
    mat2 rot = mat2(cos(0.5), sin(0.5), -sin(0.5), cos(0.50));
	for (int i = 0; i < NUM_OCTAVES; ++i) {
		v += a * noise(x);
		x = rot * x * 2.0 + shift;
		a *= 0.5;
	}
	return v;
}

vec4 blenderVec3(int blend, vec4 fColv4, vec3 sCol)
{
    vec3 fCol = vec3(fColv4);
    if ( blend == 1) { fCol = fCol * sCol; }
    else if (blend == 2) { fCol = (1. - (1. - fCol) * (1. - sCol)); }
    else if (blend == 3) { fCol = min(fCol, sCol); }
    else if (blend == 4) { fCol = max(fCol, sCol); }
    else if (blend == 5) { fCol = abs(fCol - sCol); }
    else if (blend == 6) { fCol = 1. - abs(1. - fCol - sCol); }
    else if (blend == 7) { fCol = fCol + sCol - (2. * fCol * sCol); }
    else if (blend == 8) { fCol = all(lessThanEqual(fCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 9) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol) : (1. - 2. * (1. - fCol) * (1. - sCol)); }
    else if (blend == 10) { fCol = all(lessThanEqual(sCol, vec3(0.5, 0.5, 0.5))) ? (2. * fCol * sCol + fCol * fCol * (1. - 2. * sCol)) : sqrt(fCol) * (2. * sCol - 1.) + (2. * fCol) * (1. - sCol); }
    else if (blend == 11) { fCol = fCol / (1.0 - sCol + 0.00001); }
    else if (blend == 12) { fCol = 1.0 - (1.0 - fCol) / sCol + 0.00001; }
    else if (blend == 13) { fCol = max(fCol,sCol)-(min(fCol,sCol)*0.5)+abs(fCol-sCol);}
    else if (blend >= 14) { fCol = fCol + sCol; }
    
    return vec4(fCol,fColv4.a);
}

void main() {
    
    float distortion1 = fbm( 
        vec2( fbm(  vFilterCoord * 2.5 * scale + time*0.5),
              fbm( (-vFilterCoord - vec2(0.01)) * 5. * scale + time*0.3333334) )
                    );
    
    float distortion2 = fbm( 
        vec2( fbm( -vFilterCoord * 5. * scale + time*0.5),
              fbm(  (vFilterCoord + vec2(0.01)) * 2.5 * scale + time*0.3333334) )
                    );
    
    vec2 uv = vFilterCoord;
    
    uv.x += 0.8*sin(min(distortion1*0.25,distortion2*0.25));
    uv.y += 0.8*cos(min(distortion1*0.25,distortion2*0.25));
    uv *= 1. + 0.11*(cos(sqrt(max(distortion1, distortion2))+1.)*0.5);
    uv -= vec2(0.036,0.81); 

    vec2 mappedCoord = (filterMatrixInverse * vec3(uv, 1.0)).xy;
    
    vec4 pixel = texture2D(uSampler, mappedCoord);
    vec3 aColor = color;
    if (alphaDiscard) aColor.rgb *= mix(distortion1,distortion2,0.5);
    else aColor.rgb *= min(distortion1,distortion2);
    pixel.rgb += aColor*intensity;

    float a = pixel.a;

    if (spectral) pixel.a = max(distortion1,distortion2)*3.75;
    if (alphaDiscard && all(lessThanEqual(pixel.rgb,vec3(0.50)))) discard;

    gl_FragColor = blenderVec3(blend,pixel,color*0.3333334) * min(pixel.a,a);
}
`;






class $34c9aecbf210823d$export$76689802e4398e92 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, scale: scale, intensity: intensity, blend: blend, spectral: spectral, alphaDiscard: alphaDiscard } = Object.assign({}, $34c9aecbf210823d$export$76689802e4398e92.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $aa280a975796e7bf$export$28b3a3501a7f949));
        this.uniforms.color = new Float32Array([
            0.1,
            0.45,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            scale: scale,
            intensity: intensity,
            blend: blend,
            spectral: spectral,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 180;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get scale() {
        return this.uniforms.scale;
    }
    set scale(value) {
        this.uniforms.scale = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get intensity() {
        return this.uniforms.intensity;
    }
    set intensity(value) {
        this.uniforms.intensity = value;
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get spectral() {
        return this.uniforms.spectral;
    }
    set spectral(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.spectral = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
}
$34c9aecbf210823d$export$76689802e4398e92.defaults = {
    time: 0.0,
    color: 0x0595ff,
    scale: 1,
    intensity: 5,
    blend: 4,
    spectral: false,
    alphaDiscard: false
};


const $c1ccb9766e079f8c$export$7d6ef12f70fa5332 = `
precision mediump float;

uniform sampler2D uSampler;
uniform float time;
uniform float scale;
uniform float auraIntensity;
uniform float subAuraIntensity;
uniform float threshold;
uniform int auraType;
uniform bool holes;
uniform vec2 thickness;
uniform vec4 color;
uniform vec4 inputSize;
uniform vec4 inputClamp;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

const int NUM_OCTAVES = 4;
const float PI = 3.14159265358;
const float TWOPI = 6.28318530717;
const float MAX_TOTAL_ALPHA = 17.2787595915;

float rand(vec2 uv)
{
    return fract(sin(dot(uv.xy ,vec2(12.9898,78.233))) * 43758.5453);
}

float noise(vec2 p)
{
	vec2 ip = floor(p);
	vec2 u = fract(p);
	u = u*u*(3.0-2.0*u);
	
	float res = mix(
		mix(rand(ip),rand(ip+vec2(1.0,0.0)),u.x),
		mix(rand(ip+vec2(0.0,1.0)),rand(ip+vec2(1.0,1.0)),u.x),u.y);
	return res*res;
}

float fbm(vec2 x) 
{
	float v = 0.0;
	float a = 0.5;
	vec2 shift = vec2(100);
    mat2 rot = mat2(cos(0.5), sin(0.5), -sin(0.5), cos(0.50));
	for (int i = 0; i < NUM_OCTAVES; ++i) {
		v += a * noise(x);
		x = rot * x * 2.0 + shift;
		a *= 0.5;
	}
	return v;
}

vec4 outlining() 
{
    vec4 ownColor = texture2D(uSampler, vTextureCoord);
    vec4 curColor;
    float maxAlpha = 0.;
    vec2 displaced;
    for (float angle = 0.; angle <= TWOPI; angle += 0.3141592653) {
        displaced.x = vTextureCoord.x + thickness.x * cos(angle);
        displaced.y = vTextureCoord.y + thickness.y * sin(angle);
        curColor = texture2D(uSampler, clamp(displaced, inputClamp.xy, inputClamp.zw));
        maxAlpha = max(maxAlpha, curColor.a);
    }
    float resultAlpha = max(maxAlpha, ownColor.a);
    return vec4((ownColor.rgb + color.rgb * (1. - ownColor.a)) * resultAlpha, resultAlpha);

}

vec4 glowing() 
{
	vec2 px = inputSize.zw;

    float totalAlpha = 0.0;
    float outerStrength = 6.;

    vec2 direction;
    vec2 displaced;
    vec4 curColor;

    for (float angle = 0.0; angle < TWOPI; angle += 0.3141592653) {
       direction = vec2(cos(angle), sin(angle)) * px;

       for (float curDistance = 0.0; curDistance < 10.; curDistance++) {
           displaced = clamp(vTextureCoord + direction * 
                   (curDistance + 1.0), inputClamp.xy, inputClamp.zw);

           curColor = texture2D(uSampler, displaced);
           totalAlpha += (10. - curDistance) * curColor.a;
       }
    }
    
    curColor = texture2D(uSampler, vTextureCoord);

    float alphaRatio = (totalAlpha / MAX_TOTAL_ALPHA);
    float outerGlowAlpha = alphaRatio * outerStrength * (1. - curColor.a);
    float outerGlowStrength = min(1.0 - curColor.a, outerGlowAlpha);

    vec4 outerGlowColor = (outerGlowStrength * (color.rgba*0.1) );

    float resultAlpha = outerGlowAlpha;
    return vec4(color.rgb * resultAlpha, resultAlpha);
}

vec4 ripples(vec2 suv) 
{
    suv.x += time/2.;
    vec3 c1 = ( 0.0 ) * (color.rgb*10.);
    vec3 c2 = vec3(c1);
    vec3 c3 = vec3(c1);
    vec3 c4 = vec3( color.r*5., color.g*3.3333, color.b*2. );
    vec3 c5 = vec3(c3);
    vec3 c6 = vec3(c1);
    vec2 p = suv;
    float q = 2.*fbm(p + time*0.2);
    vec2 r = vec2(fbm(p + q + ( time*0.1  ) - p.x - p.y), fbm(p + p + ( time*0.1 )));
    vec3 c = color.rgb * (
        mix( c1, c2, fbm( p + r ) ) + mix( c3, c4, r.x ) - mix( c5, c6, r.y )
    );
    return vec4(c,1.);
}

vec4 noisy(vec2 suv)
{
    vec4 noiseColor;
    noiseColor.rgb = (color.rgb * noise(suv + fbm(suv) + time));
    noiseColor.a = 1.;
    return clamp(noiseColor,0.,1.);
}

void main(void) 
{

    vec4 pixel = texture2D(uSampler,vTextureCoord);

    if (pixel.a == 1.) {
        gl_FragColor =  pixel;
    } else {
        vec4 glowlevel = glowing();
        vec4 outlinelevel = outlining();
        vec4 aura;
        
        if (auraType <= 1) {
            aura = ripples(vFilterCoord*20.*scale);
        } else {
            aura = noisy(vFilterCoord*20.*scale);
        }

        vec4 effect;
        effect = ((glowlevel*subAuraIntensity)*0.1) + ((outlinelevel*auraIntensity)*0.8);

        if (effect.a >= 0.) {effect.rgb = aura.rgb*(max(effect.a,0.));}

        float intensity = effect.r + effect.g + effect.b;
	    if(intensity < threshold && effect.a != 0.) {
            if (holes) {discard;}
            effect.rgb = (color.rgb)*(effect.a*0.5);
        } 

        gl_FragColor =  pixel + effect * (1.-pixel.a);
    }
}
`;






class $4130c396ef8a0d82$export$dbf4d88a9f2fd9e6 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, thickness: thickness, scale: scale, auraIntensity: auraIntensity, subAuraIntensity: subAuraIntensity, discard: discard, threshold: threshold, auraType: auraType } = Object.assign({}, $4130c396ef8a0d82$export$dbf4d88a9f2fd9e6.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $c1ccb9766e079f8c$export$7d6ef12f70fa5332));
        this.uniforms.color = new Float32Array([
            1.0,
            0.4,
            0.1,
            1.0
        ]);
        this.uniforms.thickness = new Float32Array([
            0.01,
            0.01
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            thickness: thickness,
            scale: scale,
            auraIntensity: auraIntensity,
            subAuraIntensity: subAuraIntensity,
            discard: discard,
            threshold: threshold,
            auraType: auraType
        });
        this.zOrder = 80;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get scale() {
        return this.uniforms.scale;
    }
    set scale(value) {
        this.uniforms.scale = value;
    }
    get auraIntensity() {
        return this.uniforms.auraIntensity;
    }
    set auraIntensity(value) {
        this.uniforms.auraIntensity = value;
    }
    get subAuraIntensity() {
        return this.uniforms.subAuraIntensity;
    }
    set subAuraIntensity(value) {
        this.uniforms.subAuraIntensity = value;
    }
    get threshold() {
        return this.uniforms.threshold;
    }
    set threshold(value) {
        this.uniforms.threshold = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get discard() {
        return this.uniforms.holes;
    }
    set discard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.holes = value;
    }
    get auraType() {
        return this.uniforms.auraType;
    }
    set auraType(value) {
        this.uniforms.auraType = Math.floor(value);
    }
    apply(filterManager, input, output, clear) {
        this.uniforms.thickness[0] = this.thickness * this.targetPlaceable.worldTransform.a / input._frame.width;
        this.uniforms.thickness[1] = this.thickness * this.targetPlaceable.worldTransform.a / input._frame.height;
        super.apply(filterManager, input, output, clear);
    }
}
$4130c396ef8a0d82$export$dbf4d88a9f2fd9e6.defaults = {
    time: 0,
    color: 0xff8010,
    thickness: 5,
    scale: 1,
    auraIntensity: 1,
    subAuraIntensity: 1,
    discard: false,
    threshold: 0.5,
    auraType: 1
};




class $9d7a67912a650eb7$export$26c3bdb8b50816cc extends PIXI.filters.PixelateFilter {
    constructor(params){
        super();
        this.enabled = false;
        this.animated = {};
        this.sizeX = 5;
        this.sizeY = 5;
        this.zOrder = 20;
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    handleTransform() {
        this.size.x = this.sizeX * this.targetPlaceable.worldTransform.a;
        this.size.y = this.sizeY * this.targetPlaceable.worldTransform.a;
    }
}


const $98979de687ff2ca3$export$ee64fcda6bb0a01b = `
precision mediump float;

uniform float time;
uniform float thickness;
uniform float div1;
uniform float div2;
uniform float tear;
uniform float amplitude;
uniform bool alphaDiscard;
uniform vec2 anchor;
uniform vec3 color;
uniform sampler2D uSampler;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

const float PI = 3.14159265358;

float random(vec2 n) 
{ 
	return fract(cos(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

float noise(vec2 n) 
{
	const vec2 d = vec2(0., 1.0);
	vec2 b = floor(n);
	vec2 f = smoothstep(vec2(0.), vec2(1.0), fract(n));
	return mix(mix(random(b), random(b + d.yx), f.x), 
	       mix(random(b + d.xy), random(b + d.yy), f.x), f.y);
}

float fbm(vec2 n) 
{
	float total = 0.0, amp = amplitude;
	for (int i = 0; i < 2; i++) {
		total += noise(n) * amp;
		n += n;
		amp *= 0.5;
	}
	return total;
}

vec4 spiderweb()
{
    vec2 coord = vFilterCoord.xy + anchor;

    float t = floor(time * 0.01) * 7.3962;

    vec2 sc = (coord.xy - 1.) * 0.5;
    float phi = atan(sc.y, sc.x + 1e-6);
    vec2 pc = vec2(fract(phi / (PI * 2.)), length(sc));
    
    float h_divnum = div1;
    float s_divnum = div2;
    
    float ddth = fbm(vec2(pc.x*h_divnum,pc.x*20.*pow(length(sc*0.5),2.))*3.);
    
    float h_rand = 0.3+0.0895*(0.1*cos(time)+010.9)*tear;
    float s_rand = .355*(0.2*cos(time)+1.);
    
    float l = pc.y+ cos(ddth*0.5) * (h_rand - 0.4) + ddth*(s_rand - 0.5)*0.2;
    
    float ts = 0.05;
    float a = smoothstep(abs(sin(( pc.x*PI*2.  )  * s_divnum) ),-.1,thickness * ts );
    float b = smoothstep(abs(sin(( pc.y*PI*2. + h_rand + l)  * h_divnum ) ),-.1,thickness * ts );
    float s = a*b*2.;
    float m = alphaDiscard ? 1. : 2.25;
    return vec4(color.rgb*m,2.)-vec4(s,s,s,1.);
}

void main() 
{
    vec4 pixel = texture2D(uSampler,vTextureCoord);
    vec4 result = max(spiderweb(),pixel)*pixel.a;
    if (alphaDiscard && result.rgb == vec3(0.)) discard;
    gl_FragColor = result;
}
`;






class $30e3cacecefea03b$export$be2f10404718dbad extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, anchorX: anchorX, anchorY: anchorY, color: color, thickness: thickness, div1: div1, div2: div2, tear: tear, amplitude: amplitude, alphaDiscard: alphaDiscard } = Object.assign({}, $30e3cacecefea03b$export$be2f10404718dbad.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $98979de687ff2ca3$export$ee64fcda6bb0a01b));
        this.uniforms.anchor = new Float32Array([
            0.5,
            -1
        ]);
        this.uniforms.color = new Float32Array([
            0.75,
            0.75,
            0.75
        ]);
        Object.assign(this, {
            time: time,
            anchorX: anchorX,
            anchorY: anchorY,
            color: color,
            thickness: thickness,
            div1: div1,
            div2: div2,
            tear: tear,
            amplitude: amplitude,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 260;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get anchorX() {
        return this.uniforms.anchor[0];
    }
    set anchorX(value) {
        this.uniforms.anchor[0] = 0.5;
    }
    get anchorY() {
        return this.uniforms.anchor[1];
    }
    set anchorY(value) {
        this.uniforms.anchor[1] = 0.5;
    }
    get thickness() {
        return this.uniforms.thickness;
    }
    set thickness(value) {
        this.uniforms.thickness = value;
    }
    get tear() {
        return this.uniforms.tear;
    }
    set tear(value) {
        this.uniforms.tear = value;
    }
    get amplitude() {
        return this.uniforms.amplitude;
    }
    set amplitude(value) {
        this.uniforms.amplitude = value;
    }
    get div1() {
        return this.uniforms.div1;
    }
    set div1(value) {
        this.uniforms.div1 = value;
    }
    get div2() {
        return this.uniforms.div2;
    }
    set div2(value) {
        this.uniforms.div2 = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
}
$30e3cacecefea03b$export$be2f10404718dbad.defaults = {
    time: 0.0,
    anchorX: 0.5,
    anchorY: 0.5,
    color: 0xbbbbbb,
    thickness: 1,
    div1: 10,
    div2: 10,
    tear: 0.54,
    amplitude: 0.8,
    alphaDiscard: false
};


const $2f78c4e175cbc874$export$ddb966d307e896d5 = `
precision mediump float;
precision mediump int;

uniform vec3 color;
uniform float time;
uniform float amplitude;
uniform float intensity;
uniform bool alphaDiscard;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;
uniform sampler2D uSampler;

#define PI 3.14159265
#define OCTAVES 3

float random(vec2 n) 
{ 
	return fract(cos(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

float bornedCos(float minimum, float maximum)
{
    return (maximum-minimum)*(cos(2.*PI*time*0.05 + 1.)*0.5)+minimum;
}

float bornedSin(float minimum, float maximum)
{
    return (maximum-minimum)*(sin(2.*PI*time*0.05 + 1.)*0.5)+minimum;
}

float noise(vec2 n) 
{
	const vec2 d = vec2(0.0, 1.0);
	vec2 b = floor(n);
	vec2 f = smoothstep(vec2(0.), vec2(1.0), fract(n));
	return mix(mix(random(b), random(b + d.yx), f.x), 
	       mix(random(b + d.xy), random(b + d.yy), f.x), f.y);
}

float fbm(vec2 n) 
{
	float total = 0.0, amp = amplitude;
	for (int i = 0; i < OCTAVES; i++) {
		total += noise(n) * amp;
		n += n;
		amp *= 0.5;
	}
	return total;
}

vec4 ripples(vec2 suv) 
{
    suv.x += time*0.5;
    vec3 c1 = color*intensity;
    vec3 c2 = vec3(0.);
    vec3 c3 = vec3(c1);
    vec3 c4 = vec3(color.r*3.333, color.g*3.333, color.b*3.333);
    vec3 c5 = vec3(c3);
    vec3 c6 = vec3(c1);
    vec2 p = suv;
    float q = 2. * fbm(p + time * 2.);
    vec2 r = vec2(fbm(p + q + ( time  ) - p.x - p.y), fbm(p + p + ( time )));
    r.x += bornedCos(-0.3,-0.2);
    r.y += 200.*bornedSin(-1.9,1.9);
    
    vec3 c = color * (
        mix( c1, c2, fbm( p + r ) ) + mix( c3, c4, r.x ) - mix( c5, c6, r.y )
    );
    return vec4(c,1.);
}

void main() {

    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a==0.) {
       gl_FragColor = pixel;
       return;
    }

    vec4 result = max(ripples(15.* vFilterCoord),pixel);
    if (alphaDiscard && all(lessThanEqual(result.rgb,vec3(0.40)))) discard;
    gl_FragColor = result*pixel.a;
}
`;






class $5c475373f35e120f$export$3f7eb987d91438a2 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, amplitude: amplitude, intensity: intensity, alphaDiscard: alphaDiscard, _octaves: _octaves } = Object.assign({}, $5c475373f35e120f$export$3f7eb987d91438a2.defaults, params);
        if (typeof _octaves !== "number") _octaves = $5c475373f35e120f$export$3f7eb987d91438a2.defaults._octave;
        let fragment = (0, $2f78c4e175cbc874$export$ddb966d307e896d5).replace(`#define OCTAVES 3`, `#define OCTAVES ${_octaves}`);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), fragment);
        this.uniforms.color = new Float32Array([
            0.75,
            0.75,
            0.75
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            amplitude: amplitude,
            intensity: intensity,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 250;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get amplitude() {
        return this.uniforms.amplitude;
    }
    set amplitude(value) {
        this.uniforms.amplitude = value;
    }
    get intensity() {
        return this.uniforms.intensity;
    }
    set intensity(value) {
        this.uniforms.intensity = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
}
$5c475373f35e120f$export$3f7eb987d91438a2.defaults = {
    time: 0.0,
    color: 0xbbbbbb,
    amplitude: 1,
    intensity: 0.001,
    alphaDiscard: false,
    _octave: 3
};


const $f4c3c5d7c98dfcd4$export$59ce548d84b541a8 = `
precision mediump float;

uniform float time;
uniform float scale;
uniform float distortion;
uniform bool alphaDiscard;
uniform vec3 color;
uniform sampler2D uSampler;
varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

const float PI = 3.14159265358;

float rand(vec2 c)
{
	return fract( sin( dot( c.xy, vec2( 12.9898, 78.233 ) ) ) * 43758.5453 );
}

vec2 rand2(vec2 st)
{
    st = vec2( dot(st,vec2(127.1,311.7)),
              dot(st,vec2(269.5,183.3)) );
    return -1.0 + 2.0*fract(cos(st)*43758.5453123);
}

vec3 toGray(vec3 color)
{
  float average = (color.r + color.g + color.b)*0.3333333;
  return vec3(average, average, average);
}

vec3 colorize(vec3 grayscale, vec3 color)
{
    return (grayscale * color);
}

float noise (vec2 st) 
{
    vec2 i = floor(st);
    vec2 f = fract(st);

    vec2 u = f*f*(3.0-2.0*f);

    return mix( mix( dot( rand2(i + vec2(0.0,0.0) ), f - vec2(0.0,0.0) ),
                     dot( rand2(i + vec2(1.0,0.0) ), f - vec2(1.0,0.0) ), u.x),
                mix( dot( rand2(i + vec2(0.0,1.0) ), f - vec2(0.0,1.0) ),
                     dot( rand2(i + vec2(1.0,1.0) ), f - vec2(1.0,1.0) ), u.x), u.y);
}

float circle(vec2 pos, float radius, float glow)
{
    float sdf = length(pos);
    sdf = smoothstep(radius-0.700,radius,sdf);
    float circles = 1.0 - smoothstep(0.0,1.0,sdf*1.280);
    float glows = exp(-sdf*4.496) * glow * (3.0 - circles);
    return circles+glows;
}

vec4 globes()
{
    vec2 st = (vFilterCoord - 0.5);
    st *= scale;
    vec2 uv = st;
    float noisest = noise(vec2(uv.x - time,uv.y - time));
    uv += noisest*distortion;
    uv -= vec2( noise(vec2(time)*0.2)*4.0,-time*0.01);
    
    vec3 color = vec3(0.);
    
    
    vec2 pos = fract(uv)-0.5;
    vec2 id = floor(uv);

    
    for(int y = -1; y <= 1; y++){
        for(int x = -1; x <= 1; x++){
            vec2 neighbour = vec2(x,y);
            vec2 rand2 = rand2(id+neighbour);
            float a = noise(rand2+time*2.8);
            vec2 offset = 0.5*(sin(time + rand2*5.28))*2.2;
            float size = rand(id+neighbour)*0.75 + a*0.15;
            color += circle(pos-neighbour+offset,size,size*1.400)*0.143 * vec3(rand2.x*7.884,7.2,rand2.y*6.832);
        }
    }
    
    return vec4(color,1.0);
}

void main() {
    vec4 pixel = texture2D(uSampler,vTextureCoord);

    vec4 tinyGlobes = vec4(colorize(toGray(globes().rgb*1.5),color*1.5),1.);

    bool belowThreshold = all(lessThanEqual(tinyGlobes.rgb,vec3(0.6)));
    if (alphaDiscard && belowThreshold) discard;
    else if (belowThreshold) tinyGlobes = pixel;

    gl_FragColor = max(tinyGlobes,pixel)*pixel.a;
}
`;






class $6fa47e94e013e8e5$export$dd8c8c08b796f015 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, scale: scale, distortion: distortion, alphaDiscard: alphaDiscard } = Object.assign({}, $6fa47e94e013e8e5$export$dd8c8c08b796f015.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $f4c3c5d7c98dfcd4$export$59ce548d84b541a8));
        this.uniforms.color = new Float32Array([
            0.75,
            0.75,
            0.75
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            scale: scale,
            distortion: distortion,
            alphaDiscard: alphaDiscard
        });
        this.zOrder = 270;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get scale() {
        return this.uniforms.scale;
    }
    set scale(value) {
        this.uniforms.scale = value;
    }
    get distortion() {
        return this.uniforms.distortion;
    }
    set distortion(value) {
        this.uniforms.distortion = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
}
$6fa47e94e013e8e5$export$dd8c8c08b796f015.defaults = {
    time: 0.0,
    color: 0xaa3050,
    scale: 20,
    distortion: 0.25,
    alphaDiscard: false
};


const $d7e8f36ca079ac30$export$9bdad1ae37d738e0 = `
precision mediump float;

uniform float rotation;
uniform float twRadius;
uniform float twAngle;
uniform float bpRadius;
uniform float bpStrength;
uniform vec2 scale;
uniform vec2 translation;
uniform vec2 pivot;
uniform vec4 inputClamp;
uniform sampler2D uSampler;
uniform mat3 filterMatrixInverse;

varying vec2 vFilterCoord;

const float PI = 3.1415927;

vec2 morphing(in vec2 uv) {
    float dist = length(uv);

    // twist effect
    if (dist < twRadius) {
        float ratioDist = (twRadius - dist) / twRadius;
        float angleMod = ratioDist * ratioDist * twAngle;
        float s = sin(angleMod);
        float c = cos(angleMod);
        uv = vec2(uv.x * c - uv.y * s, uv.x * s + uv.y * c);
    }

    // bulge pinch effect
    if (dist < bpRadius) {
        float percent = dist / bpRadius;
        if (bpStrength > 0.) {
            uv *= mix(1.0, smoothstep(0., bpRadius / dist, percent), bpStrength * 0.75);
        } else {
            uv *= mix(1.0, pow(percent, 1.0 + bpStrength * 0.75) * bpRadius / dist, 1.0 - percent);
        }
    }

    return uv;
}

vec2 transform(in vec2 uv) {
    float angle = -(PI * rotation * 0.005555555555);
    uv -= pivot;
    uv *= mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
    uv *= mat2(scale.x, 0.0, 0.0, scale.y);
    uv = morphing(uv);
    uv += pivot;

    return uv;
}

void main() {
    vec2 uv = vFilterCoord + translation;
    uv = transform(uv);
    vec2 mappedCoord = (filterMatrixInverse * vec3(uv, 1.0)).xy;
    vec4 pixel = texture2D(uSampler,clamp(mappedCoord, inputClamp.xy, inputClamp.zw));
    gl_FragColor = pixel;
}
`;






class $5ae15acc2d1ee812$export$e8341be799357874 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { rotation: rotation, twRadiusPercent: twRadiusPercent, twAngle: twAngle, twRotation: twRotation, bpRadiusPercent: bpRadiusPercent, bpStrength: bpStrength, scale: scale, scaleX: scaleX, scaleY: scaleY, pivotX: pivotX, pivotY: pivotY, translationX: translationX, translationY: translationY } = Object.assign({}, $5ae15acc2d1ee812$export$e8341be799357874.defaults, params);
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $d7e8f36ca079ac30$export$9bdad1ae37d738e0));
        this.uniforms.scale = new Float32Array([
            1.0,
            1.0
        ]);
        this.uniforms.pivot = new Float32Array([
            0.5,
            0.5
        ]);
        this.uniforms.translation = new Float32Array([
            0.0,
            0.0
        ]);
        Object.assign(this, {
            rotation: rotation,
            twRadiusPercent: twRadiusPercent,
            twAngle: twAngle,
            twRotation: twRotation,
            bpRadiusPercent: bpRadiusPercent,
            bpStrength: bpStrength,
            scale: scale,
            scaleX: scaleX,
            scaleY: scaleY,
            pivotX: pivotX,
            pivotY: pivotY,
            translationX: translationX,
            translationY: translationY
        });
        this.zOrder = 1000;
        this.autoFit = false;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get rotation() {
        return this.uniforms.rotation;
    }
    set rotation(value) {
        this.uniforms.rotation = value;
    }
    get twRadiusPercent() {
        return this.uniforms.twRadius * 200;
    }
    set twRadiusPercent(value) {
        this.uniforms.twRadius = value / 200;
    }
    get twAngle() {
        return this.uniforms.twAngle;
    }
    set twAngle(value) {
        this.uniforms.twAngle = value;
    }
    get twRotation() {
        return this.uniforms.twAngle * (180 / Math.PI);
    }
    set twRotation(value) {
        this.uniforms.twAngle = value * (Math.PI / 180);
    }
    get bpRadiusPercent() {
        return this.uniforms.bpRadius * 200;
    }
    set bpRadiusPercent(value) {
        this.uniforms.bpRadius = value / 200;
    }
    get bpStrength() {
        return this.uniforms.bpStrength;
    }
    set bpStrength(value) {
        this.uniforms.bpStrength = value;
    }
    get scale() {
        // a little hack (we get only x)
        return this.uniforms.scale[0];
    }
    set scale(value) {
        this.uniforms.scale[1] = this.uniforms.scale[0] = value;
    }
    get scaleX() {
        return this.uniforms.scale[0];
    }
    set scaleX(value) {
        this.uniforms.scale[0] = value;
    }
    get scaleY() {
        return this.uniforms.scale[1];
    }
    set scaleY(value) {
        this.uniforms.scale[1] = value;
    }
    get pivotX() {
        return this.uniforms.pivot[0];
    }
    set pivotX(value) {
        this.uniforms.pivot[0] = value;
    }
    get pivotY() {
        return this.uniforms.pivot[1];
    }
    set pivotY(value) {
        this.uniforms.pivot[1] = value;
    }
    get translationX() {
        return this.uniforms.translation[0];
    }
    set translationX(value) {
        this.uniforms.translation[0] = value;
    }
    get translationY() {
        return this.uniforms.translation[1];
    }
    set translationY(value) {
        this.uniforms.translation[1] = value;
    }
}
$5ae15acc2d1ee812$export$e8341be799357874.defaults = {
    rotation: 0.0,
    twRadiusPercent: 0,
    twAngle: 0,
    bpRadiusPercent: 0,
    bpStrength: 0,
    scaleX: 1,
    scaleY: 1,
    pivotX: 0.5,
    pivotY: 0.5,
    translationX: 0,
    translationY: 0
};


const $dfbe319118a6cb9c$export$a55475809cca74a = `
precision mediump float;

uniform float time;
uniform float seed;
uniform float spread;
uniform float splashFactor;
uniform int blend;
uniform vec2 dimensions;
uniform vec2 anchor;
uniform vec3 color;
uniform bool cut;
uniform bool textureAlphaBlend;
uniform sampler2D uSampler;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

float random(vec2 n) 
{ 
	return fract(cos(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

vec4 blender(int blend, vec4 fCol, vec4 sCol)
{
    if ( blend == 1) { fCol.rgb = fCol.rgb * sCol.rgb; }
    else if (blend == 2) { fCol.rgb = (1. - (1. - fCol.rgb) * (1. - sCol.rgb)); }
    else if (blend == 3) { fCol.rgb = min(fCol.rgb, sCol.rgb); }
    else if (blend == 4) { fCol.rgb = max(fCol.rgb, sCol.rgb); }
    else if (blend == 5) { fCol.rgb = abs(fCol.rgb - sCol.rgb); }
    else if (blend == 6) { fCol.rgb = 1. - abs(1. - fCol.rgb - sCol.rgb); }
    else if (blend == 7) { fCol.rgb = fCol.rgb + sCol.rgb - (2. * fCol.rgb * sCol.rgb); }
    else if (blend == 8) { fCol.rgb = all(lessThanEqual(fCol.rgb, vec3(0.5, 0.5, 0.5))) ? (2. * fCol.rgb * sCol.rgb) : (1. - 2. * (1. - fCol.rgb) * (1. - sCol.rgb)); }
    else if (blend == 9) { fCol.rgb = all(lessThanEqual(sCol.rgb, vec3(0.5, 0.5, 0.5))) ? (2. * fCol.rgb * sCol.rgb) : (1. - 2. * (1. - fCol.rgb) * (1. - sCol.rgb)); }
    else if (blend == 10) { fCol.rgb = all(lessThanEqual(sCol.rgb, vec3(0.5, 0.5, 0.5))) ? (2. * fCol.rgb * sCol.rgb + fCol.rgb * fCol.rgb * (1. - 2. * sCol.rgb)) : sqrt(fCol.rgb) * (2. * sCol.rgb - 1.) + (2. * fCol.rgb) * (1. - sCol.rgb); }
    else if (blend == 11) { fCol.rgb = fCol.rgb / (1.0 - sCol.rgb); }
    else if (blend == 12) { fCol.rgb = 1.0 - (1.0 - fCol.rgb) / (sCol.rgb)+0.001; }
    else if (blend == 13) { fCol.rgb = fCol.rgb + sCol.rgb; }
    else if (blend == 14) { fCol.rgb = (max(fCol.rgb,sCol.rgb)-(min(fCol.rgb,sCol.rgb)))+abs(fCol.rgb-sCol.rgb);}
    else { fCol.rgb = clamp(fCol.rgb + sCol.rgb,0.,1.); }

    fCol.a = max(fCol.a,sCol.a);
    return fCol;
}

vec3 splash(vec2 g)
{
	vec2 uv = (12.*(2.*g-1.)*.2) / dimensions;

    float a = abs(atan(uv.x,uv.y) * splashFactor);   
	vec3 iuv = vec3(uv.x,uv.y,a);

	float cseed = sin(1.+fract(abs(random(vec2(seed*0.9854,seed*0.3541)))));
    vec3 uvw = iuv;

	iuv = 1. - abs(1. - mod(uvw - time*0.1, 2.));
	
    float initLen = length(iuv);
    float nLen = initLen;
    float tot = 0.;
    
    for (int i=0; i < 12; i++) 
	{
		iuv = abs(iuv) / (initLen*initLen) - cseed;
		nLen = length(iuv);
		tot += abs(nLen-initLen);
		initLen = nLen;
    }
    
    float fc = tot + 1.0;
	fc = 1.-smoothstep(fc, fc+1.9, spread/dot(uv,uv));
	
	return vec3(1.-fc)*color;
}

void main() {
    vec4 pixel = texture2D(uSampler,vTextureCoord);
    vec3 splashed = splash(vFilterCoord - anchor);

    if (splashed == vec3(0.0))
    {
        if (pixel.a > 0. && !cut)
        {
            gl_FragColor = pixel;
            return;
        }
        else if (cut) discard;
    }

    vec4 splashed4 = vec4(splashed,1.);
    vec4 blendResult = mix(blender(blend, pixel, splashed4),splashed4,1.-pixel.a);
    gl_FragColor = (textureAlphaBlend ? blendResult * pixel.a : blendResult);
}
`;






class $1737f68aeb781d93$export$df3de41f3315cb09 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, seed: seed, spread: spread, splashFactor: splashFactor, color: color, dimX: dimX, dimY: dimY, blend: blend, cut: cut, textureAlphaBlend: textureAlphaBlend, anchorX: anchorX, anchorY: anchorY } = Object.assign({}, $1737f68aeb781d93$export$df3de41f3315cb09.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $dfbe319118a6cb9c$export$a55475809cca74a));
        this.uniforms.color = new Float32Array([
            1.0,
            0.05,
            0.05
        ]);
        this.uniforms.dimensions = new Float32Array([
            1.0,
            1.0
        ]);
        this.uniforms.anchor = new Float32Array([
            0.0,
            0.0
        ]);
        Object.assign(this, {
            time: time,
            seed: seed,
            spread: spread,
            splashFactor: splashFactor,
            color: color,
            dimX: dimX,
            dimY: dimY,
            blend: blend,
            cut: cut,
            textureAlphaBlend: textureAlphaBlend,
            anchorX: anchorX,
            anchorY: anchorY
        });
        this.zOrder = 5;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get seed() {
        return this.uniforms.seed;
    }
    set seed(value) {
        this.uniforms.seed = value;
    }
    get spread() {
        return this.uniforms.spread;
    }
    set spread(value) {
        this.uniforms.spread = value;
    }
    get splashFactor() {
        return this.uniforms.splashFactor;
    }
    set splashFactor(value) {
        this.uniforms.splashFactor = value;
    }
    get dimX() {
        return this.uniforms.dimensions[0];
    }
    set dimX(value) {
        this.uniforms.dimensions[0] = value;
    }
    get dimY() {
        return this.uniforms.dimensions[1];
    }
    set dimY(value) {
        this.uniforms.dimensions[1] = value;
    }
    get anchorY() {
        return this.uniforms.anchor[1] + 0.5;
    }
    set anchorY(value) {
        this.uniforms.anchor[1] = value - 0.5;
    }
    get anchorX() {
        return this.uniforms.anchor[0] + 0.5;
    }
    set anchorX(value) {
        this.uniforms.anchor[0] = value - 0.5;
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get cut() {
        return this.uniforms.cut;
    }
    set cut(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.cut = value;
    }
    get textureAlphaBlend() {
        return this.uniforms.textureAlphaBlend;
    }
    set textureAlphaBlend(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.textureAlphaBlend = value;
    }
}
$1737f68aeb781d93$export$df3de41f3315cb09.defaults = {
    time: Math.random() * 2000,
    color: 0xf00505,
    seed: 0.1,
    spread: 5,
    splashFactor: 2,
    dimX: 1,
    dimY: 1,
    blend: 8,
    cut: false,
    textureAlphaBlend: false,
    anchorX: 0.5,
    anchorY: 0.5
};


const $fa5813b787142e29$export$981b7ede7b45eb87 = `#version 300 es
precision mediump float;

uniform float progress;
uniform float magnify;
uniform int type;
uniform vec4 inputClamp;
uniform vec4 inputClampTarget;
uniform sampler2D uSampler;
uniform sampler2D uSamplerTarget;
uniform mat3 filterMatrixInverse;

in vec2 vTextureCoord;
in vec2 vTextureCoordExtra;
in vec2 vFilterCoord;

out vec4 outputColor;

const float PI = 3.14159265358;

float getClip(vec2 uv) {
    return step(3.5,
       step(inputClampTarget.x, uv.x) +
       step(inputClampTarget.y, uv.y) +
       step(uv.x, inputClampTarget.z) +
       step(uv.y, inputClampTarget.w));
}

vec4 getFromColor(vec2 uv) {
    return texture(uSampler,clamp(uv,inputClamp.xy,inputClamp.zw));
}

vec4 getToColor(vec2 uv) {
    return texture(uSamplerTarget,clamp(uv,inputClampTarget.xy,inputClampTarget.zw))*getClip(uv);
}

float rand(vec2 co) {
  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
}

vec2 offset(float progress, float x, float theta, float str) {
    float shifty = str*progress*cos(10.0*(progress+x));
    return vec2(0, shifty);
}

vec2 roffset(float progress, float x, float theta, float str) {
    float shifty = (1.-progress)*str*progress*cos(10.0*(progress+x));
    return vec2(0, shifty);
}

float noise(vec2 co) {
    float a = 12.9898;
    float b = 78.233;
    float c = 43758.5453;
    float dt= dot(co.xy * progress, vec2(a, b));
    float sn= mod(dt,3.14);
    return fract(sin(sn) * c);
}

vec4 morph(vec2 uv, vec2 uvt) {
    vec4 ca = getFromColor(uv);
    vec4 cb = getToColor(uvt);
    vec2 oa = (((ca.rg+ca.b)*0.5)*2.0-1.0);
    vec2 ob = (((cb.rg+cb.b)*0.5)*2.0-1.0);
    vec2 oc = mix(oa,ob,0.5)*0.1;
    float w0 = progress;
    float w1 = 1.0-w0;
    vec2 sourceMappedCoord = (filterMatrixInverse * vec3(vFilterCoord+(oc*0.4)*w0, 1.0)).xy;
    vec4 fromcol = getFromColor(sourceMappedCoord);
    vec4 tocol = getToColor(uvt-oc*w1);
    float a = mix(ca.a, cb.a, progress);
    return mix(fromcol, tocol, progress)*a;
}

vec4 waterdrop(vec2 uv, vec2 uvt) {
    vec2 dirt = uvt - vec2(.5);
    float distt = length(dirt);
    if (distt > progress) {
        return mix(getFromColor(uv), getToColor(uvt), progress);
    } else {
        vec2 shiftuvt = dirt * sin(distt * 60. - progress * 20.);
        vec2 fuv = (filterMatrixInverse * vec3(vFilterCoord + (shiftuvt*(1.-progress)), 1.0)).xy;
        return mix(getFromColor(fuv), getToColor(uvt + (shiftuvt*(1.-progress))), progress);
    }
}

vec4 dreamy(vec2 uv, vec2 uvt) {
    return mix(getFromColor(uv + offset(progress, uv.x, 0.0, 0.03)), 
               getToColor(uvt + offset(1.0-progress, uvt.x, 3.14, 0.03)), 
               progress);
}

vec2 swirluv(vec2 uv) {
    vec2 xy = 2.* uv - 1.;
    float fdist = length(xy);
    if (fdist > 1.) return uv;
    uv -= vec2( 0.5, 0.5 );
    float dist = length(uv);
    if ( dist < 1. ) {
	    float pct = (1. - dist);
	    float a = ( progress <= 0.5 ) ? mix( 0.0, 1.0, progress*2. ) : mix( 1.0, 0.0, (progress-0.5)*2. );
	    float t = pct * pct * a * 5.0 * 3.14159;
	    float s = sin( t );
	    float c = cos( t );
	    uv = vec2(dot(uv,vec2(c,-s)),dot(uv,vec2(s,c)));
    }
    uv += vec2(0.5,0.5);
    return uv;
}

vec4 swirl(vec2 uv, vec2 uvt) {
    vec2 suvfrom = swirluv(vFilterCoord);
    vec2 suvto = swirluv(uvt);
    vec2 sourceMappedCoord = (filterMatrixInverse * vec3(suvfrom, 1.0)).xy;
    vec4 fscol = getFromColor(sourceMappedCoord);
    vec4 ftcol = getToColor(suvto);
    return mix( fscol, ftcol, progress );
}

vec4 crosswarp(vec2 uv, vec2 uvt) {
    float x = progress;
    x = smoothstep(.0,1.0,(x*2.0+uv.x-1.0));
    vec4 rawfscol = getFromColor(uv);
    vec4 fscol = getFromColor((uv-.5)*(1.-x)+.5);
    vec4 ftcol = getToColor(uvt);
    return mix(fscol, ftcol, x)*mix(rawfscol.a,ftcol.a,progress);
}

vec4 tvnoise(vec2 uv, vec2 uvt) {
    vec4 noise = vec4(vec3(noise(uv)), 1.);
    vec4 fscol = getFromColor(uv);
    vec4 ftcol = getToColor(uvt);
    float alphamix = mix(fscol.a, ftcol.a, pow(clamp(progress,0.,1.), 0.6));
    if (progress <= 0.30) {
        return mix(fscol, noise*alphamix, pow(clamp(progress,0.,1.),0.3-progress));
    } else if (progress >= 0.70) {
        return mix(noise*alphamix, ftcol, pow(clamp(progress-0.7,0.,1.),1.-progress));
    } else {
        return noise*alphamix;
    }
}

vec4 hologram(vec2 uv, vec2 uvt) {
    float cosProg = 0.5*(cos(2.*PI*progress)+1.);
    vec4 fscol = getFromColor(uv + roffset(progress, uvt.x, 0., 0.12));
    vec4 ftcol = getToColor(uvt + roffset(progress, uvt.x, 0., 0.6));
  
    float scintensity = max(max(fscol.r,fscol.g),fscol.b);
    float tcintensity = max(max(ftcol.r,ftcol.g),ftcol.b);

    vec4 tscol = vec4(0.,fscol.g*3.,0.,1.)*scintensity;
    vec4 ttcol = vec4(ftcol.r*3.,0.,0.,1.)*tcintensity;
    
    vec4 iscol = vec4(0.,fscol.g*3.,fscol.b*3.,1.)*scintensity;
    vec4 itcol = vec4(ftcol.r*3.,0.,ftcol.b*3.,1.)*tcintensity;
    
    vec4 smix = mix(mix(fscol,tscol,progress),iscol,1.-cosProg);
    vec4 tmix = mix(mix(ftcol,ttcol,1.-progress),itcol,1.-cosProg);;

    return mix(smix, 
               tmix, 
               progress);
}

vec4 wind(vec2 uv, vec2 uvt) {
    float r = rand(vec2(0, uv.y));
    float m = smoothstep(0.0, -0.25, uv.x*0.75 + 0.25*r - (progress * 1.25));
    return mix(
        getFromColor(uv),
        getToColor(uvt),
        m
    );
}

vec4 transition(vec2 uv, vec2 uvt) {
    return mix(
        getFromColor(uv),
        getToColor(uvt),
        progress
    );
}

void main() {
    vec4 result;
    float scale = 1./magnify;
    vec2 uvExtra = vTextureCoordExtra;
    uvExtra -= vec2(0.5);
    uvExtra *= mat2(scale,0.,0.,scale);
    uvExtra += vec2(0.5);

    // shortcut to prevent a lot of computation if progress is equal to 0 or 1
    if (progress == 1.) {
        outputColor = getToColor(uvExtra);
        return;
    }

    if (progress == 0.) {
        outputColor = getFromColor(vTextureCoord);
        return;
    }

    if (type <= 1 || type >= 10) {
        result = transition(vTextureCoord, uvExtra);
    } else if (type == 2) {
        result = dreamy(vTextureCoord, uvExtra);
    } else if (type == 3) {
        result = swirl(vTextureCoord, uvExtra);
    } else if (type == 4) {
        result = waterdrop(vTextureCoord, uvExtra);
    } else if (type == 5) {
        result = tvnoise(vTextureCoord, uvExtra);
    } else if (type == 6) {
        result = morph(vTextureCoord, uvExtra);
    } else if (type == 7) {
        result = crosswarp(vTextureCoord, uvExtra);
    } else if (type == 8) {
        result = wind(vTextureCoord, uvExtra);
    } else if (type == 9) {
        result = hologram(vTextureCoord, uvExtra);
    } 
   
    outputColor = result;
}
`;


// Custom vertex shader with filter matrix to map for additional sampler
const $b20a995bbf43eef6$export$935bdd8d48f63a2e = `#version 300 es
precision mediump float;

in vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;
uniform mat3 targetUVMatrix;

out vec2 vTextureCoord;
out vec2 vTextureCoordExtra;
out vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vTextureCoordExtra = (targetUVMatrix * vec3(vTextureCoord, 1.0)).xy;
    vFilterCoord = (filterMatrix * vec3(vTextureCoord, 1.0)).xy;
}
`;






class $6d7cfa7b8cdebcda$export$cf7260b11c6fd85d extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { imagePath: imagePath, progress: progress, magnify: magnify, type: type } = Object.assign({}, $6d7cfa7b8cdebcda$export$cf7260b11c6fd85d.defaults, params);
        const targetSpriteMatrix = new PIXI.Matrix();
        // using specific vertex shader and fragment shader
        super((0, $b20a995bbf43eef6$export$935bdd8d48f63a2e), (0, $fa5813b787142e29$export$981b7ede7b45eb87));
        // vertex uniforms
        this.uniforms.targetUVMatrix = targetSpriteMatrix;
        // fragment uniforms
        this.uniforms.inputClampTarget = new Float32Array([
            0,
            0,
            0,
            0
        ]);
        // to store sprite matrix from the filter manager (and send to vertex)
        this.targetSpriteMatrix = targetSpriteMatrix;
        Object.assign(this, {
            imagePath: (0, $97b1237a45b106ea$export$3bebb302ab08af33)(imagePath),
            progress: progress,
            magnify: magnify,
            type: type
        });
        this.zOrder = 1;
        this.autoFit = false;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    setTMParams(params) {
        super.setTMParams(params);
        if (!this.dummy && "imagePath" in params) this.assignTexture();
    }
    get progress() {
        return this.uniforms.progress * 100;
    }
    set progress(value) {
        this.uniforms.progress = Math.min(Math.max(value * 0.01, 0), 1);
    }
    get magnify() {
        return this.uniforms.magnify;
    }
    set magnify(value) {
        this.uniforms.magnify = Math.min(Math.max(value, 0.1), 100);
    }
    get type() {
        return this.uniforms.type;
    }
    set type(value) {
        this.uniforms.type = Math.floor(value);
    }
    get uSamplerTarget() {
        return this.uniforms.uSamplerTarget;
    }
    set uSamplerTarget(value) {
        this.uniforms.uSamplerTarget = value;
    }
    _setTargetSpriteSize() {
        const sprite = this.targetSprite;
        let ratioW = this.placeableImg._texture.baseTexture.realWidth / sprite.texture.baseTexture.realWidth;
        sprite.width = sprite.texture.baseTexture.realWidth * ratioW;
        sprite.height = sprite.texture.baseTexture.realHeight * ratioW;
        sprite.anchor.set(0.5);
    }
    assignTexture() {
        if (this.hasOwnProperty("imagePath")) {
            let tex = PIXI.Texture.from(this.imagePath);
            let sprite = new PIXI.Sprite(tex);
            sprite.renderable = false;
            this.targetSprite = sprite;
            // We may need to wait for the texture to be loaded before accessing it's width and height
            // In such a case register an update listener which should be called when the texture is loaded/becomes valid
            if (tex.valid) this._setTargetSpriteSize();
            else tex.on("update", ()=>{
                this._setTargetSpriteSize();
            });
            this.uSamplerTarget = sprite._texture;
            this.placeableImg.addChild(sprite);
        }
    }
    // override
    apply(filterManager, input, output, clear) {
        const targetSprite = this.targetSprite;
        const tex = targetSprite._texture;
        if (tex.valid) {
            if (!tex.uvMatrix) tex.uvMatrix = new PIXI.TextureMatrix(tex, 0.0);
            tex.uvMatrix.update();
            this.uniforms.uSamplerTarget = tex;
            this.uniforms.targetUVMatrix = filterManager.calculateSpriteMatrix(this.targetSpriteMatrix, targetSprite).prepend(tex.uvMatrix.mapCoord);
            this.uniforms.inputClampTarget = tex.uvMatrix.uClampFrame;
        }
        super.apply(filterManager, input, output, clear);
    }
    // override
    destroy() {
        super.destroy();
        if (this.placeableImg) this.placeableImg.removeChild(this.targetSprite);
        this.targetSprite.destroy({
            children: true,
            texture: false,
            baseTexture: false
        });
    }
}
$6d7cfa7b8cdebcda$export$cf7260b11c6fd85d.defaults = {
    progress: 0,
    magnify: 1,
    type: 1
};


const $b43cf367df1e5bdb$export$3d2732364cd434b5 = `
precision mediump float;

uniform float time;
uniform float amplitude;
uniform float dispersion;
uniform float discardThreshold;
uniform int blend;
uniform bool alphaDiscard;
uniform bool chromatic;
uniform bool inlay;
uniform vec2 scale;
uniform vec3 color;
uniform vec3 color1;
uniform vec3 color2;
uniform vec3 color3;
uniform vec3 color4;

uniform sampler2D uSampler;
varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

const float MU_3 = 0.333333333334;

float rand(vec2 n) { 
	return fract(cos(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

float maxRgbIntensity(vec3 col) {
    return max(max(col.r,col.g),col.b);
}

float colorIntensity(vec3 col) {
    return clamp((col.r + col.g + col.b)*MU_3,0.,1.);
}

vec3 blendLinearDual(vec3 base, vec3 blend, float intensity) {
    if (intensity < dispersion) {
        return mix(base,blend,pow(abs((1.-dispersion)),clamp(10.*dispersion,1.,3.)));
    } 
    return mix(blend,mix(blend,base,1.-pow(intensity*dispersion,0.5)),1.-pow(intensity,4.));
}

vec3 blendScreen(vec3 base, vec3 blend, float intensity) {
    return vec3(1.)
            -((1.-base*(intensity+dispersion))
            *(1.-blend*clamp(pow(intensity,dispersion),0.,1.)));
}

float blendScreenPure(float base, float blend) {
	return 1.0-((1.0-base)*(1.0-blend));
}

vec3 blendScreenPure(vec3 base, vec3 blend) {
	return vec3(blendScreenPure(base.r,blend.r),blendScreenPure(base.g,blend.g),blendScreenPure(base.b,blend.b));
}

vec3 blendMix(vec3 base, vec3 blend) {
	return mix(blendLinearDual(base, blend, smoothstep(0.35,0.6,1.-colorIntensity(blend))),
	           blendScreen(base, blend, smoothstep(0.,1.,1.-colorIntensity(blend))),
	           smoothstep(0.,1.,colorIntensity((base+blend)*0.5)));
}

float blendColorBurn(float base, float blend) {
	return (blend==0.0)?blend:max((1.0-((1.0-base)/blend)),0.0);
}

vec3 blendColorBurn(vec3 base, vec3 blend) {
	return vec3(blendColorBurn(base.r,blend.r),blendColorBurn(base.g,blend.g),blendColorBurn(base.b,blend.b));
}

float blendColorDodge(float base, float blend) {
	return (blend==1.0)?blend:min(base/(1.0-blend),1.0);
}

vec3 blendColorDodge(vec3 base, vec3 blend) {
	return vec3(blendColorDodge(base.r,blend.r),blendColorDodge(base.g,blend.g),blendColorDodge(base.b,blend.b));
}

float blendVividLight(float base, float blend) {
	return (blend<0.5)?blendColorBurn(base,(2.0*blend)):blendColorDodge(base,(2.0*(blend-0.5)));
}

vec3 blendVividLight(vec3 base, vec3 blend) {
	return vec3(blendVividLight(base.r,blend.r),blendVividLight(base.g,blend.g),blendVividLight(base.b,blend.b));
}

vec4 blender(int blend, vec3 scol, vec3 tcol) {
    if (blend <= 1) {
        scol = mix(scol, tcol, smoothstep(dispersion, 1., maxRgbIntensity(tcol)));
    } else if (blend == 2) {
        scol = blendLinearDual(scol, tcol, maxRgbIntensity(tcol));
    } else if (blend == 3) {
        scol = blendLinearDual(scol, tcol, colorIntensity(tcol));
    } else if (blend == 4) {
        scol = blendScreen(scol, tcol, maxRgbIntensity(tcol));
    } else if (blend == 5) {
        scol = blendScreen(scol, tcol, colorIntensity(tcol));
    } else if (blend == 6) {
        scol = blendVividLight(scol,tcol);
    } else if (blend == 7) {
        scol = blendColorDodge(scol,tcol);
    } else if (blend == 8) {
        scol = blendColorBurn(scol,tcol);
    } else if (blend == 9) {
        scol = blendScreen(scol, blendVividLight(scol,tcol), colorIntensity(tcol));
    } else if (blend == 10) {
        scol = blendScreen(scol, blendColorDodge(scol,tcol), colorIntensity(tcol));
    } else if (blend == 11) {
        scol = blendLinearDual(blendVividLight(scol,tcol), tcol, maxRgbIntensity(tcol));
    } else if (blend == 12) {
        scol = blendMix(scol,tcol);
    } else if (blend == 13) {
        scol = blendScreenPure(scol,tcol);
    } else if (blend >= 14) {
        scol = blendScreenPure(scol,tcol*0.5);
    }

    return vec4(scol,1.);
}

float noise(vec2 n) {
	const vec2 d = vec2(0.0, 1.0);
	vec2 b = floor(n);
	vec2 f = smoothstep(vec2(0.), vec2(1.0), fract(n));
	return mix(mix(rand(b), rand(b + d.yx), f.x), 
	       mix(rand(b + d.xy), rand(b + d.yy), f.x), f.y);
}

float fbm(vec2 n) {
	float total = 0.0, amp = amplitude;
	for (int i = 0; i < 5; i++) {
		total += noise(n) * amp;
		n += n;
		amp *= 0.5;
	}
	return total;
}

vec3 fire(in vec4 pixel) {
    vec3 c1,c2,c3,c4;

    if (chromatic) {
        c1 = vec3(0.00, 0.50, 0.50);
    	c2 = vec3(0.60, 0.35, 0.70);
    	c3 = vec3(0.20, 0.90, 1.00);
    	c4 = vec3(0.90, 1.00, 0.60); 
    } else if ( any(greaterThan(color,vec3(0.))) ) {
        c1 = vec3(0.10*color);
    	c2 = vec3(0.85*color);
    	c3 = vec3(0.35*color);
    	c4 = vec3(color);
    } else {
        c1 = color1;
        c2 = color2;
        c3 = color3;
        c4 = color4;
    }

	const vec3 c5 = vec3(0.1);
	const vec3 c6 = vec3(0.9);
	const vec2 pivot = vec2(0.5);
	
    vec2 uv = vFilterCoord;
    uv -= pivot;
	vec2 p = uv * mat2(8.*scale.x,0.0,0.0,8.*scale.y);
	uv += pivot;

    vec2 r;
	vec3 c;
	float t = time*0.1;
	float q = fbm(p - t);

	if (inlay) {
	    float sat = pixel.r + pixel.g + pixel.b;
	    float sat4 = sat*4.;
	    r = vec2(fbm(p + q + t - p.x - p.y - sat), fbm(p + q - t + sat4));
	    c = mix(c1, c2, fbm(p + r + sat4)) + mix(c3, c4, 1.4-pixel.rgb) - mix(c5, c6, r.y);
	} else {
	    r = vec2(fbm(p + q + time - p.x - p.y), fbm(p + q - t));
	    c = mix(c1, c2, fbm(p + r)) + mix(c3, c4, r.x) - mix(c5, c6, r.y);
	}
	
	return clamp(c,0.,1.);
}

void main() {
    vec4 pixel = texture2D(uSampler, vTextureCoord);
    if (pixel.a==0.) {
       gl_FragColor = pixel;
       return;
    }

    vec3 fire = fire(pixel);
    if (alphaDiscard && all(lessThanEqual(fire,vec3(discardThreshold))))  {
        discard;
    }

    vec4 result = blender(blend, pixel.rgb, fire);

	gl_FragColor = result*pixel.a;
}
`;






class $792ddf9c96904ba5$export$f5292971f4ab78f9 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        let { time: time, color: color, color1: color1, color2: color2, color3: color3, color4: color4, amplitude: amplitude, dispersion: dispersion, blend: blend, scaleX: scaleX, scaleY: scaleY, alphaDiscard: alphaDiscard, discardThreshold: discardThreshold, chromatic: chromatic, inlay: inlay } = Object.assign({}, $792ddf9c96904ba5$export$f5292971f4ab78f9.defaults, params);
        // using specific vertex shader and fragment shader
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $b43cf367df1e5bdb$export$3d2732364cd434b5));
        this.uniforms.color = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.color1 = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.color2 = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.color3 = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.color4 = new Float32Array([
            1.0,
            1.0,
            1.0
        ]);
        this.uniforms.scale = new Float32Array([
            1.0,
            1.0
        ]);
        Object.assign(this, {
            time: time,
            color: color,
            color1: color1,
            color2: color2,
            color3: color3,
            color4: color4,
            amplitude: amplitude,
            dispersion: dispersion,
            blend: blend,
            scaleX: scaleX,
            scaleY: scaleY,
            alphaDiscard: alphaDiscard,
            discardThreshold: discardThreshold,
            chromatic: chromatic,
            inlay: inlay
        });
        this.zOrder = 145;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get time() {
        return this.uniforms.time;
    }
    set time(value) {
        this.uniforms.time = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get color1() {
        return PIXI.utils.rgb2hex(this.uniforms.color1);
    }
    set color1(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color1);
    }
    get color2() {
        return PIXI.utils.rgb2hex(this.uniforms.color2);
    }
    set color2(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color2);
    }
    get color3() {
        return PIXI.utils.rgb2hex(this.uniforms.color3);
    }
    set color3(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color3);
    }
    get color4() {
        return PIXI.utils.rgb2hex(this.uniforms.color4);
    }
    set color4(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color4);
    }
    get amplitude() {
        return this.uniforms.amplitude;
    }
    set amplitude(value) {
        this.uniforms.amplitude = value;
    }
    get dispersion() {
        return this.uniforms.dispersion;
    }
    set dispersion(value) {
        this.uniforms.dispersion = value;
    }
    get blend() {
        return this.uniforms.blend;
    }
    set blend(value) {
        this.uniforms.blend = Math.floor(value);
    }
    get scaleX() {
        return this.uniforms.scale[0];
    }
    set scaleX(value) {
        this.uniforms.scale[0] = value;
    }
    get scaleY() {
        return this.uniforms.scale[1];
    }
    set scaleY(value) {
        this.uniforms.scale[1] = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
    get discardThreshold() {
        return this.uniforms.discardThreshold;
    }
    set discardThreshold(value) {
        this.uniforms.discardThreshold = value;
    }
    get chromatic() {
        return this.uniforms.chromatic;
    }
    set chromatic(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.chromatic = value;
    }
    get inlay() {
        return this.uniforms.inlay;
    }
    set inlay(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.inlay = value;
    }
}
$792ddf9c96904ba5$export$f5292971f4ab78f9.defaults = {
    time: 0,
    color: 0x000000,
    color1: 0x250000,
    color2: 0xb20000,
    color3: 0x330000,
    color4: 0xffe500,
    amplitude: 1,
    dispersion: 0.25,
    blend: 2,
    scaleX: 1,
    scaleY: 1,
    discardThreshold: 0.1,
    alphaDiscard: false,
    chromatic: false,
    inlay: false
};


const $95d08043b744c79a$export$9f64abe9148df1d = `#version 300 es
precision mediump float;

uniform float rotation;
uniform float twRadius;
uniform float twAngle;
uniform float bpRadius;
uniform float bpStrength;
uniform float alpha;
uniform bool alphaDiscard;

uniform bool inverse;
uniform bool top;
uniform bool colorize;
uniform bool repeat;

uniform vec2 scale;
uniform vec2 translation;

uniform vec3 color;

uniform vec4 inputClamp;
uniform vec4 inputClampTarget;

uniform sampler2D uSampler;
uniform sampler2D uSamplerTarget;

in vec2 vTextureCoord;
in vec2 vTextureCoordExtra;
in vec2 vFilterCoord;
in mat3 vTargetUVMatrix;

out vec4 outputColor;

const float PI = 3.14159265358;

float getClip(in vec2 uv) {
    return step(3.5,
       step(inputClampTarget.x, uv.x) +
       step(inputClampTarget.y, uv.y) +
       step(uv.x, inputClampTarget.z) +
       step(uv.y, inputClampTarget.w));
}

vec2 morphing(in vec2 uv) {
    float dist = length(uv);

    // twist effect
    if (dist < twRadius) {
        float ratioDist = (twRadius - dist) / twRadius;
        float angleMod = ratioDist * ratioDist * twAngle;
        float s = sin(angleMod);
        float c = cos(angleMod);
        uv = vec2(uv.x * c - uv.y * s, uv.x * s + uv.y * c);
    }

    // bulge pinch effect
    if (dist < bpRadius) {
        float percent = dist / bpRadius;
        if (bpStrength > 0.) {
            uv *= mix(1.0, smoothstep(0., bpRadius / dist, percent), bpStrength * 0.75);
        } else {
            uv *= mix(1.0, pow(percent, 1.0 + bpStrength * 0.75) * bpRadius / dist, 1.0 - percent);
        }
    }

    return uv;
}

vec4 colorization(in vec4 col) {
    vec3 wcol = col.rgb;
    if (inverse) {
        wcol = (vec3(1.0) - wcol) * col.a;
    }
    float avg = (wcol.r + wcol.g + wcol.b) / 3.0;
    return vec4(vec3(color * avg), col.a);
}

vec2 transform(in vec2 uv) {
    float angle = -(PI * rotation * 0.005555555555);
    uv -= 0.5;
    uv *= mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
    uv *= mat2(1.0 / scale.x, 0.0, 0.0, 1.0 / scale.y);
    uv = morphing(uv);
    uv += 0.5;

    return uv;
}

vec4 getFromColor(in vec2 uv) {
    return texture(uSampler, clamp(uv, inputClamp.xy, inputClamp.zw));
}

vec4 getToColor(in vec2 uv) {
    return texture(uSamplerTarget, clamp(uv, inputClampTarget.xy, inputClampTarget.zw)) * getClip(uv);
}

vec4 getToColorFract(in vec2 uv) {
    return textureGrad(uSamplerTarget, fract(uv), dFdx(uv), dFdy(uv));
}

void main() {

    // UV transformations
    vec2 uvTex = transform(vTextureCoordExtra);

    // get samplers color
    vec4 icolor = getFromColor(vTextureCoord);

    vec4 tcolor;
    if(repeat) {
        tcolor = getToColorFract(uvTex + translation);
    } else {
        tcolor = getToColor(uvTex + translation);
    }

    tcolor.a *= alpha;
    if(alphaDiscard) tcolor = mix(tcolor, icolor, 1.0 - icolor.a);

    // colorize if necessary
    if (colorize) {
        tcolor = colorization(tcolor);
    }

    vec3 fcolor = tcolor.rgb;
    if(top && icolor.a > 0.) fcolor = mix(tcolor.rgb, icolor.rgb, 1.0 - tcolor.a);
    else if(!top) fcolor = mix(icolor.rgb, tcolor.rgb, 1.0 - icolor.a);
   
    outputColor = vec4(fcolor, max(tcolor.a, icolor.a));
}
`;







class $14ec92966e5a1c8e$export$96f9417ff369e52 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    tex = null;
    constructor(params){
        let { imagePath: imagePath, color: color, colorize: colorize, inverse: inverse, alpha: alpha, alphaDiscard: alphaDiscard, repeat: repeat, top: top, rotation: rotation, twRadiusPercent: twRadiusPercent, twAngle: twAngle, twRotation: twRotation, bpRadiusPercent: bpRadiusPercent, bpStrength: bpStrength, scale: scale, scaleX: scaleX, scaleY: scaleY, translationX: translationX, translationY: translationY, play: play, loop: loop, maintainAspectRatio: maintainAspectRatio, maintainScale: maintainScale } = Object.assign({}, $14ec92966e5a1c8e$export$96f9417ff369e52.defaults, params);
        const targetSpriteMatrix = new PIXI.Matrix();
        // using specific vertex shader and fragment shader
        super((0, $b20a995bbf43eef6$export$935bdd8d48f63a2e), (0, $95d08043b744c79a$export$9f64abe9148df1d));
        // vertex uniforms
        this.uniforms.targetUVMatrix = targetSpriteMatrix;
        // fragment uniforms
        this.uniforms.inputClampTarget = new Float32Array([
            0,
            0,
            0,
            0
        ]);
        this.uniforms.color = new Float32Array([
            0.0,
            0.0,
            0.0
        ]);
        this.uniforms.scale = new Float32Array([
            1.0,
            1.0
        ]);
        this.uniforms.translation = new Float32Array([
            0.0,
            0.0
        ]);
        // to store sprite matrix from the filter manager (and send to vertex)
        this.targetSpriteMatrix = targetSpriteMatrix;
        Object.assign(this, {
            imagePath: (0, $97b1237a45b106ea$export$3bebb302ab08af33)(imagePath),
            color: color,
            colorize: colorize,
            inverse: inverse,
            alpha: alpha,
            alphaDiscard: alphaDiscard,
            repeat: repeat,
            top: top,
            rotation: rotation,
            twRadiusPercent: twRadiusPercent,
            twAngle: twAngle,
            twRotation: twRotation,
            bpRadiusPercent: bpRadiusPercent,
            bpStrength: bpStrength,
            scale: scale,
            scaleX: scaleX,
            scaleY: scaleY,
            translationX: translationX,
            translationY: translationY,
            play: play,
            loop: loop,
            maintainAspectRatio: maintainAspectRatio,
            maintainScale: maintainScale
        });
        this.zOrder = 0;
        this.autoFit = false;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    setTMParams(params) {
        super.setTMParams(params);
        if (!this.dummy && "imagePath" in params) this.assignTexture();
    }
    _play = true;
    _loop = true;
    _maintainAspectRatio = false;
    _maintainScale = false;
    get play() {
        return this._play;
    }
    set play(value) {
        if (!(value == null) && typeof value === "boolean") {
            this._play = value;
            this._playVideo(this._play);
        }
    }
    get loop() {
        return this._loop;
    }
    set loop(value) {
        if (!(value == null) && typeof value === "boolean") {
            this._loop = value;
            this._playVideo(this._play);
        }
    }
    get maintainAspectRatio() {
        return this._maintainAspectRatio;
    }
    set maintainAspectRatio(value) {
        if (!(value == null) && typeof value === "boolean") this._maintainAspectRatio = value;
    }
    get maintainScale() {
        return this._maintainScale;
    }
    set maintainScale(value) {
        if (!(value == null) && typeof value === "boolean") this._maintainScale = value;
    }
    get color() {
        return PIXI.utils.rgb2hex(this.uniforms.color);
    }
    set color(value) {
        new PIXI.Color(value).toRgbArray(this.uniforms.color);
    }
    get colorize() {
        return this.uniforms.colorize;
    }
    set colorize(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.colorize = value;
    }
    get inverse() {
        return this.uniforms.inverse;
    }
    set inverse(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.inverse = value;
    }
    get alpha() {
        return this.uniforms.alpha;
    }
    set alpha(value) {
        this.uniforms.alpha = value;
    }
    get alphaDiscard() {
        return this.uniforms.alphaDiscard;
    }
    set alphaDiscard(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.alphaDiscard = value;
    }
    get repeat() {
        return this.uniforms.repeat;
    }
    set repeat(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.repeat = value;
    }
    get top() {
        return this.uniforms.top;
    }
    set top(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.top = value;
    }
    get rotation() {
        return this.uniforms.rotation;
    }
    set rotation(value) {
        this.uniforms.rotation = value;
    }
    get twRadiusPercent() {
        return this.uniforms.twRadius * 200;
    }
    set twRadiusPercent(value) {
        this.uniforms.twRadius = value / 200;
    }
    get twAngle() {
        return this.uniforms.twAngle;
    }
    set twAngle(value) {
        this.uniforms.twAngle = value;
    }
    get twRotation() {
        return this.uniforms.twAngle * (180 / Math.PI);
    }
    set twRotation(value) {
        this.uniforms.twAngle = value * (Math.PI / 180);
    }
    get bpRadiusPercent() {
        return this.uniforms.bpRadius * 200;
    }
    set bpRadiusPercent(value) {
        this.uniforms.bpRadius = value / 200;
    }
    get bpStrength() {
        return this.uniforms.bpStrength;
    }
    set bpStrength(value) {
        this.uniforms.bpStrength = value;
    }
    get scale() {
        // a little hack (we get only x)
        return this.uniforms.scale[0];
    }
    set scale(value) {
        this.uniforms.scale[1] = this.uniforms.scale[0] = value;
    }
    get scaleX() {
        return this.uniforms.scale[0];
    }
    set scaleX(value) {
        this.uniforms.scale[0] = value;
    }
    get scaleY() {
        return this.uniforms.scale[1];
    }
    set scaleY(value) {
        this.uniforms.scale[1] = value;
    }
    get translationX() {
        return this.uniforms.translation[0];
    }
    set translationX(value) {
        this.uniforms.translation[0] = value;
    }
    get translationY() {
        return this.uniforms.translation[1];
    }
    set translationY(value) {
        this.uniforms.translation[1] = value;
    }
    get uSamplerTarget() {
        return this.uniforms.uSamplerTarget;
    }
    set uSamplerTarget(value) {
        this.uniforms.uSamplerTarget = value;
    }
    async _playVideo(value) {
        // Play if baseTexture resource is a video
        if (this.tex) {
            const source = getProperty(this.tex, "baseTexture.resource.source");
            if (source && source.tagName === "VIDEO") {
                if (isNaN(source.duration)) await new Promise((resolve)=>{
                    source.onloadedmetadata = ()=>resolve();
                });
                if (value) game.video.play(source, {
                    loop: this._loop,
                    volume: 0
                });
                else game.video.stop(source);
            }
        }
    }
    assignTexture() {
        if (this.hasOwnProperty("imagePath")) {
            // Destroy the previous sprite
            if (this.targetSprite && !this.targetSprite.destroyed) this.targetSprite.destroy({
                children: true,
                texture: false,
                baseTexture: false
            });
            this.tex = PIXI.Texture.from(this.imagePath);
            let sprite = new PIXI.Sprite(this.tex);
            sprite.renderable = false;
            if (this.placeableImg._texture) {
                sprite.width = this.placeableImg._texture.baseTexture.realWidth;
                sprite.height = this.placeableImg._texture.baseTexture.realHeight;
                sprite.anchor.set(0.5);
            } else {
                sprite.width = this.placeableImg.width;
                sprite.height = this.placeableImg.height;
            }
            this.targetSprite = sprite;
            this.uSamplerTarget = sprite._texture;
            this.placeableImg.addChild(sprite);
            this._playVideo(this._play);
        }
    }
    // override
    apply(filterManager, input, output, clear) {
        const targetSprite = this.targetSprite;
        const tex = targetSprite._texture;
        if (tex.valid) {
            if (!tex.uvMatrix) tex.uvMatrix = new PIXI.TextureMatrix(tex, 0.0);
            tex.uvMatrix.update();
            this.uniforms.uSamplerTarget = tex;
            if (this.maintainScale) {
                let pScale = targetSprite.parent.scale;
                targetSprite.scale.set(1 / pScale.x, 1 / pScale.y);
            }
            let w = targetSprite.worldTransform;
            if (this.maintainAspectRatio) {
                let scale = Math.min(w.a, w.d);
                w.set(scale, w.b, w.c, scale, w.tx, w.ty);
            }
            this.uniforms.targetUVMatrix = filterManager.calculateSpriteMatrix(this.targetSpriteMatrix, targetSprite);
            this.uniforms.inputClampTarget = tex.uvMatrix.uClampFrame;
        }
        super.apply(filterManager, input, output, clear);
    }
    // override
    destroy() {
        super.destroy();
        if (!this.targetSprite.destroyed) this.targetSprite.destroy({
            children: true,
            texture: false,
            baseTexture: false
        });
    }
}
$14ec92966e5a1c8e$export$96f9417ff369e52.defaults = {
    color: 0x000000,
    colorize: false,
    inverse: false,
    alpha: 1,
    alphaDiscard: false,
    repeat: false,
    top: false,
    rotation: 0.0,
    twRadiusPercent: 0,
    twAngle: 0,
    bpRadiusPercent: 0,
    bpStrength: 0,
    scaleX: 1,
    scaleY: 1,
    translationX: 0,
    translationY: 0,
    play: true,
    loop: true,
    maintainAspectRatio: false,
    maintainScale: false
};


const $2b583b7eab61925d$export$3729c40aa34df6ff = `#version 300 es
precision mediump float;

uniform float rotation;
uniform float twRadius;
uniform float twAngle;
uniform float bpRadius;
uniform float bpStrength;
uniform float alpha;

uniform bool repeat;

uniform vec2 scale;
uniform vec2 translation;

uniform vec4 inputClamp;
uniform vec4 inputClampTarget;

uniform sampler2D uSampler;
uniform sampler2D uSamplerTarget;

in vec2 vTextureCoord;
in vec2 vTextureCoordExtra;
in vec2 vFilterCoord;
in mat3 vTargetUVMatrix;

out vec4 outputColor;

const float PI = 3.14159265358;

float getClip(in vec2 uv) {
    return step(3.5,
       step(inputClampTarget.x, uv.x) +
       step(inputClampTarget.y, uv.y) +
       step(uv.x, inputClampTarget.z) +
       step(uv.y, inputClampTarget.w));
}

vec2 morphing(in vec2 uv) {
    float dist = length(uv);

    // twist effect
    if (dist < twRadius) {
        float ratioDist = (twRadius - dist) / twRadius;
        float angleMod = ratioDist * ratioDist * twAngle;
        float s = sin(angleMod);
        float c = cos(angleMod);
        uv = vec2(uv.x * c - uv.y * s, uv.x * s + uv.y * c);
    }

    // bulge pinch effect
    if (dist < bpRadius) {
        float percent = dist / bpRadius;
        if (bpStrength > 0.) {
            uv *= mix(1.0, smoothstep(0., bpRadius / dist, percent), bpStrength * 0.75);
        } else {
            uv *= mix(1.0, pow(percent, 1.0 + bpStrength * 0.75) * bpRadius / dist, 1.0 - percent);
        }
    }

    return uv;
}

vec2 transform(in vec2 uv) {
    float angle = -(PI * rotation * 0.005555555555);
    uv -= 0.5;
    uv *= mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
    uv *= mat2(1.0 / scale.x, 0.0, 0.0, 1.0 / scale.y);
    uv = morphing(uv);
    uv += 0.5;

    return uv;
}

vec4 getFromColor(in vec2 uv) {
    return texture(uSampler, clamp(uv, inputClamp.xy, inputClamp.zw));
}

vec4 getToColor(in vec2 uv) {
    return texture(uSamplerTarget, clamp(uv, inputClampTarget.xy, inputClampTarget.zw)) * getClip(uv);
}

vec4 getToColorFract(in vec2 uv) {
    return textureGrad(uSamplerTarget, fract(uv), dFdx(uv), dFdy(uv));
}

void main() {

    // UV transformations
    vec2 uvTex = transform(vTextureCoordExtra);

    // get samplers color
    vec4 icolor = getFromColor(vTextureCoord);

    vec4 tcolor;
    if(repeat) tcolor = getToColorFract(uvTex + translation);
    else tcolor = getToColor(uvTex + translation);

    outputColor = icolor * (tcolor.a * alpha);
}
`;







class $756e6c880a697f93$export$4569ea13832ce134 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    tex = null;
    constructor(params){
        let { imagePath: imagePath, alpha: alpha, repeat: repeat, rotation: rotation, twRadiusPercent: twRadiusPercent, twAngle: twAngle, twRotation: twRotation, bpRadiusPercent: bpRadiusPercent, bpStrength: bpStrength, scale: scale, scaleX: scaleX, scaleY: scaleY, translationX: translationX, translationY: translationY, play: play, loop: loop, maintainAspectRatio: maintainAspectRatio, maintainScale: maintainScale } = Object.assign({}, $756e6c880a697f93$export$4569ea13832ce134.defaults, params);
        const targetSpriteMatrix = new PIXI.Matrix();
        // using specific vertex shader and fragment shader
        super((0, $b20a995bbf43eef6$export$935bdd8d48f63a2e), (0, $2b583b7eab61925d$export$3729c40aa34df6ff));
        // vertex uniforms
        this.uniforms.targetUVMatrix = targetSpriteMatrix;
        // fragment uniforms
        this.uniforms.inputClampTarget = new Float32Array([
            0,
            0,
            0,
            0
        ]);
        this.uniforms.color = new Float32Array([
            0.0,
            0.0,
            0.0
        ]);
        this.uniforms.scale = new Float32Array([
            1.0,
            1.0
        ]);
        this.uniforms.translation = new Float32Array([
            0.0,
            0.0
        ]);
        // to store sprite matrix from the filter manager (and send to vertex)
        this.targetSpriteMatrix = targetSpriteMatrix;
        Object.assign(this, {
            imagePath: (0, $97b1237a45b106ea$export$3bebb302ab08af33)(imagePath),
            alpha: alpha,
            repeat: repeat,
            rotation: rotation,
            twRadiusPercent: twRadiusPercent,
            twAngle: twAngle,
            twRotation: twRotation,
            bpRadiusPercent: bpRadiusPercent,
            bpStrength: bpStrength,
            scale: scale,
            scaleX: scaleX,
            scaleY: scaleY,
            translationX: translationX,
            translationY: translationY,
            play: play,
            loop: loop,
            maintainAspectRatio: maintainAspectRatio,
            maintainScale: maintainScale
        });
        this.zOrder = 0;
        this.autoFit = false;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    setTMParams(params) {
        super.setTMParams(params);
        if (!this.dummy && "imagePath" in params) this.assignTexture();
    }
    _play = true;
    _loop = true;
    _maintainAspectRatio = false;
    _maintainScale = false;
    get play() {
        return this._play;
    }
    set play(value) {
        if (!(value == null) && typeof value === "boolean") {
            this._play = value;
            this._playVideo(this._play);
        }
    }
    get loop() {
        return this._loop;
    }
    set loop(value) {
        if (!(value == null) && typeof value === "boolean") {
            this._loop = value;
            this._playVideo(this._play);
        }
    }
    get maintainAspectRatio() {
        return this._maintainAspectRatio;
    }
    set maintainAspectRatio(value) {
        if (!(value == null) && typeof value === "boolean") this._maintainAspectRatio = value;
    }
    get maintainScale() {
        return this._maintainScale;
    }
    set maintainScale(value) {
        if (!(value == null) && typeof value === "boolean") this._maintainScale = value;
    }
    get alpha() {
        return this.uniforms.alpha;
    }
    set alpha(value) {
        this.uniforms.alpha = value;
    }
    get repeat() {
        return this.uniforms.repeat;
    }
    set repeat(value) {
        if (!(value == null) && typeof value === "boolean") this.uniforms.repeat = value;
    }
    get rotation() {
        return this.uniforms.rotation;
    }
    set rotation(value) {
        this.uniforms.rotation = value;
    }
    get twRadiusPercent() {
        return this.uniforms.twRadius * 200;
    }
    set twRadiusPercent(value) {
        this.uniforms.twRadius = value / 200;
    }
    get twAngle() {
        return this.uniforms.twAngle;
    }
    set twAngle(value) {
        this.uniforms.twAngle = value;
    }
    get twRotation() {
        return this.uniforms.twAngle * (180 / Math.PI);
    }
    set twRotation(value) {
        this.uniforms.twAngle = value * (Math.PI / 180);
    }
    get bpRadiusPercent() {
        return this.uniforms.bpRadius * 200;
    }
    set bpRadiusPercent(value) {
        this.uniforms.bpRadius = value / 200;
    }
    get bpStrength() {
        return this.uniforms.bpStrength;
    }
    set bpStrength(value) {
        this.uniforms.bpStrength = value;
    }
    get scale() {
        // a little hack (we get only x)
        return this.uniforms.scale[0];
    }
    set scale(value) {
        this.uniforms.scale[1] = this.uniforms.scale[0] = value;
    }
    get scaleX() {
        return this.uniforms.scale[0];
    }
    set scaleX(value) {
        this.uniforms.scale[0] = value;
    }
    get scaleY() {
        return this.uniforms.scale[1];
    }
    set scaleY(value) {
        this.uniforms.scale[1] = value;
    }
    get translationX() {
        return this.uniforms.translation[0];
    }
    set translationX(value) {
        this.uniforms.translation[0] = value;
    }
    get translationY() {
        return this.uniforms.translation[1];
    }
    set translationY(value) {
        this.uniforms.translation[1] = value;
    }
    get uSamplerTarget() {
        return this.uniforms.uSamplerTarget;
    }
    set uSamplerTarget(value) {
        this.uniforms.uSamplerTarget = value;
    }
    async _playVideo(value) {
        // Play if baseTexture resource is a video
        if (this.tex) {
            const source = getProperty(this.tex, "baseTexture.resource.source");
            if (source && source.tagName === "VIDEO") {
                if (isNaN(source.duration)) await new Promise((resolve)=>{
                    source.onloadedmetadata = ()=>resolve();
                });
                if (value) game.video.play(source, {
                    loop: this._loop,
                    volume: 0
                });
                else game.video.stop(source);
            }
        }
    }
    assignTexture() {
        if (this.hasOwnProperty("imagePath")) {
            // Destroy the previous sprite
            if (this.targetSprite && !this.targetSprite.destroyed) this.targetSprite.destroy({
                children: true,
                texture: false,
                baseTexture: false
            });
            this.tex = PIXI.Texture.from(this.imagePath);
            let sprite = new PIXI.Sprite(this.tex);
            sprite.renderable = false;
            if (this.placeableImg._texture) {
                sprite.width = this.placeableImg._texture.baseTexture.realWidth;
                sprite.height = this.placeableImg._texture.baseTexture.realHeight;
                sprite.anchor.set(0.5);
            } else {
                sprite.width = this.placeableImg.width;
                sprite.height = this.placeableImg.height;
            }
            this.targetSprite = sprite;
            this.uSamplerTarget = sprite._texture;
            this.placeableImg.addChild(sprite);
            this._playVideo(this._play);
        }
    }
    // override
    apply(filterManager, input, output, clear) {
        const targetSprite = this.targetSprite;
        const tex = targetSprite._texture;
        if (tex.valid) {
            if (!tex.uvMatrix) tex.uvMatrix = new PIXI.TextureMatrix(tex, 0.0);
            tex.uvMatrix.update();
            this.uniforms.uSamplerTarget = tex;
            if (this.maintainScale) {
                let pScale = targetSprite.parent.scale;
                targetSprite.scale.set(1 / pScale.x, 1 / pScale.y);
            }
            let w = targetSprite.worldTransform;
            if (this.maintainAspectRatio) {
                let scale = Math.min(w.a, w.d);
                w.set(scale, w.b, w.c, scale, w.tx, w.ty);
            }
            this.uniforms.targetUVMatrix = filterManager.calculateSpriteMatrix(this.targetSpriteMatrix, targetSprite);
            this.uniforms.inputClampTarget = tex.uvMatrix.uClampFrame;
        }
        super.apply(filterManager, input, output, clear);
    }
    // override
    destroy() {
        super.destroy();
        if (!this.targetSprite.destroyed) this.targetSprite.destroy({
            children: true,
            texture: false,
            baseTexture: false
        });
    }
}
$756e6c880a697f93$export$4569ea13832ce134.defaults = {
    alpha: 1,
    repeat: false,
    rotation: 0.0,
    twRadiusPercent: 0,
    twAngle: 0,
    bpRadiusPercent: 0,
    bpStrength: 0,
    scaleX: 1,
    scaleY: 1,
    translationX: 0,
    translationY: 0,
    play: true,
    loop: true,
    maintainAspectRatio: false,
    maintainScale: false
};




class $66619a9ab494ce98$export$c3ce4d77f1074b4d extends PIXI.filters.ColorReplaceFilter {
    constructor(params){
        super();
        this.originalColor = [
            1,
            0,
            0
        ];
        this.newColor = [
            0,
            1,
            0
        ];
        this.epsilon = 0.7;
        this.zOrder = 100;
        this.animating = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}






const $21b728704648605f$export$711d0b0b05d4a93a = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec3 tint;
void main() {
    vec4 color = texture2D(uSampler, vTextureCoord);
    float lesser = min(color.g,color.b);
    float bigger = max(color.g,color.b);
    if ((bigger - lesser < 0.1) && (color.r > 1.5 * bigger)) {
        float primary = color.r;
        float range = primary - lesser;
        color.r = lesser + range * tint.r;
        color.g = lesser + range * tint.g;
        color.b = lesser + range * tint.b;
    }
    gl_FragColor = color;
}`;


class $4896edd1e4c7b975$export$1ee8d69885ee6ad1 extends (0, $44fa44dcb802915a$export$c042bd0ff4d3251b) {
    constructor(params){
        super((0, $15c633ba44c21f75$export$c6eb01d07cc2e1e8), (0, $21b728704648605f$export$711d0b0b05d4a93a));
        this.tint = [
            1,
            0,
            0
        ];
        this.zOrder = 100;
        this.animating = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get tint() {
        return this.uniforms.tint;
    }
    set tint(value) {
        this.uniforms.tint = value;
    }
}



const $ff7eec2964ce8415$export$19612c32a2f7f4cd = {
    MAIN: "tmfx-main",
    TEMPLATE: "tmfx-template"
};
var $ff7eec2964ce8415$export$7afd9c1079ecedf7 = [];
let $ff7eec2964ce8415$var$params = [
    {
        filterType: "bevel",
        filterId: "bevel",
        rotation: 0,
        thickness: 5,
        lightColor: 0xff0000,
        lightAlpha: 0.8,
        shadowColor: 0x00ff00,
        shadowAlpha: 0.5,
        animated: {
            rotation: {
                active: true,
                clockWise: true,
                loopDuration: 1600,
                animType: "syncRotation"
            }
        }
    }
];
var $ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "bevel";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "adjustment",
        filterId: "adjustment",
        saturation: 1.5,
        brightness: 1.5,
        contrast: 2,
        gamma: 2,
        red: 4,
        green: 0.25,
        blue: 0.25,
        alpha: 1,
        animated: {
            alpha: {
                active: true,
                loopDuration: 5000,
                animType: "syncCosOscillation",
                val1: 0.15,
                val2: 1
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "adjustment";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "shadow",
        filterId: "dropshadow",
        rotation: 35,
        blur: 2,
        quality: 5,
        distance: 20,
        alpha: 0.7,
        padding: 10,
        shadowOnly: false,
        color: 0x000000,
        animated: {
            blur: {
                active: true,
                loopDuration: 1500,
                animType: "syncCosOscillation",
                val1: 2,
                val2: 3
            },
            rotation: {
                active: true,
                loopDuration: 150,
                animType: "syncSinOscillation",
                val1: 33,
                val2: 35
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "dropshadow";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "outline",
        filterId: "outline",
        padding: 10,
        color: 0xee6035,
        thickness: 1,
        quality: 5,
        animated: {
            thickness: {
                active: true,
                loopDuration: 800,
                animType: "syncCosOscillation",
                val1: 1,
                val2: 6
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "outline";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "glow",
        filterId: "glow",
        outerStrength: 7,
        innerStrength: 0,
        color: 0x006000,
        quality: 0.5,
        padding: 10,
        animated: {
            color: {
                active: true,
                loopDuration: 3000,
                animType: "colorOscillation",
                val1: 0x003000,
                val2: 0x00ff00
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "glow";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xbloom",
        filterId: "bloom",
        threshold: 0.35,
        bloomScale: 0,
        brightness: 1,
        blur: 0.1,
        padding: 10,
        quality: 15,
        blendMode: 0,
        animated: {
            bloomScale: {
                active: true,
                loopDuration: 2000,
                animType: "syncCosOscillation",
                val1: 0,
                val2: 2.1
            },
            threshold: {
                active: false,
                loopDuration: 1000,
                animType: "syncCosOscillation",
                val1: 0.0,
                val2: 1.9
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "bloom";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "distortion",
        filterId: "distortion",
        maskPath: "modules/tokenmagic/fx/assets/distortion-1.png",
        maskSpriteScaleX: 5,
        maskSpriteScaleY: 5,
        padding: 20,
        animated: {
            maskSpriteX: {
                active: true,
                speed: 0.05,
                animType: "move"
            },
            maskSpriteY: {
                active: true,
                speed: 0.07,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "distortion";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "oldfilm",
        filterId: "oldfilm",
        sepia: 0.6,
        noise: 0.2,
        noiseSize: 1.0,
        scratch: 0.8,
        scratchDensity: 0.5,
        scratchWidth: 1.2,
        vignetting: 0.9,
        vignettingAlpha: 0.6,
        vignettingBlur: 0.2,
        animated: {
            seed: {
                active: true,
                animType: "randomNumber",
                val1: 0,
                val2: 1
            },
            vignetting: {
                active: true,
                animType: "syncCosOscillation",
                loopDuration: 2000,
                val1: 0.2,
                val2: 0.4
            }
        }
    },
    {
        filterType: "outline",
        filterId: "oldfilm",
        color: 0x000000,
        thickness: 0
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "oldfilm";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "twist",
        filterId: "twist",
        radiusPercent: 120,
        angle: 0,
        animated: {
            angle: {
                active: true,
                animType: "sinOscillation",
                loopDuration: 10000,
                val1: -0.6 * Math.PI,
                val2: 0.6 * Math.PI
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "twist";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "bulgepinch",
        filterId: "bulge",
        padding: 150,
        strength: 0,
        zIndex: 2,
        radiusPercent: 200,
        animated: {
            strength: {
                active: true,
                animType: "cosOscillation",
                loopDuration: 2000,
                val1: 0,
                val2: 0.45
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "bulge";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "blur",
        filterId: "blur",
        padding: 10,
        quality: 4.0,
        blur: 0,
        blurX: 0,
        blurY: 0,
        animated: {
            blurX: {
                active: true,
                animType: "syncCosOscillation",
                loopDuration: 500,
                val1: 0,
                val2: 6
            },
            blurY: {
                active: true,
                animType: "syncCosOscillation",
                loopDuration: 750,
                val1: 0,
                val2: 6
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "blur";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "zoomblur",
        filterId: "zoomblur",
        strength: 0.15,
        innerRadiusPercent: 65,
        radiusPercent: 100,
        padding: 30,
        animated: {
            innerRadiusPercent: {
                active: true,
                animType: "sinOscillation",
                loopDuration: 500,
                val1: 65,
                val2: 75
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "zoomblur";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "shockwave",
        filterId: "shockwave",
        time: 0,
        amplitude: 8,
        wavelength: 75,
        radius: 500,
        brightness: 1.5,
        speed: 25,
        padding: 0,
        animated: {
            time: {
                animType: "cosOscillation",
                active: true,
                loopDuration: 1800,
                val1: 0,
                val2: 10
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "shockwave";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "zapshadow",
        filterId: "zapshadow",
        alphaTolerance: 0.45
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "zapshadow";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "ray",
        filterId: "rays",
        time: 0,
        color: 0xcf8000,
        alpha: 0.5,
        divisor: 32,
        anchorX: 0,
        anchorY: 0,
        animated: {
            time: {
                active: true,
                speed: 0.0005,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "rays";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "fog",
        filterId: "fog",
        color: 0x000000,
        density: 0.65,
        time: 0,
        dimX: 1,
        dimY: 1,
        animated: {
            time: {
                active: true,
                speed: 2.2,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "fog";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "fumes",
        filterId: "fumes",
        color: 0x808080,
        time: 0,
        blend: 8,
        animated: {
            time: {
                active: true,
                speed: 0.001,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "fumes";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "electric",
        filterId: "electric",
        color: 0xffffff,
        time: 0,
        blend: 1,
        intensity: 5,
        animated: {
            time: {
                active: true,
                speed: 0.002,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "electric";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "fire",
        filterId: "fire",
        intensity: 1,
        color: 0xffffff,
        amplitude: 1,
        time: 0,
        blend: 2,
        fireBlend: 1,
        animated: {
            time: {
                active: true,
                speed: -0.0024,
                animType: "move"
            },
            intensity: {
                active: true,
                loopDuration: 15000,
                val1: 0.8,
                val2: 2,
                animType: "syncCosOscillation"
            },
            amplitude: {
                active: true,
                loopDuration: 4400,
                val1: 1,
                val2: 1.4,
                animType: "syncCosOscillation"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "fire";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "wave",
        filterId: "waves",
        time: 0,
        anchorX: 0.5,
        anchorY: 0.5,
        strength: 0.015,
        frequency: 120,
        color: 0xffffff,
        maxIntensity: 2.5,
        minIntensity: 0.9,
        padding: 10,
        animated: {
            time: {
                active: true,
                speed: 0.0085,
                animType: "move"
            },
            anchorX: {
                active: false,
                val1: 0.15,
                val2: 0.85,
                animType: "syncChaoticOscillation",
                loopDuration: 20000
            },
            anchorY: {
                active: false,
                val1: 0.15,
                val2: 0.85,
                animType: "syncSinOscillation",
                loopDuration: 20000
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "waves";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "flood",
        filterId: "flood",
        time: 0,
        color: 0x0020bb,
        billowy: 0.43,
        tintIntensity: 0.72,
        glint: 0.31,
        scale: 70,
        padding: 10,
        animated: {
            time: {
                active: true,
                speed: 0.0006,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "flood";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "smoke",
        filterId: "smoke",
        color: 0x5099dd,
        time: 0,
        blend: 2,
        dimX: 0.1,
        dimY: 1,
        animated: {
            time: {
                active: true,
                speed: 0.009,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "smoke";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "images",
        filterId: "images",
        time: 0,
        nbImage: 4,
        alphaImg: 1.0,
        alphaChr: 0.0,
        blend: 4,
        ampX: 0.1,
        ampY: 0.1,
        animated: {
            time: {
                active: true,
                speed: 0.001,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "images";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "images",
        filterId: "chaos-images",
        time: 0,
        nbImage: 4,
        alphaImg: 1.0,
        alphaChr: 0.0,
        blend: 4,
        ampX: 0.1,
        ampY: 0.1,
        padding: 80,
        animated: {
            time: {
                active: true,
                speed: 0.001,
                animType: "move"
            },
            ampX: {
                active: true,
                val1: 0.0,
                val2: 0.3,
                chaosFactor: 0.03,
                animType: "syncChaoticOscillation",
                loopDuration: 2000
            },
            ampY: {
                active: true,
                val1: 0.0,
                val2: 0.3,
                chaosFactor: 0.04,
                animType: "syncChaoticOscillation",
                loopDuration: 1650
            },
            alphaChr: {
                active: true,
                animType: "randomNumberPerLoop",
                val1: 0.0,
                val2: 1,
                loopDuration: 250
            },
            alphaImg: {
                active: true,
                animType: "randomNumberPerLoop",
                val1: 0.8,
                val2: 1,
                loopDuration: 250
            },
            nbImage: {
                active: true,
                val1: 1,
                val2: 9,
                animType: "syncSinOscillation",
                loopDuration: 1400
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "chaos-images";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "images",
        filterId: "spectral-images",
        time: 0,
        blend: 4,
        nbImage: 4,
        padding: 100,
        alphaImg: 0.5,
        alphaChr: 0.0,
        ampX: 0.1,
        ampY: 0.1,
        animated: {
            time: {
                speed: 0.001,
                animType: "move"
            },
            ampX: {
                val1: 0,
                val2: 0.22,
                animType: "syncCosOscillation",
                loopDuration: 2500
            },
            ampY: {
                val1: 0,
                val2: 0.24,
                animType: "syncCosOscillation",
                loopDuration: 2500,
                pauseBetweenDuration: 2500
            },
            alphaChr: {
                val1: 1,
                val2: 0,
                animType: "syncCosOscillation",
                loopDuration: 2500
            },
            alphaImg: {
                val1: 0.2,
                val2: 0.8,
                animType: "syncSinOscillation",
                loopDuration: 2500
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "spectral-images";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "hexa-field",
        shieldType: 2,
        gridPadding: 1.5,
        color: 0xcc00cc,
        time: 0,
        blend: 3,
        intensity: 1,
        lightAlpha: 0.5,
        lightSize: 0.5,
        scale: 1,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "hexa-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "fire-field",
        shieldType: 1,
        gridPadding: 2,
        color: 0xe58550,
        time: 0,
        blend: 2,
        intensity: 1.15,
        lightAlpha: 2,
        lightSize: 0.7,
        scale: 1,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "fire-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "smoke-field",
        shieldType: 3,
        gridPadding: 1.5,
        color: 0x60cc70,
        time: 0,
        blend: 2,
        intensity: 0.9,
        lightAlpha: 1,
        lightSize: 0.7,
        scale: 1,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "smoke-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "earth-field",
        shieldType: 4,
        gridPadding: 2,
        color: 0xbb9070,
        time: 0,
        blend: 1,
        intensity: 1.25,
        lightAlpha: 1,
        lightSize: 0.7,
        scale: 1,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "earth-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "earth-field-top",
        shieldType: 5,
        gridPadding: 3,
        color: 0xaaaaaa,
        time: 0,
        blend: 5,
        intensity: 1.9,
        lightAlpha: 1,
        lightSize: 0.7,
        scale: 1,
        radius: 1,
        zIndex: 5,
        chromatic: true,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "earth-field-top";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "air-field",
        shieldType: 6,
        gridPadding: 1.2,
        color: 0x7090aa,
        time: 0,
        blend: 14,
        intensity: 1,
        lightAlpha: 1,
        lightSize: 0.7,
        scale: 1,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "air-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "magic-field",
        shieldType: 7,
        gridPadding: 1,
        color: 0xffffff,
        time: 0,
        blend: 10,
        intensity: 0.8,
        lightAlpha: 1,
        lightSize: 0.45,
        scale: 1,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "magic-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "chromatic-field",
        shieldType: 8,
        gridPadding: 2,
        color: 0xaaaaaa,
        time: 0,
        blend: 0,
        intensity: 1,
        lightAlpha: 0,
        lightSize: 0,
        scale: 1,
        radius: 1,
        chromatic: true,
        animated: {
            time: {
                active: true,
                speed: 0.0045,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "chromatic-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "water-field",
        shieldType: 9,
        gridPadding: 1.2,
        color: 0x20bbee,
        time: 0,
        blend: 4,
        intensity: 1,
        lightAlpha: 0.7,
        lightSize: 0.5,
        scale: 0.6,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "water-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "evil-field",
        shieldType: 9,
        gridPadding: 2,
        color: 0xff3010,
        time: 0,
        blend: 5,
        intensity: 1,
        lightAlpha: 4,
        lightSize: 0.8,
        scale: 0.5,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0012,
                animType: "move"
            },
            lightSize: {
                val1: 0.4,
                val2: 1.5,
                animType: "syncCosOscillation",
                loopDuration: 5000
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "evil-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "grid-field",
        shieldType: 11,
        gridPadding: 2,
        color: 0x00cccc,
        time: 0,
        blend: 2,
        intensity: 1,
        lightAlpha: 1,
        lightSize: 0.3,
        scale: 0.5,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0009,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "grid-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "warp-field",
        shieldType: 12,
        gridPadding: 2,
        color: 0xffffff,
        time: 0,
        blend: 2,
        intensity: 1,
        lightAlpha: 0.8,
        lightSize: 0.5,
        scale: 0.9,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0009,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "warp-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "field",
        filterId: "color-field",
        shieldType: 13,
        gridPadding: 2,
        color: 0x00cc00,
        time: 0,
        blend: 14,
        intensity: 1,
        lightAlpha: 0,
        lightSize: 0,
        scale: 1,
        radius: 1,
        chromatic: false,
        animated: {
            time: {
                active: true,
                speed: 0.0009,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "color-field";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xray",
        filterId: "sunburst",
        time: 0,
        color: 0xffbb00,
        blend: 9,
        dimX: 1,
        dimY: 1,
        anchorX: 0,
        anchorY: 0,
        divisor: 36,
        intensity: 4,
        animated: {
            time: {
                active: true,
                speed: 0.0012,
                animType: "move"
            },
            anchorX: {
                animType: "syncCosOscillation",
                loopDuration: 6000,
                val1: 0.4,
                val2: 0.6
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "sunburst";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xray",
        filterId: "clover",
        time: 0,
        color: 0x00ff00,
        blend: 9,
        dimX: 0.05,
        dimY: 0.05,
        anchorX: 0.5,
        anchorY: 0.5,
        divisor: 4,
        intensity: 1,
        animated: {
            time: {
                active: true,
                speed: 0.0012,
                animType: "move"
            },
            anchorX: {
                animType: "syncCosOscillation",
                loopDuration: 6000,
                val1: 0.4,
                val2: 0.6
            },
            anchorY: {
                animType: "syncSinOscillation",
                loopDuration: 6000,
                val1: 0.4,
                val2: 0.6
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "clover";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xray",
        filterId: "scan",
        time: 0,
        color: 0xffffff,
        blend: 5,
        dimX: 20,
        dimY: 20,
        anchorX: 0.5,
        anchorY: 0,
        divisor: 8,
        intensity: 1,
        animated: {
            time: {
                active: true,
                speed: 0.0005,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "scan";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xray",
        filterId: "blue-rays",
        time: 0,
        color: 0x1030ff,
        blend: 9,
        dimX: 1,
        dimY: 1,
        anchorX: 0,
        anchorY: 0,
        divisor: 24,
        intensity: 1,
        animated: {
            time: {
                active: true,
                speed: 0.0002,
                animType: "move"
            },
            anchorX: {
                animType: "syncCosOscillation",
                loopDuration: 18000,
                val1: 0.05,
                val2: 0.95
            },
            anchorY: {
                animType: "syncSinOscillation",
                loopDuration: 18000,
                val1: 0.05,
                val2: 0.95
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "blue-rays";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "liquid",
        filterId: "spectral-body",
        color: 0x20aaee,
        time: 0,
        blend: 8,
        intensity: 4,
        spectral: true,
        scale: 0.9,
        animated: {
            time: {
                active: true,
                speed: 0.001,
                animType: "move"
            },
            color: {
                active: true,
                loopDuration: 6000,
                animType: "colorOscillation",
                val1: 0xffffff,
                val2: 0x00aaff
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "spectral-body";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "liquid",
        filterId: "mantle-of-madness",
        color: 0x0090ff,
        time: 0,
        blend: 5,
        intensity: 0.0001,
        spectral: false,
        scale: 7,
        animated: {
            time: {
                active: true,
                speed: 0.0015,
                animType: "move"
            },
            intensity: {
                active: true,
                animType: "syncCosOscillation",
                loopDuration: 30000,
                val1: 0.0001,
                val2: 4
            },
            scale: {
                active: true,
                animType: "syncCosOscillation",
                loopDuration: 30000,
                val1: 7,
                val2: 1
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "mantle-of-madness";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "wave",
        filterId: "drift-in-plans",
        time: 0,
        anchorX: 0.5,
        anchorY: 0.5,
        strength: 0.035,
        frequency: 80,
        color: 0xffffff,
        maxIntensity: 1.5,
        minIntensity: 0.5,
        padding: 10,
        animated: {
            time: {
                active: true,
                speed: 0.0085,
                animType: "move"
            },
            anchorX: {
                active: true,
                val1: 0.35,
                val2: 0.65,
                animType: "syncCosOscillation",
                loopDuration: 10000
            },
            anchorY: {
                active: true,
                val1: 0.35,
                val2: 0.65,
                animType: "syncSinOscillation",
                loopDuration: 10000
            }
        }
    },
    {
        filterType: "liquid",
        filterId: "drift-in-plans",
        color: 0xff0000,
        time: 0,
        blend: 6,
        intensity: 5,
        spectral: false,
        scale: 2.5,
        animated: {
            time: {
                active: true,
                speed: 0.0018,
                animType: "move"
            },
            color: {
                active: true,
                loopDuration: 9000,
                animType: "colorOscillation",
                val1: 0xff0000,
                val2: 0xffffff
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "drift-in-plans";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "zapshadow",
        filterId: "fire-aura",
        alphaTolerance: 0.5
    },
    {
        filterType: "xglow",
        filterId: "fire-aura",
        auraType: 2,
        color: 0x903010,
        thickness: 9.8,
        scale: 4,
        time: 0,
        auraIntensity: 2,
        subAuraIntensity: 1.5,
        threshold: 0.4,
        discard: true,
        animated: {
            time: {
                active: true,
                speed: 0.0027,
                animType: "move"
            },
            thickness: {
                active: true,
                loopDuration: 3000,
                animType: "cosOscillation",
                val1: 2,
                val2: 5
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "fire-aura";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "zapshadow",
        filterId: "glacial-aura",
        alphaTolerance: 0.5
    },
    {
        filterType: "xglow",
        filterId: "glacial-aura",
        auraType: 1,
        color: 0x5099dd,
        thickness: 4.5,
        scale: 3,
        time: 0,
        auraIntensity: 0.8,
        subAuraIntensity: 0.25,
        threshold: 0.5,
        discard: false,
        animated: {
            time: {
                active: true,
                speed: 0.0018,
                animType: "move"
            },
            thickness: {
                val1: 2,
                val2: 4.7,
                animType: "cosOscillation",
                loopDuration: 3000
            },
            subAuraIntensity: {
                val1: 0.45,
                val2: 0.65,
                animType: "cosOscillation",
                loopDuration: 6000
            },
            auraIntensity: {
                val1: 0.9,
                val2: 2.2,
                animType: "cosOscillation",
                loopDuration: 3000
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "glacial-aura";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "zapshadow",
        filterId: "anti-aura",
        alphaTolerance: 0.5
    },
    {
        filterType: "xglow",
        filterId: "anti-aura",
        auraType: 2,
        color: 0x050505,
        thickness: 2.7,
        scale: 7,
        time: 0,
        auraIntensity: 5,
        subAuraIntensity: 2,
        threshold: 0.08,
        discard: false,
        animated: {
            time: {
                active: true,
                speed: 0.0012,
                animType: "move"
            },
            auraIntensity: {
                active: true,
                loopDuration: 3000,
                animType: "syncCosOscillation",
                val1: 5,
                val2: 0
            },
            subAuraIntensity: {
                active: true,
                loopDuration: 3000,
                animType: "syncCosOscillation",
                val1: 2,
                val2: 0
            },
            color: {
                active: true,
                loopDuration: 6000,
                animType: "syncColorOscillation",
                val1: 0x050505,
                val2: 0x200000
            },
            threshold: {
                active: true,
                loopDuration: 1500,
                animType: "syncCosOscillation",
                val1: 0.02,
                val2: 0.5
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "anti-aura";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "fire",
        filterId: "pure-fire-aura",
        intensity: 1,
        color: 0xffffff,
        amplitude: 1,
        time: 0,
        blend: 2,
        fireBlend: 1,
        animated: {
            time: {
                active: true,
                speed: -0.0024,
                animType: "move"
            },
            intensity: {
                active: true,
                loopDuration: 15000,
                val1: 0.8,
                val2: 2,
                animType: "syncCosOscillation"
            },
            amplitude: {
                active: true,
                loopDuration: 4400,
                val1: 1,
                val2: 1.4,
                animType: "syncCosOscillation"
            }
        }
    },
    {
        filterType: "zapshadow",
        filterId: "pure-fire-aura",
        alphaTolerance: 0.5
    },
    {
        filterType: "xglow",
        filterId: "pure-fire-aura",
        auraType: 2,
        color: 0x903010,
        thickness: 9.8,
        scale: 4,
        time: 0,
        auraIntensity: 2,
        subAuraIntensity: 1.5,
        threshold: 0.4,
        discard: true,
        animated: {
            time: {
                active: true,
                speed: 0.0027,
                animType: "move"
            },
            thickness: {
                active: true,
                loopDuration: 3000,
                animType: "cosOscillation",
                val1: 2,
                val2: 5
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "pure-fire-aura";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "zapshadow",
        filterId: "pure-fire-aura-2",
        alphaTolerance: 0.5
    },
    {
        filterType: "xglow",
        filterId: "pure-fire-aura-2",
        auraType: 2,
        color: 0x903010,
        thickness: 9.8,
        scale: 4,
        time: 0,
        auraIntensity: 1,
        subAuraIntensity: 0.3,
        threshold: 0.5,
        discard: true,
        animated: {
            time: {
                active: true,
                speed: 0.0027,
                animType: "move"
            },
            thickness: {
                active: true,
                loopDuration: 3000,
                animType: "cosOscillation",
                val1: 2,
                val2: 3.6
            }
        }
    },
    {
        filterType: "fire",
        filterId: "pure-fire-aura-2",
        intensity: 1,
        color: 0xffffff,
        amplitude: 1,
        time: 0,
        blend: 2,
        fireBlend: 1,
        animated: {
            time: {
                active: true,
                speed: -0.0024,
                animType: "move"
            },
            intensity: {
                active: true,
                loopDuration: 15000,
                val1: 0.8,
                val2: 3,
                animType: "syncCosOscillation"
            },
            amplitude: {
                active: true,
                loopDuration: 4400,
                val1: 1,
                val2: 1.6,
                animType: "syncCosOscillation"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "pure-fire-aura-2";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "zapshadow",
        filterId: "pure-ice-aura",
        alphaTolerance: 0.5
    },
    {
        filterType: "xglow",
        filterId: "pure-ice-aura",
        auraType: 1,
        color: 0x5099dd,
        thickness: 4.5,
        scale: 10,
        time: 0,
        auraIntensity: 0.25,
        subAuraIntensity: 1,
        threshold: 0.5,
        discard: false,
        animated: {
            time: {
                active: true,
                speed: 0.0018,
                animType: "move"
            },
            thickness: {
                val1: 2,
                val2: 3.3,
                animType: "cosOscillation",
                loopDuration: 3000
            },
            subAuraIntensity: {
                val1: 0.45,
                val2: 0.65,
                animType: "cosOscillation",
                loopDuration: 6000
            },
            auraIntensity: {
                val1: 0.9,
                val2: 2.2,
                animType: "cosOscillation",
                loopDuration: 3000
            }
        }
    },
    {
        filterType: "smoke",
        filterId: "pure-ice-aura",
        color: 0x80ccff,
        time: 0,
        blend: 2,
        dimX: 0.3,
        dimY: 1,
        animated: {
            time: {
                active: true,
                speed: -0.006,
                animType: "move"
            },
            dimX: {
                val1: 0.4,
                val2: 0.2,
                animType: "cosOscillation",
                loopDuration: 3000
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "pure-ice-aura";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "pixel",
        filterId: "pixelate",
        sizeX: 2.5,
        sizeY: 2.5
    }
];
$ff7eec2964ce8415$var$presetObject = new Object();
$ff7eec2964ce8415$var$presetObject.name = "pixelate";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.MAIN;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$7afd9c1079ecedf7.push($ff7eec2964ce8415$var$presetObject);
var $ff7eec2964ce8415$export$bfc0b9c61923b5ec = [];
// white : **electric , **waves, ***xrays, **liquid (normal), (clover)
// black : **liquid (protoplasm), **smoke, **rays, outline, **fumes, **fog, **flood, **fire
// no texture : **glow, **bulge, **blur, **bloom
$ff7eec2964ce8415$var$params = [
    {
        filterType: "flood",
        filterId: "Watery Surface",
        time: 0,
        color: 0x0020bb,
        billowy: 0.43,
        tintIntensity: 0.72,
        glint: 0.31,
        scale: 70,
        padding: 10,
        animated: {
            time: {
                active: true,
                speed: 0.0006,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Watery Surface";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "liquid",
        filterId: "Protoplasm",
        color: 0x20aaee,
        time: 0,
        blend: 8,
        intensity: 4,
        spectral: true,
        scale: 1.4,
        animated: {
            time: {
                active: true,
                speed: 0.001,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Protoplasm";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "liquid",
        filterId: "Watery Surface 2",
        color: 0x20aaee,
        time: 0,
        blend: 8,
        intensity: 4,
        spectral: false,
        scale: 1.4,
        animated: {
            time: {
                active: true,
                speed: 0.001,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Watery Surface 2";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/white-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "smoke",
        filterId: "Smoky Area",
        color: 0xaaaaaa,
        time: 0,
        blend: 2,
        dimX: 1,
        dimY: 1,
        animated: {
            time: {
                active: true,
                speed: 0.002,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Smoky Area";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "electric",
        filterId: "Shock",
        color: 0xffffff,
        time: 0,
        blend: 1,
        intensity: 5,
        animated: {
            time: {
                active: true,
                speed: 0.002,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Shock";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/white-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xray",
        filterId: "Annihilating Rays",
        time: 0,
        color: 0xffbb00,
        blend: 9,
        dimX: 1,
        dimY: 1,
        anchorX: 0,
        anchorY: 0,
        divisor: 6,
        intensity: 4,
        animated: {
            time: {
                active: true,
                speed: 0.0012,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Annihilating Rays";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/white-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "ray",
        filterId: "Classic Rays",
        time: 0,
        color: 0xcf8000,
        alpha: 0.5,
        divisor: 32,
        anchorX: 0,
        anchorY: 0,
        animated: {
            time: {
                active: true,
                speed: 0.0005,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Classic Rays";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "fumes",
        filterId: "Smoke Filaments",
        color: 0x808080,
        time: 0,
        blend: 8,
        animated: {
            time: {
                active: true,
                speed: 0.001,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Smoke Filaments";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "fire",
        filterId: "Flames",
        intensity: 1.5,
        color: 0xffffff,
        amplitude: 1.3,
        time: 0,
        blend: 2,
        fireBlend: 1,
        animated: {
            time: {
                active: true,
                speed: -0.0016,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Flames";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xfog",
        filterId: "Thick Fog",
        autoFit: false,
        color: 0x3090ff,
        time: 0,
        animated: {
            time: {
                active: true,
                speed: 0.0006,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Thick Fog";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-vstrong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "glow",
        filterId: "Glowing Outline",
        outerStrength: 5.5,
        innerStrength: 0,
        color: 0x006000,
        quality: 0.5,
        padding: 10,
        animated: {
            outerStrength: {
                active: true,
                loopDuration: 3000,
                animType: "syncCosOscillation",
                val1: 5.5,
                val2: 1.5
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Glowing Outline";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "wave",
        filterId: "Waves",
        time: 0,
        anchorX: 0.5,
        anchorY: 0.5,
        strength: 0.015,
        frequency: 120,
        color: 0xffffff,
        maxIntensity: 2.5,
        minIntensity: 0.9,
        padding: 10,
        animated: {
            time: {
                active: true,
                speed: 0.0085,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Waves";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/white-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "wave",
        filterId: "Waves 2",
        time: 0,
        anchorX: 0.5,
        anchorY: 0.5,
        strength: 0.014,
        frequency: 400,
        color: 0xffffff,
        maxIntensity: 2.4,
        minIntensity: 0.8,
        padding: 10,
        animated: {
            time: {
                active: true,
                speed: 0.0385,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Waves 2";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/white-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "wave",
        filterId: "Waves 3",
        time: 0,
        anchorX: 0.5,
        anchorY: 0.5,
        strength: 0.017,
        frequency: 35,
        color: 0xffffff,
        maxIntensity: 2.6,
        minIntensity: 0.9,
        padding: 20,
        animated: {
            time: {
                active: true,
                speed: 0.0085,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Waves 3";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/white-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xglow",
        filterId: "Zone : Fire",
        auraType: 1,
        color: 0x903010,
        scale: 1.5,
        time: 0,
        auraIntensity: 1.8,
        subAuraIntensity: 0.25,
        threshold: 0.6,
        discard: false,
        animated: {
            time: {
                active: true,
                speed: 0.0027,
                animType: "move"
            },
            thickness: {
                active: true,
                loopDuration: 3000,
                animType: "cosOscillation",
                val1: 2,
                val2: 5
            }
        }
    },
    {
        filterType: "fire",
        filterId: "Zone : Fire",
        intensity: 1.5,
        color: 0xffffff,
        amplitude: 1,
        time: 0,
        blend: 2,
        fireBlend: 1,
        animated: {
            time: {
                active: true,
                speed: -0.0015,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Zone : Fire";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xglow",
        filterId: "Zone : Electricity",
        auraType: 2,
        color: 0x303030,
        scale: 1.5,
        time: 0,
        auraIntensity: 1,
        subAuraIntensity: 0.9,
        threshold: 0,
        discard: true,
        animated: {
            time: {
                active: true,
                speed: 0.0027,
                animType: "move"
            },
            thickness: {
                active: true,
                loopDuration: 3000,
                animType: "cosOscillation",
                val1: 1,
                val2: 2
            }
        }
    },
    {
        filterType: "electric",
        filterId: "Zone : Electricity",
        color: 0xffffff,
        time: 0,
        blend: 1,
        intensity: 5,
        animated: {
            time: {
                active: true,
                speed: 0.002,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Zone : Electricity";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/white-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xglow",
        filterId: "Zone : Blizzard",
        auraType: 1,
        color: 0x5099dd,
        thickness: 4.5,
        scale: 5,
        time: 0,
        auraIntensity: 0.25,
        subAuraIntensity: 1,
        threshold: 0.5,
        discard: false,
        animated: {
            time: {
                active: true,
                speed: 0.0018,
                animType: "move"
            },
            thickness: {
                val1: 2,
                val2: 3.3,
                animType: "cosOscillation",
                loopDuration: 3000
            },
            subAuraIntensity: {
                val1: 0.05,
                val2: 0.1,
                animType: "cosOscillation",
                loopDuration: 6000
            },
            auraIntensity: {
                val1: 0.9,
                val2: 2.2,
                animType: "cosOscillation",
                loopDuration: 3000
            }
        }
    },
    {
        filterType: "smoke",
        filterId: "Zone : Blizzard",
        color: 0x80ccff,
        time: 0,
        blend: 2,
        dimY: 1,
        animated: {
            time: {
                active: true,
                speed: -0.005,
                animType: "move"
            },
            dimX: {
                val1: 0.4,
                val2: 0.2,
                animType: "cosOscillation",
                loopDuration: 3000
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Zone : Blizzard";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "bulgepinch",
        filterId: "Bulging Out",
        padding: 150,
        strength: 0,
        radiusPercent: 200,
        animated: {
            strength: {
                active: true,
                animType: "cosOscillation",
                loopDuration: 2000,
                val1: 0,
                val2: 0.45
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Bulging Out";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "blur",
        filterId: "Blurred Texture",
        padding: 25,
        quality: 4.0,
        blur: 0,
        blurX: 0,
        blurY: 0,
        animated: {
            blurX: {
                active: true,
                animType: "syncCosOscillation",
                loopDuration: 500,
                val1: 0,
                val2: 6
            },
            blurY: {
                active: true,
                animType: "syncCosOscillation",
                loopDuration: 750,
                val1: 0,
                val2: 6
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Blurred Texture";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "xbloom",
        filterId: "Bloomed Texture",
        threshold: 0.35,
        bloomScale: 0,
        brightness: 1,
        blur: 0.1,
        padding: 10,
        quality: 15,
        blendMode: 0,
        animated: {
            bloomScale: {
                active: true,
                loopDuration: 2000,
                animType: "syncCosOscillation",
                val1: 0,
                val2: 2.1
            },
            threshold: {
                active: false,
                loopDuration: 1000,
                animType: "syncCosOscillation",
                val1: 0.0,
                val2: 1.9
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Bloomed Texture";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "liquid",
        filterId: "Wild Magic",
        color: 0xff0000,
        time: 0,
        blend: 6,
        intensity: 5,
        spectral: false,
        scale: 2.5,
        animated: {
            time: {
                active: true,
                speed: 0.0018,
                animType: "move"
            }
        }
    },
    {
        filterType: "wave",
        filterId: "Wild Magic",
        time: 0,
        anchorX: 0.5,
        anchorY: 0.5,
        strength: 0.014,
        frequency: 10,
        color: 0xffffff,
        maxIntensity: 1.3,
        minIntensity: 0.6,
        padding: 10,
        animated: {
            time: {
                active: true,
                speed: 0.0065,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Wild Magic";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "web",
        filterId: "Spider Web 1",
        anchorX: 0.5,
        anchorY: 0.5,
        color: 0xffffff,
        thickness: 2,
        div2: 5,
        time: 98.8,
        animated: {
            time: {
                active: true,
                loopDuration: 5000,
                animType: "cosOscillation",
                val1: 98.8,
                val2: 99.7
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Spider Web 1";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "web",
        filterId: "Spider Web 2",
        anchorX: 0.5,
        anchorY: 0.5,
        color: 0xcccccc,
        animated: {
            time: {
                active: true,
                speed: 0.0005,
                animType: "move"
            }
        }
    },
    {
        filterType: "liquid",
        filterId: "Spider Web 2",
        color: 0xff0000,
        time: 0,
        blend: 4,
        intensity: 8,
        spectral: false,
        scale: 0.2,
        animated: {
            time: {
                active: true,
                speed: 0.0005,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Spider Web 2";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
$ff7eec2964ce8415$var$params = [
    {
        filterType: "web",
        filterId: "Spider Web 3",
        anchorX: 0.5,
        anchorY: 0.5,
        color: 0xcccccc,
        time: 100
    },
    {
        filterType: "liquid",
        filterId: "Spider Web 3",
        color: 0xff0000,
        time: 0,
        blend: 1,
        intensity: 4,
        spectral: true,
        scale: 0.2,
        animated: {
            time: {
                active: true,
                speed: 0.0005,
                animType: "move"
            }
        }
    }
];
$ff7eec2964ce8415$var$presetObject = {};
$ff7eec2964ce8415$var$presetObject.name = "Spider Web 3";
$ff7eec2964ce8415$var$presetObject.library = $ff7eec2964ce8415$export$19612c32a2f7f4cd.TEMPLATE;
$ff7eec2964ce8415$var$presetObject.defaultTexture = "modules/tokenmagic/fx/assets/templates/black-tone-strong-opacity.png";
$ff7eec2964ce8415$var$presetObject.params = $ff7eec2964ce8415$var$params;
$ff7eec2964ce8415$export$bfc0b9c61923b5ec.push($ff7eec2964ce8415$var$presetObject);
var $ff7eec2964ce8415$export$9381e89181e5b461 = $ff7eec2964ce8415$export$7afd9c1079ecedf7.concat($ff7eec2964ce8415$export$bfc0b9c61923b5ec);




const $a48a250facc06caa$var$Magic = (0, $97b1237a45b106ea$export$4367b12d875874d3)();
const $a48a250facc06caa$export$df3971f21aaed551 = {
    ARCHAIC: "",
    V030: "0.3.0",
    V040: "0.4.0",
    V040b: "0.4.0b",
    V041: "0.4.1",
    V043: "0.4.3"
};
async function $a48a250facc06caa$export$182eb7a8e7220720() {
    if ((0, $97b1237a45b106ea$export$485113ed30b22bb8)()) {
        var dataVersionNow;
        try {
            dataVersionNow = game.settings.get("tokenmagic", "migration");
        } catch (e) {
            dataVersionNow = $a48a250facc06caa$export$df3971f21aaed551.ARCHAIC;
        }
        if (dataVersionNow < $a48a250facc06caa$export$df3971f21aaed551.V030) await $a48a250facc06caa$var$updatePresetsV030();
        if (dataVersionNow < $a48a250facc06caa$export$df3971f21aaed551.V040) await $a48a250facc06caa$var$updatePresetsV040();
        if (dataVersionNow < $a48a250facc06caa$export$df3971f21aaed551.V040b) await $a48a250facc06caa$var$updatePresetsV040b();
        if (dataVersionNow < $a48a250facc06caa$export$df3971f21aaed551.V041) await $a48a250facc06caa$var$updatePresetsV041();
        if (dataVersionNow < $a48a250facc06caa$export$df3971f21aaed551.V043) await $a48a250facc06caa$var$updatePresetsV043();
    }
}
// migrating to the new presets data
async function $a48a250facc06caa$var$updatePresetsV030() {
    var presets = game.settings.get("tokenmagic", "presets");
    if (!(presets == null)) {
        (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.3.0 - Launching presets data migration...`);
        let foundTemplateLibrary = false;
        for (const preset of presets){
            if (!preset.hasOwnProperty("library")) {
                preset.library = (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).MAIN;
                (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.3.0 - Adding ${preset.name} to ${(0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).MAIN}`);
            } else if (preset.library === (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).TEMPLATE && !foundTemplateLibrary) {
                foundTemplateLibrary = true;
                (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.3.0 - Found template presets. Templates will not be added.`);
            }
        }
        if (!foundTemplateLibrary) (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.3.0 - Merging templates presets.`);
        let newPresets = foundTemplateLibrary ? presets : presets.concat((0, $ff7eec2964ce8415$export$bfc0b9c61923b5ec));
        try {
            await game.settings.set("tokenmagic", "presets", newPresets);
            await game.settings.set("tokenmagic", "migration", $a48a250facc06caa$export$df3971f21aaed551.V030);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.3.0 - Migration successful!`);
        } catch (e) {
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(`Migration 0.3.0 - Migration failed.`);
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(e);
        }
    }
}
async function $a48a250facc06caa$var$updatePresetsV040() {
    var presets = game.settings.get("tokenmagic", "presets");
    if (!(presets == null)) {
        (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0 - Launching presets data migration...`);
        // Adding zOrder for the template presets only
        // Does not break visuals
        for (const preset of presets)if (preset.library === (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).TEMPLATE) {
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0 - Checking template preset ${preset.name}...`);
            let zOrder = 1;
            for (const filter of preset.params)if (!filter.hasOwnProperty("zOrder")) {
                filter.zOrder = zOrder;
                (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0 - Updating ${filter.filterType} in ${preset.name}...`);
                zOrder++;
            }
        }
        try {
            await game.settings.set("tokenmagic", "presets", presets);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0 - Importing new template presets...`);
            await $a48a250facc06caa$var$Magic.importPresetLibraryFromPath("modules/tokenmagic/import/TMFX-update-presets-v040.json", {
                overwrite: false
            });
            await game.settings.set("tokenmagic", "migration", $a48a250facc06caa$export$df3971f21aaed551.V040);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0 - Migration successful!`);
        } catch (e) {
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(`Migration 0.4.0 - Migration failed.`);
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(e);
        }
    }
}
async function $a48a250facc06caa$var$updatePresetsV040b() {
    var presets = game.settings.get("tokenmagic", "presets");
    if (!(presets == null)) {
        (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0b - Launching presets data migration...`);
        try {
            await game.settings.set("tokenmagic", "presets", presets);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0b - updating template presets...`);
            await $a48a250facc06caa$var$Magic.importPresetLibraryFromPath("modules/tokenmagic/import/TMFX-update-presets-v040b.json", {
                overwrite: true
            });
            await game.settings.set("tokenmagic", "migration", $a48a250facc06caa$export$df3971f21aaed551.V040b);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.0b - Migration successful!`);
        } catch (e) {
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(`Migration 0.4.0b - Migration failed.`);
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(e);
        }
    }
}
async function $a48a250facc06caa$var$updatePresetsV041() {
    var presets = game.settings.get("tokenmagic", "presets");
    if (!(presets == null)) {
        (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.1 - Launching presets data migration...`);
        try {
            await game.settings.set("tokenmagic", "presets", presets);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.1 - updating template presets...`);
            await $a48a250facc06caa$var$Magic.importPresetLibraryFromPath("modules/tokenmagic/import/TMFX-update-presets-v041.json", {
                overwrite: true
            });
            await game.settings.set("tokenmagic", "migration", $a48a250facc06caa$export$df3971f21aaed551.V041);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.1 - Migration successful!`);
        } catch (e) {
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(`Migration 0.4.1 - Migration failed.`);
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(e);
        }
    }
}
async function $a48a250facc06caa$var$updatePresetsV043() {
    var presets = game.settings.get("tokenmagic", "presets");
    if (!(presets == null)) {
        (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.3 - Launching presets data migration...`);
        try {
            await game.settings.set("tokenmagic", "presets", presets);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.3 - updating template presets...`);
            await $a48a250facc06caa$var$Magic.importPresetLibraryFromPath("modules/tokenmagic/import/TMFX-update-presets-v043.json", {
                overwrite: true
            });
            await game.settings.set("tokenmagic", "migration", $a48a250facc06caa$export$df3971f21aaed551.V043);
            (0, $97b1237a45b106ea$export$bef1f36f5486a6a3)(`Migration 0.4.3 - Migration successful!`);
        } catch (e) {
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(`Migration 0.4.3 - Migration failed.`);
            (0, $97b1237a45b106ea$export$a3bc9b8ed74fc)(e);
        }
    }
}






class $0213c2d85a9c5b71$export$1ab2366e25c48ed5 extends PIXI.filters.CRTFilter {
    constructor(params){
        super();
        this.curvature = 1.0;
        this.lineWidth = 1.0;
        this.lineContrast = 0.25;
        this.verticalLine = false;
        this.noise = 0.08;
        this.noiseSize = 1.0;
        this.seed = 0;
        this.vignetting = 0;
        this.zOrder = 320;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
}




class $1e1fe8af01bced2b$export$767e09686399ca49 extends PIXI.filters.RGBSplitFilter {
    constructor(params){
        super();
        this.red = new Float32Array([
            -10,
            0
        ]);
        this.green = new Float32Array([
            0,
            10
        ]);
        this.blue = new Float32Array([
            0,
            0
        ]);
        this.zOrder = 340;
        this.animated = {};
        this.setTMParams(params);
        if (!this.dummy) {
            this.anime = new (0, $c1844ae22deae2c0$export$b229f242afc35ae9)(this);
            this.normalizeTMParams();
        }
    }
    get redX() {
        return this.uniforms.red[0];
    }
    set redX(value) {
        this.uniforms.red[0] = value;
    }
    get redY() {
        return this.uniforms.red[1];
    }
    set redY(value) {
        this.uniforms.red[1] = value;
    }
    get greenX() {
        return this.uniforms.green[0];
    }
    set greenX(value) {
        this.uniforms.green[0] = value;
    }
    get greenY() {
        return this.uniforms.green[1];
    }
    set greenY(value) {
        this.uniforms.green[1] = value;
    }
    get blueX() {
        return this.uniforms.blue[0];
    }
    set blueX(value) {
        this.uniforms.blue[0] = value;
    }
    get blueY() {
        return this.uniforms.blue[1];
    }
    set blueY(value) {
        this.uniforms.blue[1] = value;
    }
}






class $8d3e8f4e5d297304$export$7b4b307b24c88455 {
    static get defaultConfiguration() {
        const defaultConfig = {
            categories: {},
            overrides: {
                0: {
                    target: "Stinking Cloud",
                    opacity: 0.5,
                    tint: "#00a80b",
                    preset: "Smoky Area",
                    texture: null
                },
                1: {
                    target: "Web",
                    opacity: 0.5,
                    tint: "#808080",
                    preset: "Spider Web 2",
                    texture: null
                }
            }
        };
        Object.keys(CONFIG.DND5E.damageTypes).forEach((dmgType)=>{
            if (defaultConfig.categories[dmgType] == undefined) {
                const config = {
                    opacity: (0, $165cdb672a404ae7$export$7395e4cb572e863b),
                    tint: null
                };
                switch(dmgType.toLowerCase()){
                    case "acid":
                        config.tint = "#2d8000";
                        config.opacity = 0.6;
                        break;
                    case "cold":
                        config.tint = "#47b3ff";
                        break;
                    case "necrotic":
                        config.tint = "#502673";
                        break;
                    case "poison":
                        config.tint = "#00a80b";
                        break;
                    case "psychic":
                        config.tint = "#8000ff";
                        break;
                    case "thunder":
                        config.tint = "#0060ff";
                        break;
                    default:
                        break;
                }
                defaultConfig.categories[dmgType] = config;
            }
            Object.keys(CONFIG.MeasuredTemplate.types).forEach((tplType)=>{
                const config = {
                    preset: (0, $165cdb672a404ae7$export$680af52575be3523),
                    texture: null
                };
                switch(dmgType.toLowerCase()){
                    case "acid":
                        config.preset = "Watery Surface 2";
                        break;
                    case "cold":
                        config.preset = "Thick Fog";
                        break;
                    case "fire":
                        config.preset = "Flames";
                        break;
                    case "force":
                        config.preset = "Waves 3";
                        break;
                    case "lightning":
                        config.preset = "Shock";
                        break;
                    case "necrotic":
                        config.preset = "Smoke Filaments";
                        break;
                    case "poison":
                        config.preset = "Smoky Area";
                        break;
                    case "psychic":
                        config.preset = "Classic Rays";
                        break;
                    case "radiant":
                        config.preset = "Annihilating Rays";
                        break;
                    case "thunder":
                        config.preset = "Waves";
                        break;
                    default:
                        break;
                }
                defaultConfig.categories[dmgType][tplType] = config;
            });
        });
        return defaultConfig;
    }
    constructor(){
        this._enabled = false;
    }
    get enabled() {
        return this._enabled;
    }
    configure(enabled = false) {
        if (game.system.id !== "dnd5e") return;
        if (!enabled) {
            if (this._enabled) {
                if (game.modules.get("lib-wrapper")?.active) libWrapper.unregister("tokenmagic", "game.dnd5e.canvas.AbilityTemplate.fromItem");
                else window.location.reload();
            }
        } else if (!this._enabled) {
            if (game.modules.get("lib-wrapper")?.active) libWrapper.register("tokenmagic", "game.dnd5e.canvas.AbilityTemplate.fromItem", $8d3e8f4e5d297304$var$fromItem, "WRAPPER");
            else {
                const origFromItem = game.dnd5e.canvas.AbilityTemplate.fromItem;
                game.dnd5e.canvas.AbilityTemplate.fromItem = function() {
                    return $8d3e8f4e5d297304$var$fromItem.call(this, origFromItem.bind(this), ...arguments);
                };
            }
        }
        this._enabled = enabled;
    }
    getData() {
        return {
            hasAutoTemplates: true,
            dmgTypes: CONFIG.DND5E.damageTypes,
            templateTypes: CONFIG.MeasuredTemplate.types
        };
    }
}
function $8d3e8f4e5d297304$var$fromConfig(config, template) {
    const o = {
        tokenmagic: {
            options: {}
        }
    };
    if (config.preset && config.preset !== "" && config.preset !== (0, $165cdb672a404ae7$export$680af52575be3523)) o.tokenmagic.options.tmfxPreset = config.preset;
    if (config.texture && config.texture !== "") o.tokenmagic.options.tmfxTexture = config.texture;
    if (config.tint && config.tint !== "") o.tokenmagic.options.tmfxTint = config.tint;
    o.tokenmagic.options.tmfxTextureAlpha = config.opacity;
    template.document.updateSource({
        flags: {
            tokenmagic: o.tokenmagic
        }
    });
}
function $8d3e8f4e5d297304$var$fromOverrides(overrides = [], item, template) {
    let configs = overrides.filter((el)=>el.target.toLowerCase() === item.name.toLowerCase());
    if (configs.length === 0) return false;
    // if there are multiple overrides for the same item, the random one is chosen
    let config = configs[Math.floor(Math.random() * configs.length)];
    $8d3e8f4e5d297304$var$fromConfig(config, template);
    return true;
}
function $8d3e8f4e5d297304$var$fromCategories(categories = {}, item, template) {
    if (!item.hasDamage) return false;
    let config, dmgSettings;
    // some items/spells have multiple damage types
    // this loop looks over all the types until it finds one with a valid fx preset
    for (const [_, dmgType] of item.system.damage.parts){
        dmgSettings = categories[dmgType] || {};
        config = dmgSettings[template.document.t];
        if (config && config.preset !== (0, $165cdb672a404ae7$export$680af52575be3523)) break;
    }
    if (!config) return false;
    $8d3e8f4e5d297304$var$fromConfig(mergeObject(config, {
        opacity: dmgSettings.opacity,
        tint: dmgSettings.tint
    }, true, true), template);
    return true;
}
function $8d3e8f4e5d297304$var$fromItem(wrapped, ...args) {
    const [item] = args;
    const template = wrapped(...args);
    if (!template) return template;
    let hasPreset = template.hasOwnProperty("tmfxPreset");
    if (hasPreset) return template;
    const settings = game.settings.get("tokenmagic", "autoTemplateSettings");
    let updated = settings.overrides ? $8d3e8f4e5d297304$var$fromOverrides(Object.values(settings.overrides), item, template) : false;
    if (!updated) $8d3e8f4e5d297304$var$fromCategories(settings.categories, item, template);
    return template;
}
const $8d3e8f4e5d297304$export$2e33ee4bec8a51fe = new $8d3e8f4e5d297304$export$7b4b307b24c88455();



class $1d3b56998084216a$export$974ac8c3143e0d38 {
    static get defaultConfiguration() {
        const defaultConfig = {
            categories: {},
            overrides: {
                0: {
                    target: "Stinking Cloud",
                    opacity: 0.5,
                    tint: "#00a80b",
                    preset: "Smoky Area",
                    texture: null
                },
                1: {
                    target: "Sanguine Mist",
                    opacity: 0.6,
                    tint: "#c41212",
                    preset: "Smoky Area"
                },
                2: {
                    target: "Web",
                    opacity: 0.5,
                    tint: "#808080",
                    preset: "Spider Web 2",
                    texture: null
                },
                3: {
                    target: "Incendiary Aura",
                    opacity: 0.2,
                    tint: "#b12910",
                    preset: "Smoke Filaments",
                    texture: null
                }
            }
        };
        Object.keys(CONFIG.PF2E.damageTraits).forEach((dmgType)=>{
            if (defaultConfig.categories[dmgType] == undefined) {
                const config = {
                    opacity: (0, $165cdb672a404ae7$export$7395e4cb572e863b),
                    tint: null
                };
                switch(dmgType.toLowerCase()){
                    case "acid":
                        config.tint = "#2d8000";
                        config.opacity = 0.6;
                        break;
                    case "cold":
                        config.tint = "#47b3ff";
                        break;
                    case "electricity":
                        break;
                    case "fire":
                        break;
                    case "force":
                        break;
                    case "mental":
                        config.tint = "#8000ff";
                        break;
                    case "negative":
                        config.tint = "#502673";
                        break;
                    case "poison":
                        config.tint = "#00a80b";
                        break;
                    case "positive":
                        break;
                    case "sonic":
                        config.tint = "#0060ff";
                        break;
                    default:
                        break;
                }
                defaultConfig.categories[dmgType] = config;
            }
            Object.keys(CONFIG.MeasuredTemplate.types).forEach((tplType)=>{
                const config = {
                    preset: (0, $165cdb672a404ae7$export$680af52575be3523),
                    texture: null
                };
                switch(dmgType.toLowerCase()){
                    case "acid":
                        config.preset = "Watery Surface 2";
                        break;
                    case "cold":
                        config.preset = "Thick Fog";
                        break;
                    case "electricity":
                        config.preset = "Shock";
                        break;
                    case "fire":
                        config.preset = "Flames";
                        break;
                    case "force":
                        config.preset = "Waves 3";
                        break;
                    case "mental":
                        config.preset = "Classic Rays";
                        break;
                    case "negative":
                        config.preset = "Smoke Filaments";
                        break;
                    case "poison":
                        config.preset = "Smoky Area";
                        break;
                    case "positive":
                        config.preset = "Annihilating Rays";
                        break;
                    case "sonic":
                        config.preset = "Waves";
                        break;
                    default:
                        break;
                }
                defaultConfig.categories[dmgType][tplType] = config;
            });
        });
        return defaultConfig;
    }
    constructor(){
        this._enabled = false;
    }
    configure(enabled = false) {
        if (game.system.id !== "pf2e") return;
        this._enabled = enabled;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {}
    getData() {
        return {
            hasAutoTemplates: true,
            dmgTypes: CONFIG.PF2E.damageTraits,
            templateTypes: CONFIG.MeasuredTemplate.types
        };
    }
    preCreateMeasuredTemplate(template) {
        let hasPreset = template.hasOwnProperty("tmfxPreset");
        if (hasPreset) return template;
        const origin = template.flags?.pf2e?.origin;
        const settings = game.settings.get("tokenmagic", "autoTemplateSettings");
        let updated = settings.overrides ? $1d3b56998084216a$var$fromOverrides(Object.values(settings.overrides), origin, template) : false;
        if (!updated) $1d3b56998084216a$var$fromCategories(settings.categories, origin, template);
        return template;
    }
}
function $1d3b56998084216a$var$fromConfig(config, template) {
    const o = {
        tokenmagic: {
            options: {}
        }
    };
    if (config.preset && config.preset !== "" && config.preset !== (0, $165cdb672a404ae7$export$680af52575be3523)) o.tokenmagic.options.tmfxPreset = config.preset;
    if (config.texture && config.texture !== "") o.tokenmagic.options.tmfxTexture = config.texture;
    if (config.tint && config.tint !== "") o.tokenmagic.options.tmfxTint = config.tint;
    o.tokenmagic.options.tmfxTextureAlpha = config.opacity;
    template.updateSource({
        flags: {
            tokenmagic: o.tokenmagic
        }
    });
}
function $1d3b56998084216a$var$fromOverrides(overrides = [], origin, template) {
    const { name: name, slug: slug } = origin;
    let configs = overrides.filter((el)=>el.target.toLowerCase() === name?.toLowerCase());
    if (configs.length === 0) return false;
    // if there are multiple overrides for the same item, the random one is chosen
    let config = configs[Math.floor(Math.random() * configs.length)];
    $1d3b56998084216a$var$fromConfig(config, template);
    return true;
}
function $1d3b56998084216a$var$fromCategories(categories = {}, origin, template) {
    if (!origin.traits?.length) return false;
    let config, dmgSettings;
    // some templates may have multiple traits
    // this loop looks over all of them until it finds one with a valid fx preset
    for (const trait of origin.traits){
        dmgSettings = categories[trait.toLowerCase()] || {};
        config = dmgSettings[template.t];
        if (config && config.preset !== (0, $165cdb672a404ae7$export$680af52575be3523)) break;
    }
    if (!config) return false;
    $1d3b56998084216a$var$fromConfig(mergeObject(config, {
        opacity: dmgSettings.opacity,
        tint: dmgSettings.tint
    }, true, true), template);
    return true;
}
const $1d3b56998084216a$export$437ce40001ae0212 = new $1d3b56998084216a$export$974ac8c3143e0d38();



class $0ef7da65087c6087$export$6e94d583ff29718b {
    static get defaultConfiguration() {
        const defaultConfig = {
            categories: {},
            overrides: {
                0: {
                    target: "\u0418\u0433\u043D\u0438",
                    opacity: 0.5,
                    tint: "#00a80b",
                    preset: "Flames",
                    texture: null
                }
            }
        };
        Object.keys(CONFIG.witcher.meleeSkills).forEach((meleeSkillType)=>{
            if (defaultConfig.categories[meleeSkillType] == undefined) {
                const config = {
                    opacity: (0, $165cdb672a404ae7$export$7395e4cb572e863b),
                    tint: null
                };
                switch(meleeSkillType.toLowerCase()){
                    case "brawling":
                        config.tint = "#2d8000";
                        config.opacity = 0.6;
                        break;
                    case "melee":
                        config.tint = "#47b3ff";
                        break;
                    case "small blades":
                        config.tint = "#502673";
                        break;
                    case "staff/spear":
                        config.tint = "#00a80b";
                        break;
                    case "swordsmanship":
                        config.tint = "#8000ff";
                        break;
                    case "athletics":
                        config.tint = "#0060ff";
                        break;
                    default:
                        break;
                }
                defaultConfig.categories[meleeSkillType] = config;
            }
            Object.keys(CONFIG.MeasuredTemplate.types).forEach((tplType)=>{
                const config = {
                    preset: (0, $165cdb672a404ae7$export$680af52575be3523),
                    texture: null
                };
                switch(meleeSkillType.toLowerCase()){
                    case "acid":
                        config.preset = "slashing";
                        break;
                    case "cold":
                        config.preset = "bludgeoning";
                        break;
                    case "fire":
                        config.preset = "piercing";
                        break;
                    case "force":
                        config.preset = "elemental";
                        break;
                    default:
                        break;
                }
                defaultConfig.categories[meleeSkillType][tplType] = config;
            });
        });
        return defaultConfig;
    }
    constructor(){
        this._enabled = false;
    }
    get enabled() {
        return this._enabled;
    }
    configure(enabled = false) {
        if (game.system.id !== "TheWitcherTRPG") return;
        this._enabled = enabled;
    }
    getData() {
        return {
            hasAutoTemplates: true,
            meleeSkills: CONFIG.witcher.meleeSkills,
            templateTypes: CONFIG.MeasuredTemplate.types
        };
    }
    preCreateMeasuredTemplate(template) {
        let hasPreset = template.hasOwnProperty("tmfxPreset");
        if (hasPreset) return template;
        const settings = game.settings.get("tokenmagic", "autoTemplateSettings");
        let updated = settings.overrides ? $0ef7da65087c6087$var$fromOverrides(Object.values(settings.overrides), template) : false;
        if (!updated) $0ef7da65087c6087$var$fromCategories(settings.categories, template);
    }
}
function $0ef7da65087c6087$var$fromConfig(config, templateData) {
    const o = {
        tokenmagic: {
            options: {}
        }
    };
    if (config.preset && config.preset !== "" && config.preset !== (0, $165cdb672a404ae7$export$680af52575be3523)) o.tokenmagic.options.tmfxPreset = config.preset;
    if (config.texture && config.texture !== "") o.tokenmagic.options.tmfxTexture = config.texture;
    if (config.tint && config.tint !== "") o.tokenmagic.options.tmfxTint = config.tint;
    o.tokenmagic.options.tmfxTextureAlpha = config.opacity;
    mergeObject(templateData, {
        "flags.tokenmagic": o.tokenmagic
    });
}
function $0ef7da65087c6087$var$fromOverrides(overrides = [], templateData) {
    const name = templateData.flags.witcher?.origin?.name;
    let config = overrides.find((el)=>el.target.toLowerCase() === name?.toLowerCase());
    if (!config) return false;
    $0ef7da65087c6087$var$fromConfig(config, templateData);
    return true;
}
function $0ef7da65087c6087$var$fromCategories(categories = {}, templateData) {
    const traits = templateData.flags.witcher?.origin?.traits ?? [];
    let config, dmgSettings;
    for (const trait of traits){
        dmgSettings = categories[trait] || {};
        config = dmgSettings[templateData.t];
        if (config && config.preset !== (0, $165cdb672a404ae7$export$680af52575be3523)) break;
    }
    if (!config) return false;
    $0ef7da65087c6087$var$fromConfig(mergeObject(config, {
        opacity: dmgSettings.opacity,
        tint: dmgSettings.tint
    }, true, true), templateData);
    return true;
}
const $0ef7da65087c6087$export$e8d12d88f51888cc = new $0ef7da65087c6087$export$6e94d583ff29718b();



const $4c34bd360e81b010$var$Magic = (0, $97b1237a45b106ea$export$4367b12d875874d3)();
class $4c34bd360e81b010$export$804072f25096732f extends FormApplication {
    constructor(object = {}, options){
        super(object, options);
    }
    /** @override */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            template: "modules/tokenmagic/templates/settings/settings.html",
            height: "auto",
            title: game.i18n.localize("TMFX.settings.autoTemplateSettings.dialog.title"),
            width: 600,
            classes: [
                "tokenmagic",
                "settings"
            ],
            tabs: [
                {
                    navSelector: ".tabs",
                    contentSelector: "form",
                    initial: "name"
                }
            ],
            submitOnClose: false
        };
    }
    static init() {
        const menuAutoTemplateSettings = {
            key: "autoTemplateSettings",
            config: {
                name: game.i18n.localize("TMFX.settings.autoTemplateSettings.button.name"),
                label: game.i18n.localize("TMFX.settings.autoTemplateSettings.button.label"),
                hint: game.i18n.localize("TMFX.settings.autoTemplateSettings.button.hint"),
                type: $4c34bd360e81b010$export$804072f25096732f,
                restricted: true
            }
        };
        const settingAutoTemplateSettings = {
            key: "autoTemplateSettings",
            config: {
                name: game.i18n.localize("TMFX.settings.autoTemplateSettings.name"),
                hint: game.i18n.localize("TMFX.settings.autoTemplateSettings.hint"),
                scope: "world",
                config: false,
                default: {},
                type: Object
            }
        };
        const templates = this.getSystemTemplates();
        let hasAutoTemplates = !!templates;
        if (templates) {
            game.settings.registerMenu("tokenmagic", menuAutoTemplateSettings.key, menuAutoTemplateSettings.config);
            game.settings.register("tokenmagic", settingAutoTemplateSettings.key, mergeObject(settingAutoTemplateSettings.config, {
                default: templates.constructor.defaultConfiguration
            }, true, true));
        }
        game.settings.register("tokenmagic", "autoTemplateEnabled", {
            name: game.i18n.localize("TMFX.settings.autoTemplateEnabled.name"),
            hint: game.i18n.localize("TMFX.settings.autoTemplateEnabled.hint"),
            scope: "world",
            config: hasAutoTemplates,
            default: hasAutoTemplates,
            type: Boolean,
            onChange: (value)=>$4c34bd360e81b010$export$804072f25096732f.configureAutoTemplate(value)
        });
        game.settings.register("tokenmagic", "defaultTemplateOnHover", {
            name: game.i18n.localize("TMFX.settings.defaultTemplateOnHover.name"),
            hint: game.i18n.localize("TMFX.settings.defaultTemplateOnHover.hint"),
            scope: "world",
            config: true,
            default: hasAutoTemplates,
            type: Boolean,
            onChange: ()=>window.location.reload()
        });
        game.settings.register("tokenmagic", "autohideTemplateElements", {
            name: game.i18n.localize("TMFX.settings.autohideTemplateElements.name"),
            hint: game.i18n.localize("TMFX.settings.autohideTemplateElements.hint"),
            scope: "world",
            config: true,
            default: true,
            type: Boolean,
            onChange: ()=>window.location.reload()
        });
        game.settings.register("tokenmagic", "useAdditivePadding", {
            name: game.i18n.localize("TMFX.settings.useMaxPadding.name"),
            hint: game.i18n.localize("TMFX.settings.useMaxPadding.hint"),
            scope: "world",
            config: true,
            default: false,
            type: Boolean
        });
        game.settings.register("tokenmagic", "minPadding", {
            name: game.i18n.localize("TMFX.settings.minPadding.name"),
            hint: game.i18n.localize("TMFX.settings.minPadding.hint"),
            scope: "world",
            config: true,
            default: 50,
            type: Number
        });
        game.settings.register("tokenmagic", "fxPlayerPermission", {
            name: game.i18n.localize("TMFX.settings.fxPlayerPermission.name"),
            hint: game.i18n.localize("TMFX.settings.fxPlayerPermission.hint"),
            scope: "world",
            config: true,
            default: false,
            type: Boolean
        });
        game.settings.register("tokenmagic", "importOverwrite", {
            name: game.i18n.localize("TMFX.settings.importOverwrite.name"),
            hint: game.i18n.localize("TMFX.settings.importOverwrite.hint"),
            scope: "world",
            config: true,
            default: false,
            type: Boolean
        });
        game.settings.register("tokenmagic", "useZOrder", {
            name: game.i18n.localize("TMFX.settings.useZOrder.name"),
            hint: game.i18n.localize("TMFX.settings.useZOrder.hint"),
            scope: "world",
            config: true,
            default: false,
            type: Boolean
        });
        game.settings.register("tokenmagic", "disableAnimations", {
            name: game.i18n.localize("TMFX.settings.disableAnimations.name"),
            hint: game.i18n.localize("TMFX.settings.disableAnimations.hint"),
            scope: "client",
            config: true,
            default: false,
            type: Boolean,
            onChange: ()=>window.location.reload()
        });
        game.settings.register("tokenmagic", "disableCaching", {
            name: game.i18n.localize("TMFX.settings.disableCaching.name"),
            hint: game.i18n.localize("TMFX.settings.disableCaching.hint"),
            scope: "client",
            config: true,
            default: true,
            type: Boolean
        });
        game.settings.register("tokenmagic", "disableVideo", {
            name: game.i18n.localize("TMFX.settings.disableVideo.name"),
            hint: game.i18n.localize("TMFX.settings.disableVideo.hint"),
            scope: "world",
            config: true,
            default: false,
            type: Boolean,
            onChange: ()=>window.location.reload()
        });
        game.settings.register("tokenmagic", "presets", {
            name: "Token Magic FX presets",
            hint: "Token Magic FX presets",
            scope: "world",
            config: false,
            default: (0, $ff7eec2964ce8415$export$7afd9c1079ecedf7),
            type: Object
        });
        game.settings.register("tokenmagic", "migration", {
            name: "TMFX Data Version",
            hint: "TMFX Data Version",
            scope: "world",
            config: false,
            default: (0, $a48a250facc06caa$export$df3971f21aaed551).ARCHAIC,
            type: String
        });
        loadTemplates([
            "modules/tokenmagic/templates/settings/settings.html",
            "modules/tokenmagic/templates/settings/dnd5e/categories.html",
            "modules/tokenmagic/templates/settings/dnd5e/overrides.html",
            "modules/tokenmagic/templates/settings/pf2e/categories.html",
            "modules/tokenmagic/templates/settings/pf2e/overrides.html",
            "modules/tokenmagic/templates/settings/TheWitcherTRPG/categories.html",
            "modules/tokenmagic/templates/settings/TheWitcherTRPG/overrides.html"
        ]);
    }
    static configureAutoTemplate(enabled = false) {
        this.getSystemTemplates()?.configure(enabled);
    }
    static getSystemTemplates() {
        switch(game.system.id){
            case "dnd5e":
                return 0, $8d3e8f4e5d297304$export$2e33ee4bec8a51fe;
            case "pf2e":
                return 0, $1d3b56998084216a$export$437ce40001ae0212;
            case "TheWitcherTRPG":
                return 0, $0ef7da65087c6087$export$e8d12d88f51888cc;
            default:
                return null;
        }
    }
    getSettingsData() {
        let settingsData = {
            autoTemplateEnable: game.settings.get("tokenmagic", "autoTemplateEnabled")
        };
        if ($4c34bd360e81b010$export$804072f25096732f.getSystemTemplates()) settingsData["autoTemplateSettings"] = game.settings.get("tokenmagic", "autoTemplateSettings");
        return settingsData;
    }
    /** @override */ getData() {
        let data = super.getData();
        data.hasAutoTemplates = false;
        data.emptyPreset = (0, $165cdb672a404ae7$export$680af52575be3523);
        const templates = $4c34bd360e81b010$export$804072f25096732f.getSystemTemplates();
        if (templates) mergeObject(data, templates.getData());
        data.presets = $4c34bd360e81b010$var$Magic.getPresets((0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).TEMPLATE).sort(function(a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
        data.system = {
            id: game.system.id,
            title: game.system.title
        };
        data.settings = this.getSettingsData();
        data.submitText = game.i18n.localize("TMFX.save");
        return data;
    }
    /** @override */ async _updateObject(_, formData) {
        const data = expandObject(formData);
        for (let [key, value] of Object.entries(data)){
            if (key === "autoTemplateSettings" && value.overrides) {
                const compacted = {};
                Object.values(value.overrides).forEach((val, idx)=>compacted[idx] = val);
                value.overrides = compacted;
            }
            await game.settings.set("tokenmagic", key, value);
        }
    }
    /** @override */ activateListeners(html) {
        super.activateListeners(html);
        html.find("button.add-override").click(this._onAddOverride.bind(this));
        html.find("button.remove-override").click(this._onRemoveOverride.bind(this));
    }
    async _onAddOverride(event) {
        event.preventDefault();
        let idx = 0;
        const entries = event.target.closest("div.tab").querySelectorAll("div.override-entry");
        const last = entries[entries.length - 1];
        if (last) idx = last.dataset.idx + 1;
        let updateData = {};
        updateData[`autoTemplateSettings.overrides.${idx}.target`] = "";
        updateData[`autoTemplateSettings.overrides.${idx}.opacity`] = (0, $165cdb672a404ae7$export$7395e4cb572e863b);
        updateData[`autoTemplateSettings.overrides.${idx}.tint`] = null;
        updateData[`autoTemplateSettings.overrides.${idx}.preset`] = (0, $165cdb672a404ae7$export$680af52575be3523);
        updateData[`autoTemplateSettings.overrides.${idx}.texture`] = null;
        await this._onSubmit(event, {
            updateData: updateData,
            preventClose: true
        });
        this.render();
    }
    async _onRemoveOverride(event) {
        event.preventDefault();
        let idx = event.target.dataset.idx;
        const el = event.target.closest(`div[data-idx="${idx}"]`);
        if (!el) return true;
        el.remove();
        await this._onSubmit(event, {
            preventClose: true
        });
        this.render();
    }
}
Hooks.once("init", ()=>{
    // Extracted from https://github.com/leapfrogtechnology/just-handlebars-helpers/
    Handlebars.registerHelper("concat", function(...params) {
        // Ignore the object appended by handlebars.
        if (typeof params[params.length - 1] === "object") params.pop();
        return params.join("");
    });
    $4c34bd360e81b010$export$804072f25096732f.init();
    $4c34bd360e81b010$export$804072f25096732f.configureAutoTemplate(game.settings.get("tokenmagic", "autoTemplateEnabled"));
    const wmtdUpdate = async function(wrapped, ...args) {
        const [document] = args;
        let preset, hasPresetData;
        const tex = document.texture ?? "";
        const hasTexture = !!document.texture;
        const opt = document.flags?.tokenmagic?.options ?? null;
        if (!opt) preset = document["flags.tokenmagic.templateData.preset"];
        hasPresetData = !!preset;
        //const hasOpt = data["flags.tokenmagic"]?.options ?? null;
        if (hasTexture) document.texture = (0, $97b1237a45b106ea$export$3bebb302ab08af33)(document.texture);
        if (opt == null) {
            if (hasPresetData && preset !== (0, $165cdb672a404ae7$export$680af52575be3523)) {
                let defaultTexture = $4c34bd360e81b010$var$Magic._getPresetTemplateDefaultTexture(preset);
                if (!(defaultTexture == null)) {
                    if (tex === "" || tex.startsWith("modules/tokenmagic/fx/assets/templates/")) document.texture = defaultTexture;
                }
            } else if (hasTexture && tex.startsWith("modules/tokenmagic/fx/assets/templates/") && hasPresetData && preset === (0, $165cdb672a404ae7$export$680af52575be3523)) document.texture = "";
        }
        return await wrapped(...args);
    };
    const wmtDraw = async function(wrapped, ...args) {
        if (this.document.texture) this.document.texture = (0, $97b1237a45b106ea$export$3bebb302ab08af33)(this.document.texture);
        const retVal = await wrapped(...args);
        this.template.alpha = this.document.getFlag("tokenmagic", "templateData")?.opacity ?? 1;
        return retVal;
    };
    let wmtApplyRenderFlags;
    let wmtApplyRenderFlagsType;
    let wmtRefreshTemplate;
    let wmtRefreshTemplateType;
    if (!(0, $97b1237a45b106ea$export$62085f0363fc8c9)()) {
        const toRadians = Math.toRadians;
        wmtApplyRenderFlagsType = "WRAPPER";
        wmtApplyRenderFlags = function(wrapped, ...args) {
            const [flags] = args;
            if (flags?.refreshShape) flags.refreshShape = this.template && !this.template._destroyed;
            return wrapped(...args);
        };
        /* ------------------------------------------------------------------------------------ */ wmtRefreshTemplateType = "OVERRIDE";
        /**
		 *
		 * @return {wmtRefreshTemplate}
		 */ wmtRefreshTemplate = function() {
            const t = this.template.clear();
            if (!this.isVisible) return;
            // Draw the Template outline
            t.lineStyle(this._borderThickness, this.borderColor, 0.75).beginFill(0x000000, 0.0);
            // Fill Color or Texture
            if (this.texture) {
                let mat = PIXI.Matrix.IDENTITY;
                // rectangle
                if (this.shape.width && this.shape.height) mat.scale(this.shape.width / this.texture.width, this.shape.height / this.texture.height);
                else if (this.shape.radius) {
                    mat.scale(this.shape.radius * 2 / this.texture.height, this.shape.radius * 2 / this.texture.width);
                    // Circle center is texture start...
                    mat.translate(-this.shape.radius, -this.shape.radius);
                } else if (this.document.t === "ray") {
                    const d = canvas.dimensions, height = this.document.width * d.size / d.distance, width = this.document.distance * d.size / d.distance;
                    mat.scale(width / this.texture.width, height / this.texture.height);
                    mat.translate(0, -height * 0.5);
                    mat.rotate(toRadians(this.document.direction));
                } else {
                    // cone
                    const d = canvas.dimensions;
                    // Extract and prepare data
                    let { direction: direction, distance: distance, angle: angle } = this.document;
                    distance *= d.size / d.distance;
                    direction = Math.toRadians(direction);
                    const width = this.document.distance * d.size / d.distance;
                    const angles = [
                        angle / -2,
                        angle / 2
                    ];
                    distance = distance / Math.cos(Math.toRadians(angle / 2));
                    // Get the cone shape as a polygon
                    const rays = angles.map((a)=>Ray.fromAngle(0, 0, direction + Math.toRadians(a), distance + 1));
                    const height = Math.sqrt((rays[0].B.x - rays[1].B.x) * (rays[0].B.x - rays[1].B.x) + (rays[0].B.y - rays[1].B.y) * (rays[0].B.y - rays[1].B.y));
                    mat.scale(width / this.texture.width, height / this.texture.height);
                    mat.translate(0, -height / 2);
                    mat.rotate(toRadians(this.document.direction));
                }
                t.beginTextureFill({
                    texture: this.texture,
                    matrix: mat,
                    alpha: 1.0
                });
                const source = getProperty(this.texture, "baseTexture.resource.source");
                if (source && source.tagName === "VIDEO") {
                    source.loop = true;
                    source.muted = true;
                    game.video.play(source);
                }
            } else t.beginFill(0x000000, 0.0);
            // Draw the shape
            t.drawShape(this.shape);
            // Draw origin and destination points
            t.lineStyle(this._borderThickness, 0x000000).beginFill(0x000000, 0.5).drawCircle(0, 0, 6).drawCircle(this.ray.dx, this.ray.dy, 6);
            // Update visibility
            this.controlIcon.visible = !!this.layer.active;
            this.controlIcon.border.visible = !!this.hover;
            const alpha = this.document.getFlag("tokenmagic", "templateData")?.opacity ?? 1;
            t.alpha = this.hover ? alpha / 1.25 : alpha;
            return this;
        };
    /* ------------------------------------------------------------------------------------ */ }
    if (game.settings.get("tokenmagic", "autohideTemplateElements")) {
        /**
		 *
		 * @param wrapped
		 * @param args
		 * @return {*}
		 */ const autohideTemplateElements = function(wrapped, ...args) {
            // Save texture and border thickness
            const texture = this.texture;
            const borderThickness = this._borderThickness;
            // Hide template texture while moving
            if (this._original || this.parent === canvas.templates.preview) this.texture = null;
            // Show border outline only on hover if the template is textured
            if (this.texture && this.texture !== "" && !this._hover) this._borderThickness = 0;
            const retVal = wrapped(...args);
            // Restore texture and border thickness
            this.texture = texture;
            this._borderThickness = borderThickness;
            {
                // Show the origin/destination points and ruler text only on hover or while creating but not while moving
                const template = this._original ?? this;
                const show = !this._original && (this._hover || this.parent === canvas.templates.preview);
                if (!show && template.template?.geometry) {
                    // Hide origin and destination points, i.e., hide everything except the template shape
                    for (const document of template.template.geometry.graphicsData)if (document.shape !== template.shape) {
                        document.fillStyle.visible = false;
                        document.lineStyle.visible = false;
                    }
                    template.template.geometry.invalidate();
                }
                if (template.ruler) template.ruler.renderable = show;
                if (template.controlIcon) template.controlIcon.renderable = template.owner;
                if (template.handle) template.handle.renderable = template.owner;
            }
            return retVal;
        };
        /* ------------------------------------------------------------------------------------ */ if (wmtApplyRenderFlags) {
            const _wmtApplyRenderFlags = wmtApplyRenderFlags;
            wmtApplyRenderFlags = function() {
                return autohideTemplateElements.call(this, _wmtApplyRenderFlags.bind(this), ...arguments);
            };
        } else {
            wmtApplyRenderFlagsType = "WRAPPER";
            wmtApplyRenderFlags = autohideTemplateElements;
        }
    }
    if (game.settings.get("tokenmagic", "defaultTemplateOnHover")) Hooks.on("canvasReady", ()=>{
        canvas.stage.on("mousemove", (event)=>{
            const { x: mx, y: my } = event.data.getLocalPosition(canvas.templates);
            for (const template of canvas.templates.placeables){
                const hl = canvas.grid.getHighlightLayer(`MeasuredTemplate.${template.id}`);
                const opacity = template.document.getFlag("tokenmagic", "templateData")?.opacity ?? 1;
                if (template.texture && template.texture !== "") {
                    const { x: cx, y: cy } = template.center;
                    const mouseover = template.shape?.contains(mx - cx, my - cy);
                    hl.renderable = mouseover;
                    template.template.alpha = (mouseover ? 0.5 : 1.0) * opacity;
                } else {
                    hl.renderable = true;
                    template.template.alpha = opacity;
                }
            }
        });
    });
    if (game.modules.get("lib-wrapper")?.active) {
        libWrapper.register("tokenmagic", "MeasuredTemplateDocument.prototype.update", wmtdUpdate, "WRAPPER");
        libWrapper.register("tokenmagic", "MeasuredTemplate.prototype._draw", wmtDraw, "WRAPPER");
        if (wmtApplyRenderFlags) libWrapper.register("tokenmagic", "MeasuredTemplate.prototype._applyRenderFlags", wmtApplyRenderFlags, wmtApplyRenderFlagsType);
        if (wmtRefreshTemplate) libWrapper.register("tokenmagic", "MeasuredTemplate.prototype._refreshTemplate", wmtRefreshTemplate, wmtRefreshTemplateType);
    } else {
        const cmtdUpdate = MeasuredTemplateDocument.prototype.update;
        MeasuredTemplateDocument.prototype.update = function() {
            return wmtdUpdate.call(this, cmtdUpdate.bind(this), ...arguments);
        };
        const cmtDraw = MeasuredTemplate.prototype._draw;
        MeasuredTemplate.prototype._draw = function() {
            return wmtDraw.call(this, cmtDraw.bind(this), ...arguments);
        };
        if (wmtApplyRenderFlags) {
            if (wmtApplyRenderFlagsType && wmtApplyRenderFlagsType !== "OVERRIDE") {
                const cmtApplyRenderFlags = MeasuredTemplate.prototype._applyRenderFlags;
                MeasuredTemplate.prototype._applyRenderFlags = function() {
                    return wmtApplyRenderFlags.call(this, cmtApplyRenderFlags.bind(this), ...arguments);
                };
            } else MeasuredTemplate.prototype._applyRenderFlags = wmtApplyRenderFlags;
        }
        if (wmtRefreshTemplate) {
            if (wmtRefreshTemplateType && wmtRefreshTemplateType !== "OVERRIDE") {
                const cmtRefreshTemplate = MeasuredTemplate.prototype._refreshTemplate;
                MeasuredTemplate.prototype._refreshTemplate = function() {
                    return wmtRefreshTemplate.call(this, cmtRefreshTemplate.bind(this), ...arguments);
                };
            } else MeasuredTemplate.prototype._refreshTemplate = wmtRefreshTemplate;
        }
    }
});


/*

It's getting messy here !
I will fix it in a future version
(+ duplicated code to factorize and code to improve)

*/ const $97b1237a45b106ea$var$moduleTM = "module.tokenmagic";
const $97b1237a45b106ea$export$c67e46de1ec7dfa6 = {
    adjustment: (0, $2fe05231a5671b9f$export$1545cd3bbac349ce),
    ascii: (0, $f1f93c519987627d$export$1efdcfd4cb16ac29),
    dot: (0, $a0121c7d42a6541e$export$d75528d01a211954),
    distortion: (0, $463c3c68cacec30e$export$2d59c37be5e749a7),
    crt: (0, $0213c2d85a9c5b71$export$1ab2366e25c48ed5),
    oldfilm: (0, $11a39396e5d8589b$export$2094be6cc744d7bc),
    glow: (0, $8224c68d08cc6843$export$3ea2d657d9f1c2fe),
    outline: (0, $5b47cd38a348aa0c$export$c04494508d798797),
    bevel: (0, $e609518cea3498ff$export$bcacf43f99a4009b),
    xbloom: (0, $4d02ab9fc92d64ef$export$e7bbc116d34f17bc),
    shadow: (0, $5ba7aae303e84dac$export$3fa21fd22495d321),
    twist: (0, $0643f21646f7ec8f$export$f4e603bceef0312b),
    zoomblur: (0, $cb3547a2fc8518c6$export$767afdf6d9357594),
    blur: (0, $b8712d076a565747$export$efc74ab3983784c5),
    bulgepinch: (0, $cde275935cddb40a$export$c1f4d37fd591fb01),
    zapshadow: (0, $d6a2679398073147$export$228231731d6adde3),
    ray: (0, $56e6cd37bbebe026$export$1992e0dceaf7be8),
    fog: (0, $2a5c150fd96450c6$export$f17580ed76af4408),
    xfog: (0, $6ca08fc9db20c2ac$export$da3eec8748131849),
    electric: (0, $5a0c0cac6edacb2c$export$22f86bc7a100befc),
    wave: (0, $6c6b7c04c1d5fa2e$export$4eeb783ef7c17da8),
    shockwave: (0, $207c96b47058a247$export$985076e41ccfd508),
    fire: (0, $f77ec43cfcb845eb$export$fd0af22b8dd4eb46),
    fumes: (0, $223f1247ddebb00e$export$60b593b6124d1ebc),
    smoke: (0, $a08c1e6a648373ca$export$2ba7369b7ae4551b),
    flood: (0, $a0aac33c68ab6b34$export$bf2c97ada2c2b329),
    images: (0, $8d8f4cc819ce08c5$export$7f3e808c6a96411c),
    field: (0, $7eae9962e69f7347$export$8353bd967bf6b04d),
    xray: (0, $5b05583cddbffe38$export$a909c602e4f39889),
    liquid: (0, $34c9aecbf210823d$export$76689802e4398e92),
    xglow: (0, $4130c396ef8a0d82$export$dbf4d88a9f2fd9e6),
    pixel: (0, $9d7a67912a650eb7$export$26c3bdb8b50816cc),
    web: (0, $30e3cacecefea03b$export$be2f10404718dbad),
    ripples: (0, $5c475373f35e120f$export$3f7eb987d91438a2),
    globes: (0, $6fa47e94e013e8e5$export$dd8c8c08b796f015),
    transform: (0, $5ae15acc2d1ee812$export$e8341be799357874),
    splash: (0, $1737f68aeb781d93$export$df3de41f3315cb09),
    polymorph: (0, $6d7cfa7b8cdebcda$export$cf7260b11c6fd85d),
    xfire: (0, $792ddf9c96904ba5$export$f5292971f4ab78f9),
    sprite: (0, $14ec92966e5a1c8e$export$96f9417ff369e52),
    spriteMask: (0, $756e6c880a697f93$export$4569ea13832ce134),
    replaceColor: (0, $66619a9ab494ce98$export$c3ce4d77f1074b4d),
    ddTint: (0, $4896edd1e4c7b975$export$1ee8d69885ee6ad1),
    rgbSplit: (0, $1e1fe8af01bced2b$export$767e09686399ca49)
};
const $97b1237a45b106ea$export$f2f6f02affe07ab5 = {
    TOKEN: Token.embeddedName,
    TILE: Tile.embeddedName,
    TEMPLATE: MeasuredTemplate.embeddedName,
    DRAWING: Drawing.embeddedName,
    NOT_SUPPORTED: null
};
function $97b1237a45b106ea$var$i18n(key) {
    return game.i18n.localize(key);
}
async function $97b1237a45b106ea$var$exportObjectAsJson(exportObj, exportName) {
    let jsonStr = JSON.stringify(exportObj, null, 4);
    const a = document.createElement("a");
    const file = new Blob([
        jsonStr
    ], {
        type: "plain/text"
    });
    a.href = URL.createObjectURL(file);
    a.download = exportName + ".json";
    a.click();
    URL.revokeObjectURL(a.href);
}
const $97b1237a45b106ea$export$157d7b8c087faa7b = {
    SET_FLAG: "TMFXSetFlag",
    SET_ANIME_FLAG: "TMFXSetAnimeFlag"
};
function $97b1237a45b106ea$export$24d33a6f4bffea69(placeable, flag, socketAction) {
    const data = {
        tmAction: socketAction,
        tmPlaceableId: placeable.id,
        tmPlaceableType: placeable._TMFXgetPlaceableType(),
        tmFlag: flag,
        tmViewedScene: game.user.viewedScene
    };
    game.socket.emit($97b1237a45b106ea$var$moduleTM, data, (resp)=>{});
}
function $97b1237a45b106ea$export$73ccc1811a23c47(moduleName) {
    return game.modules.has(moduleName) && game.modules.get(moduleName).active === true;
}
function $97b1237a45b106ea$export$a3e1d0865041c250() {
    return game.settings.get("tokenmagic", "minPadding");
}
function $97b1237a45b106ea$export$db02b1003f6b14db() {
    return game.settings.get("tokenmagic", "useAdditivePadding");
}
function $97b1237a45b106ea$export$4d149f3fface3da5() {
    return game.settings.get("tokenmagic", "disableCaching");
}
function $97b1237a45b106ea$export$62085f0363fc8c9() {
    return game.settings.get("tokenmagic", "disableVideo");
}
function $97b1237a45b106ea$export$485113ed30b22bb8() {
    const theOne = game.users.find((user)=>user.isGM && user.active);
    return theOne && game.user === theOne;
}
function $97b1237a45b106ea$export$ae4b89d79d01bd2b() {
    return game.settings.get("tokenmagic", "fxPlayerPermission") && !$97b1237a45b106ea$export$485113ed30b22bb8();
}
function $97b1237a45b106ea$export$2bf9d1af56f0b37d() {
    canvas.app.renderer.filter.useMaxPadding = !$97b1237a45b106ea$export$db02b1003f6b14db();
}
function $97b1237a45b106ea$export$222530a21fa4a417() {
    return game.settings.get("tokenmagic", "useZOrder");
}
function $97b1237a45b106ea$export$4876a704e2bf90fb() {
    return game.settings.get("tokenmagic", "disableAnimations");
}
function $97b1237a45b106ea$export$bef1f36f5486a6a3(output) {
    let logged = "%cTokenMagic %c| " + output;
    console.log(logged, "color:#4BC470", "color:#B3B3B3");
}
function $97b1237a45b106ea$export$c106dd0671a0fc2d(output) {
    let logged = "TokenMagic | " + output;
    console.warn(logged);
}
function $97b1237a45b106ea$export$a3bc9b8ed74fc(output) {
    let logged = "TokenMagic | " + output;
    console.error(logged);
}
function $97b1237a45b106ea$export$3bebb302ab08af33(path) {
    /*
      /prefix/...               =>   ...
      /modules/tokenmagic/...   =>   modules/tokenmagic/...
  */ if (path) {
        const base = "/modules/tokenmagic";
        const url = new URL(path, window.location.href);
        if (url.origin === window.location.origin) {
            let prefix = "/";
            try {
                if (ROUTE_PREFIX) prefix = new URL(ROUTE_PREFIX, window.location.origin).pathname;
            } catch (err) {}
            path = url.pathname;
            if (prefix === "/") path = path.slice(1);
            else if (path.startsWith(prefix) && (path.length === prefix.length || path[prefix.length] === "/")) path = path.slice(prefix.length + 1);
            else if (path.startsWith(base) && (path.length === base.length || path[base.length] === "/")) path = path.slice(1);
        } else path = url.href;
    }
    return path;
}
function $97b1237a45b106ea$export$674b9bd489502778() {
    const authorizedLayers = [
        canvas.tokens,
        canvas.tiles,
        canvas.drawings
    ];
    if (authorizedLayers.some((layer)=>layer === canvas.activeLayer)) return canvas.activeLayer.placeables.filter((p)=>p.controlled === true) || [];
    else return [];
}
function $97b1237a45b106ea$export$c0c03469ba031852() {
    return canvas.tokens.placeables.filter((placeable)=>placeable.isTargeted);
}
function $97b1237a45b106ea$export$5008448b4c27fa2b(id, type) {
    let placeable = null;
    function findPlaceable(placeables, id) {
        let rplaceable = null;
        if (!(placeables == null) && placeables.length > 0) rplaceable = placeables.find((n)=>n.id === id);
        return rplaceable;
    }
    switch(type){
        case $97b1237a45b106ea$export$f2f6f02affe07ab5.TOKEN:
            placeable = findPlaceable(canvas.tokens.placeables, id);
            break;
        case $97b1237a45b106ea$export$f2f6f02affe07ab5.TILE:
            placeable = findPlaceable(canvas.tiles.placeables, id);
            break;
        case $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE:
            placeable = findPlaceable(canvas.templates.placeables, id);
            break;
        case $97b1237a45b106ea$export$f2f6f02affe07ab5.DRAWING:
            placeable = findPlaceable(canvas.drawings.placeables, id);
            break;
    }
    return placeable;
}
/**
 * Randomizes params using 'randomized' field.
 * 'randomized' is an object consisting of keys named after params to be randomized, which map either
 * to arrays or ranges which will be used to generate a random value.
 * e.g.
 * {
 *  param1: ['foo1', 'foo2', 'foo3'],
 *  param2: { list: ['foo1', 'foo2', 'foo3'], link: 'param5'},
 *  param3: { val1: 0, val2: 1, step: 0.1},
 *  param4: { val1: 0, val2: 10, step: 1, link: 'param6'},
 * }
 * 'link' will assign the same generated value to one other param.
 */ function $97b1237a45b106ea$var$randomizeParams(params1) {
    if (params1.randomized.hasOwnProperty("active") && !params1.randomized.active) return;
    for (const [param, opts] of Object.entries(params1.randomized)){
        let rVal;
        if (Array.isArray(opts) || opts.hasOwnProperty("list")) {
            const list = opts.list ?? opts;
            rVal = list[Math.floor(Math.random() * list.length)];
        } else {
            const min = Math.min(opts.val1, opts.val2);
            const max = Math.max(opts.val1, opts.val2);
            const step = opts.step ?? 1;
            const stepsInRange = (max - min + (Number.isInteger(step) ? 1 : 0)) / step;
            rVal = Math.floor(Math.random() * stepsInRange) * step + min;
        }
        setProperty(params1, param, rVal);
        if (opts.hasOwnProperty("link")) setProperty(params1, opts.link, rVal);
    }
}
function $97b1237a45b106ea$export$45dd0c4934db71d0(target, ...sources) {
    sources.forEach((source)=>{
        Object.keys(source).forEach((key)=>{
            const s_val = source[key];
            const t_val = target[key];
            if (s_val instanceof Array) target[key] = [
                ...s_val
            ];
            else target[key] = t_val && s_val && typeof t_val === "object" && typeof s_val === "object" ? $97b1237a45b106ea$export$45dd0c4934db71d0(t_val, s_val) : s_val;
        });
    });
    return target;
}
function $97b1237a45b106ea$export$4367b12d875874d3() {
    let _cachedContainer = new PIXI.Container();
    async function addFiltersOnSelected(paramsArray, replace = false) {
        if (!Array.isArray(paramsArray)) paramsArray = getPreset(paramsArray);
        const controlled = $97b1237a45b106ea$export$674b9bd489502778();
        if (!(controlled == null) && controlled.length > 0) for (const placeable of controlled)await addFilters(placeable, paramsArray, replace);
    }
    async function addUpdateFiltersOnSelected(paramsArray) {
        if (!Array.isArray(paramsArray)) paramsArray = getPreset(paramsArray);
        const controlled = $97b1237a45b106ea$export$674b9bd489502778();
        if (!(controlled == null) && controlled.length > 0) for (const placeable of controlled)await addUpdateFilters(placeable, paramsArray);
    }
    async function addUpdateFiltersOnTargeted(paramsArray) {
        if (!Array.isArray(paramsArray)) paramsArray = getPreset(paramsArray);
        const targeted = $97b1237a45b106ea$export$c0c03469ba031852();
        if (!(targeted == null) && targeted.length > 0) for (const token of targeted)await addUpdateFilters(token, paramsArray);
    }
    async function addFiltersOnTargeted(paramsArray, replace = false) {
        if (!Array.isArray(paramsArray)) paramsArray = getPreset(paramsArray);
        const targeted = $97b1237a45b106ea$export$c0c03469ba031852();
        if (!(targeted == null) && targeted.length > 0) for (const token of targeted)await addFilters(token, paramsArray, replace);
    }
    async function addFilters(placeable, paramsArray, replace = false) {
        if (!Array.isArray(paramsArray)) paramsArray = getPreset(paramsArray);
        if (!(paramsArray instanceof Array && paramsArray.length > 0) || placeable == null) return;
        let actualFlags = replace ? null : placeable.document.getFlag("tokenmagic", "filters");
        let newFlags = [];
        for (const params1 of paramsArray){
            if (!params1.hasOwnProperty("filterType") || !$97b1237a45b106ea$export$c67e46de1ec7dfa6.hasOwnProperty(params1.filterType)) // one invalid ? all rejected.
            return;
            if (!params1.hasOwnProperty("rank")) params1.rank = placeable._TMFXgetMaxFilterRank();
            if (!params1.hasOwnProperty("filterId") || params1.filterId == null) params1.filterId = randomID();
            if (!params1.hasOwnProperty("enabled") || !(typeof params1.enabled === "boolean")) params1.enabled = true;
            if (params1.hasOwnProperty("randomized")) $97b1237a45b106ea$var$randomizeParams(params1);
            params1.placeableId = placeable.id;
            params1.filterInternalId = randomID();
            params1.filterOwner = game.data.userId;
            params1.placeableType = placeable._TMFXgetPlaceableType();
            params1.updateId = randomID();
            newFlags.push({
                tmFilters: {
                    tmFilterId: params1.filterId,
                    tmFilterInternalId: params1.filterInternalId,
                    tmFilterType: params1.filterType,
                    tmFilterOwner: params1.filterOwner,
                    tmParams: params1
                }
            });
        }
        if (!(actualFlags == null)) newFlags = actualFlags.concat(newFlags);
        await placeable._TMFXsetFlag(newFlags);
    }
    async function addUpdateFilters(placeable, paramsArray) {
        if (!paramsArray instanceof Array || paramsArray.length < 1) return;
        let flags = placeable.document.getFlag("tokenmagic", "filters");
        let workingFlags = [];
        if (flags) flags.forEach((flag)=>{
            workingFlags.push(duplicate(flag));
        });
        let newFlags = [];
        let updateParams;
        for (const params1 of paramsArray){
            updateParams = false;
            params1.updateId = randomID();
            if (params1.hasOwnProperty("randomized")) $97b1237a45b106ea$var$randomizeParams(params1);
            workingFlags.forEach((flag)=>{
                if (flag.tmFilters.tmFilterId === params1.filterId && flag.tmFilters.tmFilterType === params1.filterType) {
                    if (flag.tmFilters.hasOwnProperty("tmParams")) {
                        $97b1237a45b106ea$export$45dd0c4934db71d0(flag.tmFilters.tmParams, params1);
                        updateParams = true;
                    }
                }
            });
            if (!updateParams) {
                if (!params1.hasOwnProperty("filterType") || !$97b1237a45b106ea$export$c67e46de1ec7dfa6.hasOwnProperty(params1.filterType)) // one invalid ? all rejected (even the update)
                return;
                if (!params1.hasOwnProperty("rank")) params1.rank = placeable._TMFXgetMaxFilterRank();
                if (!params1.hasOwnProperty("filterId") || params1.filterId == null) params1.filterId = randomID();
                if (!params1.hasOwnProperty("enabled") || !(typeof params1.enabled === "boolean")) params1.enabled = true;
                params1.placeableId = placeable.id;
                params1.filterInternalId = randomID();
                params1.filterOwner = game.data.userId;
                params1.placeableType = placeable._TMFXgetPlaceableType();
                newFlags.push({
                    tmFilters: {
                        tmFilterId: params1.filterId,
                        tmFilterInternalId: params1.filterInternalId,
                        tmFilterType: params1.filterType,
                        tmFilterOwner: params1.filterOwner,
                        tmParams: params1
                    }
                });
            }
        }
        if (newFlags.length > 0) workingFlags = newFlags.concat(workingFlags);
        await placeable._TMFXsetFlag(workingFlags);
    }
    async function updateFilters(paramsArray) {
        if (params == null || !params.hasOwnProperty("filterId")) return;
        let placeableIdSet = new Set();
        let animations = (0, $c1844ae22deae2c0$export$b229f242afc35ae9).getAnimeMap();
        if (animations.size <= 0) return;
        animations.forEach((anime, id)=>{
            let filterIdMatch = (params1)=>params1.filterId === anime.puppet.filterId;
            if (paramsArray.some(filterIdMatch)) placeableIdSet.add(anime.puppet.placeableId);
        });
        if (placeableIdSet.size <= 0) return;
        for (const placeableId of placeableIdSet){
            // we must browse the collection of placeables whatever their types
            // we have just a filterId.
            let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(placeableId, $97b1237a45b106ea$export$f2f6f02affe07ab5.TOKEN);
            if (placeable == null) placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(placeableId, $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE);
            if (placeable == null) placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(placeableId, $97b1237a45b106ea$export$f2f6f02affe07ab5.TILE);
            if (placeable == null) placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(placeableId, $97b1237a45b106ea$export$f2f6f02affe07ab5.DRAWING);
            if (!(placeable == null) && placeable instanceof PlaceableObject) await updateFiltersByPlaceable(placeable, paramsArray);
        }
    }
    async function updateFiltersOnSelected(paramsArray) {
        let placeables = $97b1237a45b106ea$export$674b9bd489502778();
        if (placeables == null || placeables.length < 1) return;
        if (typeof paramsArray === "string") paramsArray = getPreset(paramsArray);
        if (!(paramsArray instanceof Array) || paramsArray.length < 1) return;
        for (const placeable of placeables)await updateFiltersByPlaceable(placeable, paramsArray);
    }
    async function updateFiltersOnTargeted(paramsArray) {
        let targeted = $97b1237a45b106ea$export$c0c03469ba031852();
        if (targeted == null || targeted.length < 1) return;
        if (typeof paramsArray === "string") paramsArray = getPreset(paramsArray);
        if (!(paramsArray instanceof Array) || paramsArray.length < 1) return;
        for (const token of targeted)await updateFiltersByPlaceable(token, paramsArray);
    }
    async function updateFiltersByPlaceable(placeable, paramsArray) {
        if (!(paramsArray instanceof Array) || paramsArray.length < 1) return;
        let flags = placeable.document.getFlag("tokenmagic", "filters");
        if (flags == null || !(flags instanceof Array) || flags.length < 1) return;
         // nothing to update...
        let workingFlags = [];
        flags.forEach((flag)=>{
            workingFlags.push(duplicate(flag));
        });
        for (const params1 of paramsArray){
            params1.updateId = randomID();
            if (params1.hasOwnProperty("randomized")) $97b1237a45b106ea$var$randomizeParams(params1);
            workingFlags.forEach((flag)=>{
                if (flag.tmFilters.tmFilterId === params1.filterId && flag.tmFilters.tmFilterType === params1.filterType) {
                    if (flag.tmFilters.hasOwnProperty("tmParams")) $97b1237a45b106ea$export$45dd0c4934db71d0(flag.tmFilters.tmParams, params1);
                }
            });
        }
        await placeable._TMFXsetFlag(workingFlags);
    }
    // Deleting filters on targeted tokens
    async function deleteFiltersOnTargeted(filterId = null) {
        let targeted = $97b1237a45b106ea$export$c0c03469ba031852();
        if (!(targeted == null) && targeted.length > 0) for (const token of targeted)await deleteFilters(token, filterId);
    }
    // Deleting filters on selected placeable(s)
    async function deleteFiltersOnSelected(filterId = null) {
        let placeables = $97b1237a45b106ea$export$674b9bd489502778();
        if (!(placeables == null) && placeables.length > 0) for (const placeable of placeables)await deleteFilters(placeable, filterId);
    }
    // Deleting all filters on a placeable in parameter
    async function deleteFilters(placeable, filterId = null) {
        if (placeable == null) return;
        if (filterId == null) {
            await placeable._TMFXunsetFlag();
            await placeable._TMFXunsetAnimeFlag();
        } else if (typeof filterId === "string") {
            let flags = placeable.document.getFlag("tokenmagic", "filters");
            if (flags == null || !(flags instanceof Array) || flags.length < 1) return;
             // nothing to delete...
            let workingFlags = [];
            flags.forEach((flag)=>{
                if (flag.tmFilters.tmFilterId !== filterId) workingFlags.push(duplicate(flag));
            });
            if (workingFlags.length > 0) await placeable._TMFXsetFlag(workingFlags);
            else await placeable._TMFXunsetFlag();
            flags = placeable.document.getFlag("tokenmagic", "animeInfo");
            if (flags == null || !(flags instanceof Array) || flags.length < 1) return;
             // nothing to delete...
            workingFlags = [];
            flags.forEach((flag)=>{
                if (flag.tmFilterId !== filterId) workingFlags.push(duplicate(flag));
            });
            if (workingFlags.length > 0) await placeable._TMFXsetAnimeFlag(workingFlags);
            else await placeable._TMFXunsetAnimeFlag();
        }
    }
    function hasFilterType(placeable, filterType) {
        if (placeable == null || filterType == null || !(placeable instanceof PlaceableObject)) return null;
        let flags = placeable.document.getFlag("tokenmagic", "filters");
        if (flags == null || !(flags instanceof Array) || flags.length < 1) return false;
        const found = flags.find((flag)=>flag.tmFilters.tmFilterType === filterType);
        if (found === undefined) return false;
        return true;
    }
    function isApplicableUser(tmParams) {
        const hasUser = (arr)=>{
            return arr.includes(game.user.name) || arr.includes(game.user.id);
        };
        if (tmParams.users?.include?.length && !hasUser(tmParams.users.include) || tmParams.users?.exclude?.length && hasUser(tmParams.users?.exclude)) return false;
        return true;
    }
    function hasFilterId(placeable, filterId) {
        if (placeable == null || !(placeable instanceof PlaceableObject)) return null;
        let flags = placeable.document.getFlag("tokenmagic", "filters");
        return _checkFilterId(placeable, filterId, flags);
    }
    function _checkFilterId(placeable, filterId, flags) {
        if (placeable == null || filterId == null || !(placeable instanceof PlaceableObject)) return null;
        if (flags == null || !(flags instanceof Array) || flags.length < 1) return false;
        const found = flags.find((flag)=>flag.tmFilters.tmFilterId === filterId);
        if (found === undefined) return false;
        return true;
    }
    function setFilter(placeable, filter) {
        placeable._TMFXsetRawFilters(filter);
    }
    function _loadPersistedValues(params1, animeInfos) {
        if (!params1.hasOwnProperty("animated")) return;
        if (!animeInfos || animeInfos.length <= 0) return;
        for (const effect of Object.keys(params1.animated)){
            for (const animeInfo of animeInfos.values())if (animeInfo.tmFilterId === params1.filterId && animeInfo.tmFilterInternalId === params1.filterInternalId && animeInfo.tmFilterEffect === effect) {
                params1.animated[effect].active = false;
                params1[effect] = animeInfo.tmFilterEffectValue;
                // special case for halfCosOscillation
                if (params1.animated[effect].animType === "halfCosOscillation") {
                    if (params1.animated[effect].val1 !== animeInfo.tmFilterEffectValue) {
                        params1.animated[effect].val2 = params1.animated[effect].val1;
                        params1.animated[effect].val1 = animeInfo.tmFilterEffectValue;
                    }
                }
            }
        }
    }
    function _assignFilters(placeable, filters, bulkLoading = false) {
        if (filters == null || placeable == null) return;
        // Assign all filters to the placeable
        let animeInfos = placeable.document.getFlag("tokenmagic", "animeInfo");
        for (const filterInfo of filters){
            // if bulkloading is on, we update with terminal value if it exists
            if (bulkLoading) {
                let params1 = filterInfo.tmFilters.tmParams;
                _loadPersistedValues(params1, animeInfos);
            }
            _assignFilter(placeable, filterInfo);
        }
    }
    function _assignFilter(placeable, filterInfo) {
        if (filterInfo == null) return;
        // Do not assign the filter if it has been explicitly set as not applicable to the current user
        if (!isApplicableUser(filterInfo.tmFilters.tmParams)) return;
        let workingFilterInfo = duplicate(filterInfo);
        workingFilterInfo.tmFilters.tmParams.placeableId = placeable.id;
        workingFilterInfo.tmFilters.tmParams.placeableType = placeable._TMFXgetPlaceableType();
        let filter = new $97b1237a45b106ea$export$c67e46de1ec7dfa6[workingFilterInfo.tmFilters.tmFilterType](workingFilterInfo.tmFilters.tmParams);
        setFilter(placeable, filter);
    }
    function _loadFilters(placeables, bulkLoading = true) {
        if (!(placeables == null)) placeables.slice().reverse().forEach((placeable)=>{
            _singleLoadFilters(placeable, bulkLoading);
        });
    }
    function _singleLoadFilters(placeable, bulkLoading = false) {
        let placeableType = placeable._TMFXgetPlaceableType();
        if (placeableType === $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE) {
            let updateData = placeable.document.getFlag("tokenmagic", "templateData");
            if (!(updateData == null)) {
                placeable.document.tmfxTextureAlpha = placeable._TMFXgetSprite().alpha = updateData.opacity;
                placeable.document.tmfxTint = updateData.tint;
            }
        }
        let filters = placeable.document.getFlag("tokenmagic", "filters");
        if (!(filters == null)) {
            if (placeableType === $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE) // get the first filterId to assign tmfxPreset
            placeable.document.tmfxPreset = filters[0].tmFilters.tmFilterId;
            _assignFilters(placeable, filters, bulkLoading);
        }
        placeable.loadingRequest = false;
    }
    function _fxPseudoEqual(flagObject, filterObject) {
        function isObject(object) {
            return object != null && typeof object === "object";
        }
        const flagKeys = Object.keys(flagObject);
        for (const flagKey of flagKeys){
            let flagValue = flagObject[flagKey];
            const filterValue = filterObject[flagKey];
            const areObjects = isObject(flagValue) && isObject(filterValue);
            if (areObjects && !_fxPseudoEqual(flagValue, filterValue)) return false;
            // handling the Infinity exception with loops... thanks to JSON serialization...
            if (!areObjects && flagKey === "loops" && flagValue === null) flagValue = Infinity; // not nice, but works ! :-)=
            if (!areObjects && flagValue !== filterValue) return false;
        }
        return true;
    }
    function _updateTemplateData(data, options, placeableType) {
        if (!options.hasOwnProperty("flags") || !options.flags.hasOwnProperty("tokenmagic")) return;
        if (data == null || !data.hasOwnProperty("_id")) return;
        let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(data._id, placeableType);
        if (placeable == null) return;
        let updateData = placeable.document.getFlag("tokenmagic", "templateData");
        if (!(updateData == null)) placeable._TMFXgetSprite().alpha = updateData.opacity;
    }
    function _updateFilters(data, options, placeableType) {
        if (!(options.hasOwnProperty("flags") && options.flags.hasOwnProperty("tokenmagic") && (options.flags.tokenmagic.hasOwnProperty("filters") || options.flags.tokenmagic.hasOwnProperty("-=filters")))) return;
        if (data == null || !data.hasOwnProperty("_id")) return;
        let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(data._id, placeableType);
        if (placeable == null) return;
        // Shortcut when all filters are deleted
        if (options.flags.tokenmagic.hasOwnProperty("-=filters")) {
            (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(data._id); // removing animations on this placeable
            this._clearImgFiltersByPlaceable(placeable); // clearing the filters (owned by tokenmagic)
            return;
        }
        let filters = placeable.document.getFlag("tokenmagic", "filters");
        if (filters == null) return;
        // CROSS-RESEARCH between the anime map and tokenmagic flags to add, delete or update filters on this placeable
        // we begin by detecting deleted filters
        for (let anime of (0, $c1844ae22deae2c0$export$b229f242afc35ae9).getAnimeMap().values())// we test all the animes that are supposed to be on the placeable
        if (anime.puppet.placeableId === placeable.id) {
            // is the animation present in the tokenmagic flags for this placeable ?
            // and is it applicable to the current user?
            let foundFilter = false;
            filters.forEach((filterFlag)=>{
                if (anime.puppet.filterId === filterFlag.tmFilters.tmFilterId && anime.puppet.filterInternalId === filterFlag.tmFilters.tmFilterInternalId && anime.puppet.placeableId === filterFlag.tmFilters.tmParams.placeableId && isApplicableUser(filterFlag.tmFilters.tmParams)) // we find it !
                foundFilter = true;
            });
            // Not found, the animation is removed from the AnimeMap as well as the filter on the placeable
            if (!foundFilter) {
                (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimationByFilterId(data._id, anime.puppet.filterId);
                this._clearImgFiltersByPlaceable(placeable, anime.puppet.filterId);
            }
        }
        // we test each tokenmagic filter flag in the placeable
        filters.forEach((filterFlag)=>{
            if (filterFlag.tmFilters.hasOwnProperty("tmParams")) {
                // we get the puppets in anime corresponding to this placeable
                let puppets = (0, $c1844ae22deae2c0$export$b229f242afc35ae9).getPuppetsByParams(filterFlag.tmFilters.tmParams);
                if (puppets.length > 0) // we found corresponding filters
                for (const puppet of puppets){
                    // we update if needed
                    if (!_fxPseudoEqual(filterFlag.tmFilters.tmParams, puppet)) {
                        if (!puppet.hasOwnProperty("updateId") || puppet.hasOwnProperty("updateId") && puppet.updateId !== filterFlag.tmFilters.tmParams.updateId) {
                            puppet.setTMParams(duplicate(filterFlag.tmFilters.tmParams));
                            puppet.normalizeTMParams();
                        }
                    }
                }
                else // this is a new filter, we assign it to the placeable
                _assignFilter(placeable, filterFlag);
            }
        });
    }
    function _clearImgFiltersByPlaceable(placeable, filterId = null) {
        if (placeable == null) return;
        let filterById = filterId != null && typeof filterId === "string";
        function destroyClearedFilters(theFilters) {
            if (theFilters instanceof Array) {
                let tmFilters = theFilters.filter((filter)=>filterById ? filter.hasOwnProperty("filterId") && filter.filterId === filterId : filter.hasOwnProperty("filterId"));
                for (const filter of tmFilters){
                    filter.enabled = false;
                    filter.destroy();
                }
            }
        }
        function filterTheFiltering(theFilters) {
            if (theFilters instanceof Array) {
                let tmFilters = theFilters.filter((filter)=>filterById ? !(filter.hasOwnProperty("filterId") && filter.filterId === filterId) : !filter.hasOwnProperty("filterId"));
                return tmFilters.length === 0 ? null : tmFilters;
            }
            return theFilters;
        }
        let sprite = placeable._TMFXgetSprite();
        if (sprite != null) {
            destroyClearedFilters(sprite.filters);
            sprite.filters = filterTheFiltering(sprite.filters);
        }
    }
    async function _importPresetContent(content, options = {}) {
        // In internal, we can force overwrite
        if (!options.hasOwnProperty("overwrite")) options.overwrite = game.settings.get("tokenmagic", "importOverwrite");
        ///////////////////////////////////////////////
        // Checking the imported object format
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> checking import file format...");
        if (!(content instanceof Array) || content.length < 1) {
            $97b1237a45b106ea$export$a3bc9b8ed74fc("import -> file format check KO !");
            $97b1237a45b106ea$export$a3bc9b8ed74fc($97b1237a45b106ea$var$i18n("TMFX.preset.import.format.failure"));
            return false;
        }
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> file format check OK !");
        // check object format end
        /////////////////////////////////////////////////
        let check = true;
        ///////////////////////////////////////////////
        // Checking the imported content
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> checking import file content...");
        for (const element of content)if (element.hasOwnProperty("name") && typeof element.name === "string" && element.hasOwnProperty("params") && element.params instanceof Array) {
            for (const effect of element.params)if (!(effect.hasOwnProperty("filterType") && $97b1237a45b106ea$export$c67e46de1ec7dfa6.hasOwnProperty(effect.filterType))) {
                check = false;
                break;
            }
            if (!check) break;
        } else {
            check = false;
            break;
        }
        if (!check) {
            $97b1237a45b106ea$export$a3bc9b8ed74fc("import -> file content check KO !");
            $97b1237a45b106ea$export$a3bc9b8ed74fc($97b1237a45b106ea$var$i18n("TMFX.preset.import.format.failure"));
            return false;
        }
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> file content check OK !");
        // check content end
        /////////////////////////////////////////////////
        // The preset libray must be replaced ?
        if (options.hasOwnProperty("replaceLibrary") && options.replaceLibrary) {
            await game.settings.set("tokenmagic", "presets", content);
            $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> preset library replaced");
            $97b1237a45b106ea$export$bef1f36f5486a6a3($97b1237a45b106ea$var$i18n("TMFX.preset.import.success"));
            return true;
        }
        let pst = game.settings.get("tokenmagic", "presets");
        let it = 0;
        for (const element of content){
            const preset = pst.find((el)=>el.name === element.name);
            if (preset == null) {
                $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> add: " + element.name);
                pst.push(element);
                it++;
            } else if (options.hasOwnProperty("overwrite") && options.overwrite) {
                const index = pst.indexOf(preset);
                if (index > -1) {
                    $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> overwrite: " + element.name);
                    pst[index] = element;
                    it++;
                }
            } else $97b1237a45b106ea$export$c106dd0671a0fc2d("import -> ignored: " + element.name + " -> already exists");
        }
        await game.settings.set("tokenmagic", "presets", pst);
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> " + it + " preset(s) added to the library");
        $97b1237a45b106ea$export$bef1f36f5486a6a3($97b1237a45b106ea$var$i18n("TMFX.preset.import.success"));
        return true;
    }
    async function _importTemplateSettingsContent(content, options = {}) {
        ///////////////////////////////////////////////
        // Checking the imported object format
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> checking import file format...");
        if (!(content instanceof Object)) {
            $97b1237a45b106ea$export$a3bc9b8ed74fc("import -> file format check KO !");
            $97b1237a45b106ea$export$a3bc9b8ed74fc($97b1237a45b106ea$var$i18n("TMFX.preset.import.format.failure"));
            return false;
        }
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> file format check OK !");
        // check object format end
        /////////////////////////////////////////////////
        await game.settings.set("tokenmagic", "autoTemplateSettings", content);
        $97b1237a45b106ea$export$bef1f36f5486a6a3("import -> automatic template settings replaced");
        $97b1237a45b106ea$export$bef1f36f5486a6a3($97b1237a45b106ea$var$i18n("TMFX.preset.import.success"));
        return true;
    }
    async function resetPresetLibrary() {
        if (!game.user.isGM) return;
        if (confirm($97b1237a45b106ea$var$i18n("TMFX.preset.reset.message"))) try {
            await game.settings.set("tokenmagic", "presets", (0, $ff7eec2964ce8415$export$9381e89181e5b461));
            ui.notifications.info($97b1237a45b106ea$var$i18n("TMFX.preset.reset.success"));
        } catch (e) {
            $97b1237a45b106ea$export$a3bc9b8ed74fc(e.message);
        }
    }
    async function importPresetLibraryFromURL(url, options = {}) {
        try {
            $.getJSON(url, async function(content) {
                return await _importPresetContent(content, options);
            });
        } catch (e) {
            $97b1237a45b106ea$export$a3bc9b8ed74fc(e.message);
            $97b1237a45b106ea$export$a3bc9b8ed74fc($97b1237a45b106ea$var$i18n("TMFX.preset.import.failure"));
            return false;
        }
    }
    async function importPresetLibraryFromPath(path, options = {}) {
        try {
            const response = await fetch(path);
            const content = await response.json();
            return await _importPresetContent(content, options);
        } catch (e) {
            $97b1237a45b106ea$export$a3bc9b8ed74fc(e.message);
            $97b1237a45b106ea$export$a3bc9b8ed74fc($97b1237a45b106ea$var$i18n("TMFX.preset.import.failure"));
            return false;
        }
    }
    async function importTemplateSettingsFromPath(path, options = {}) {
        try {
            const response = await fetch(path);
            const content = await response.json();
            return await _importTemplateSettingsContent(content, options);
        } catch (e) {
            $97b1237a45b106ea$export$a3bc9b8ed74fc(e.message);
            $97b1237a45b106ea$export$a3bc9b8ed74fc($97b1237a45b106ea$var$i18n("TMFX.preset.import.failure"));
            return false;
        }
    }
    async function importPresetLibrary() {
        const path = "modules/tokenmagic/import";
        new FilePicker({
            type: "json",
            current: path,
            callback: importPresetLibraryFromPath
        }).browse();
    }
    function exportPresetLibrary(exportName = "tmfx-presets") {
        let pst = game.settings.get("tokenmagic", "presets");
        if (pst == null || typeof pst !== "object") return false;
        $97b1237a45b106ea$var$exportObjectAsJson(pst, exportName);
    }
    async function importTemplateSettings() {
        const path = "modules/tokenmagic/import";
        new FilePicker({
            type: "json",
            current: path,
            callback: importTemplateSettingsFromPath
        }).browse();
    }
    function exportTemplateSettings(exportName = "tmfx-template-settings") {
        let pst = game.settings.get("tokenmagic", "autoTemplateSettings");
        if (pst == null || typeof pst !== "object") return false;
        $97b1237a45b106ea$var$exportObjectAsJson(pst, exportName);
    }
    function getPresets(libraryName = (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).MAIN) {
        let pst = game.settings.get("tokenmagic", "presets");
        if (pst == null || typeof pst !== "object") return [];
        return pst.filter((preset)=>preset.library === libraryName);
    }
    function _getPresetTemplateDefaultTexture(presetName, presetLibrary = (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).TEMPLATE) {
        let pst = game.settings.get("tokenmagic", "presets");
        const preset = pst.find((el)=>el["name"] === presetName && el["library"] === presetLibrary);
        if (!(preset == null) && preset.hasOwnProperty("defaultTexture")) return $97b1237a45b106ea$export$3bebb302ab08af33(preset.defaultTexture);
        else return null;
    }
    function getPreset(presetName) {
        let pName = null, pLibrary = null;
        let argIsObj = presetName instanceof Object;
        const { name: name, library: library, ...adjustmentProp } = argIsObj ? presetName : {};
        if (argIsObj) {
            if (presetName.hasOwnProperty("name")) pName = presetName.name;
            if (presetName.hasOwnProperty("library")) pLibrary = presetName.library;
        } else pName = presetName;
        if (pLibrary == null || typeof pLibrary !== "string") pLibrary = (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).MAIN;
        if (typeof pName !== "string") return undefined;
        let pst = game.settings.get("tokenmagic", "presets");
        if (pst == null || typeof pst !== "object") return undefined;
        const preset = pst.find((el)=>el["name"] === pName && el["library"] === pLibrary);
        if (!(preset == null) && preset.hasOwnProperty("params") && preset.params instanceof Array) {
            for (const [filterProp, filterPropVal] of Object.entries(adjustmentProp)){
                //log(`getPreset ${filterProp}: ${filterPropVal}`);
                for (const param of preset.params)if (param.hasOwnProperty(filterProp)) param[filterProp] = filterPropVal;
            }
            return deepClone(preset.params);
        }
        return undefined;
    }
    async function deletePreset(presetName, silent = false) {
        if (!game.user.isGM) {
            if (!silent) ui.notifications.warn($97b1237a45b106ea$var$i18n("TMFX.preset.delete.permission.failure"));
            return false;
        }
        let pName = null, pLibrary = null;
        if (presetName instanceof Object) {
            if (presetName.hasOwnProperty("name")) pName = presetName.name;
            if (presetName.hasOwnProperty("library")) pLibrary = presetName.library;
        } else pName = presetName;
        if (pLibrary == null || typeof pLibrary !== "string") pLibrary = (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).MAIN;
        if (typeof pName !== "string") {
            if (!silent) ui.notifications.error($97b1237a45b106ea$var$i18n("TMFX.preset.delete.params.failure"));
            return false;
        }
        let pst = game.settings.get("tokenmagic", "presets");
        if (pst == null) {
            if (!silent) ui.notifications.warn($97b1237a45b106ea$var$i18n("TMFX.preset.delete.empty.failure"));
            return false;
        }
        let state = true;
        const preset = pst.find((el)=>el["name"] === pName && el["library"] === pLibrary);
        if (preset == null) {
            if (!silent) ui.notifications.warn($97b1237a45b106ea$var$i18n("TMFX.preset.delete.notfound.failure"));
            state = false;
        } else {
            const index = pst.indexOf(preset);
            if (index > -1) {
                pst.splice(index, 1);
                try {
                    await game.settings.set("tokenmagic", "presets", pst);
                    if (!silent) ui.notifications.info($97b1237a45b106ea$var$i18n("TMFX.preset.delete.success"));
                } catch (e) {
                    if (!silent) ui.notifications.error(e.message);
                    console.error(e);
                    state = false;
                }
            }
        }
        return state;
    }
    async function addPreset(presetName, params1, silent = false) {
        if (!game.user.isGM) {
            if (!silent) ui.notifications.warn($97b1237a45b106ea$var$i18n("TMFX.preset.add.permission.failure"));
            return false;
        }
        let pName = null, pLibrary = null, pDefaultTexture = null;
        if (presetName instanceof Object) {
            if (presetName.hasOwnProperty("name")) pName = presetName.name;
            if (presetName.hasOwnProperty("library")) pLibrary = presetName.library;
            if (presetName.hasOwnProperty("defaultTexture")) pDefaultTexture = $97b1237a45b106ea$export$3bebb302ab08af33(presetName.defaultTexture);
        } else pName = presetName;
        if (pLibrary == null || typeof pLibrary !== "string") pLibrary = (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).MAIN;
        if (typeof pDefaultTexture !== "string") pDefaultTexture = null;
        if (typeof pName !== "string" && !(params1 instanceof Array)) {
            if (!silent) ui.notifications.error($97b1237a45b106ea$var$i18n("TMFX.preset.add.params.failure"));
            return false;
        }
        for (const param of params1)param.filterId = pName;
        let pst = game.settings.get("tokenmagic", "presets");
        let presetObject = {};
        presetObject.name = pName;
        presetObject.library = pLibrary;
        presetObject.params = params1;
        if (pDefaultTexture != null) presetObject.defaultTexture = pDefaultTexture;
        let state = true;
        if (pst == null) pst = [
            presetObject
        ];
        else {
            const preset = pst.find((el)=>el["name"] === pName && el["library"] === pLibrary);
            if (preset == null) pst.push(presetObject);
            else {
                if (!silent) ui.notifications.warn($97b1237a45b106ea$var$i18n("TMFX.preset.add.duplicate.failure"));
                state = false;
            }
        }
        if (state) try {
            await game.settings.set("tokenmagic", "presets", pst);
            if (!silent) ui.notifications.info($97b1237a45b106ea$var$i18n("TMFX.preset.add.success"));
        } catch (e) {
            if (!silent) ui.notifications.error(e.message);
            console.error(e);
            state = false;
        }
        return state;
    }
    return {
        addFilters: addFilters,
        addFiltersOnSelected: addFiltersOnSelected,
        addFiltersOnTargeted: addFiltersOnTargeted,
        addUpdateFilters: addUpdateFilters,
        addUpdateFiltersOnSelected: addUpdateFiltersOnSelected,
        addUpdateFiltersOnTargeted: addUpdateFiltersOnTargeted,
        deleteFilters: deleteFilters,
        deleteFiltersOnSelected: deleteFiltersOnSelected,
        deleteFiltersOnTargeted: deleteFiltersOnTargeted,
        updateFilters: updateFilters,
        updateFiltersOnSelected: updateFiltersOnSelected,
        updateFiltersOnTargeted: updateFiltersOnTargeted,
        updateFiltersByPlaceable: updateFiltersByPlaceable,
        hasFilterType: hasFilterType,
        hasFilterId: hasFilterId,
        importTemplateSettings: importTemplateSettings,
        importTemplateSettingsFromPath: importTemplateSettingsFromPath,
        exportTemplateSettings: exportTemplateSettings,
        exportPresetLibrary: exportPresetLibrary,
        importPresetLibrary: importPresetLibrary,
        importPresetLibraryFromURL: importPresetLibraryFromURL,
        importPresetLibraryFromPath: importPresetLibraryFromPath,
        resetPresetLibrary: resetPresetLibrary,
        getPresets: getPresets,
        getPreset: getPreset,
        addPreset: addPreset,
        deletePreset: deletePreset,
        getControlledPlaceables: $97b1237a45b106ea$export$674b9bd489502778,
        getTargetedTokens: $97b1237a45b106ea$export$c0c03469ba031852,
        getPlaceableById: $97b1237a45b106ea$export$5008448b4c27fa2b,
        get filterTypes () {
            return $97b1237a45b106ea$export$c67e46de1ec7dfa6;
        },
        _assignFilters: _assignFilters,
        _loadFilters: _loadFilters,
        _clearImgFiltersByPlaceable: _clearImgFiltersByPlaceable,
        _getAnimeMap: (0, $c1844ae22deae2c0$export$b229f242afc35ae9).getAnimeMap,
        _updateFilters: _updateFilters,
        _updateTemplateData: _updateTemplateData,
        _singleLoadFilters: _singleLoadFilters,
        _cachedContainer: _cachedContainer,
        _checkFilterId: _checkFilterId,
        _getPresetTemplateDefaultTexture: _getPresetTemplateDefaultTexture
    };
}
const $97b1237a45b106ea$export$480e4c19201e4e74 = $97b1237a45b106ea$export$4367b12d875874d3();
async function $97b1237a45b106ea$var$compilingShaders() {
    // Caching filters to prevent freezing on first-time loading (shader compilation time)
    // https://www.html5gamedevs.com/topic/43652-shader-compile-performance/
    let params1 = {
        enabled: true,
        dummy: true
    };
    $97b1237a45b106ea$export$480e4c19201e4e74._cachedContainer.filters = [];
    const filterTypes = Object.keys($97b1237a45b106ea$export$c67e46de1ec7dfa6);
    for (const filterType of filterTypes){
        params1.filterType = filterType;
        $97b1237a45b106ea$export$bef1f36f5486a6a3(`Caching ${filterType}`);
        $97b1237a45b106ea$export$480e4c19201e4e74._cachedContainer.filters.push(new $97b1237a45b106ea$export$c67e46de1ec7dfa6[filterType](params1));
    }
    $97b1237a45b106ea$export$bef1f36f5486a6a3("Compiling shaders...");
    let tmpRenderTexture = new PIXI.RenderTexture.create({
        width: 4,
        height: 4
    });
    // A call to render triggers the compilation of all the shaders bound to the filters.
    canvas.app.renderer.render($97b1237a45b106ea$export$480e4c19201e4e74._cachedContainer, {
        renderTexture: tmpRenderTexture
    });
    $97b1237a45b106ea$export$bef1f36f5486a6a3("Shaders compiled for the GPU and ready!");
}
function $97b1237a45b106ea$var$initSocketListener() {
    // Activate the listener only for the One
    const theOne = game.users.find((user)=>user.isGM && user.active);
    if (theOne && game.user !== theOne) return;
    // Listener the listening
    game.socket.on($97b1237a45b106ea$var$moduleTM, async (data)=>{
        if (data == null || !data.hasOwnProperty("tmAction")) return;
        async function updateFlags(targetFlag) {
            // getting the scene coming from the socket
            let scene = game.scenes.get(data.tmViewedScene);
            if (scene == null) return;
            // preparing flag data (with -= if the data is null)
            let updateData;
            if (data.tmFlag == null) updateData = {
                [`flags.tokenmagic.-=${targetFlag}`]: null
            };
            else updateData = {
                [`flags.tokenmagic.${targetFlag}`]: data.tmFlag
            };
            updateData["_id"] = data.tmPlaceableId;
            // updating the placeable in the scene
            await scene.updateEmbeddedDocuments(data.tmPlaceableType, [
                updateData
            ]);
        }
        switch(data.tmAction){
            case $97b1237a45b106ea$export$157d7b8c087faa7b.SET_FLAG:
                await updateFlags(`filters`);
                break;
            case $97b1237a45b106ea$export$157d7b8c087faa7b.SET_ANIME_FLAG:
                await updateFlags(`animeInfo`);
                break;
        }
    });
}
async function $97b1237a45b106ea$var$requestLoadFilters(placeable, startTimeout = 0) {
    let reqTimer;
    placeable.loadingRequest = true;
    function launchRequest(placeable) {
        reqTimer = setTimeout(()=>{
            if (placeable == null) return;
            let check = placeable._TMFXcheckSprite();
            if (check == null) {
                placeable.loadingRequest = false;
                return;
            } else if (check) $97b1237a45b106ea$export$480e4c19201e4e74._singleLoadFilters(placeable);
            else launchRequest(placeable);
        }, 35);
    }
    function setRequestTimeOut() {
        setTimeout(()=>{
            clearTimeout(reqTimer);
        }, 2000);
    }
    setTimeout(()=>{
        setRequestTimeOut();
        launchRequest(placeable);
    }, startTimeout);
}
function $97b1237a45b106ea$var$getAnchor(direction, angle, shapeType) {
    if (shapeType === "circle" || shapeType === "rect") return {
        x: 0.5,
        y: 0.5
    };
    // Compute emanation anchor point from the orthonormal bounding rect containing the polygon.
    // Not complete (to rework later), but ok with cardinal and half-cardinal directions
    let dirRad = direction * Math.PI / 180;
    let angleRad = angle * Math.PI / 180;
    let cosRa1 = Math.cos(dirRad - angleRad / 2);
    let rsinRa1 = -Math.sin(dirRad - angleRad / 2);
    let cosRa2 = Math.cos(dirRad + angleRad / 2);
    let rsinRa2 = -Math.sin(dirRad + angleRad / 2);
    let x = 0, y = 1;
    if (cosRa1 < 0 && cosRa2 < 0) x = 1;
    else if (cosRa1 < 0 || cosRa2 < 0) x = (Math.sin(-dirRad - Math.PI / 2) + 1) / 2;
    if (rsinRa1 < 0 && rsinRa2 < 0) y = 0;
    else if (rsinRa1 < 0 || rsinRa2 < 0) y = (Math.cos(-dirRad - Math.PI / 2) + 1) / 2;
    return {
        x: x,
        y: y
    };
}
function $97b1237a45b106ea$var$onMeasuredTemplateConfig(data, html) {
    if (!$97b1237a45b106ea$export$62085f0363fc8c9()) html[0].querySelector(".file-picker").dataset.type = "imagevideo";
    function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    }
    let tmTemplate = data.object;
    if (isNewerVersion(game.version, "0.8")) tmTemplate = tmTemplate.object;
    let opacity = tmTemplate.template.alpha;
    let tint = "";
    let currentPreset = (0, $165cdb672a404ae7$export$680af52575be3523);
    // getting custom data
    let tmfxTemplateData = tmTemplate.document.getFlag("tokenmagic", "templateData");
    if (!(tmfxTemplateData == null) && tmfxTemplateData instanceof Object) {
        opacity = tmTemplate.document.tmfxTextureAlpha = tmfxTemplateData.opacity;
        tint = tmTemplate.document.tmfxTint = tmfxTemplateData.tint ? PIXI.utils.hex2string(tmfxTemplateData.tint) : "";
        if (tmfxTemplateData.preset !== undefined) currentPreset = tmfxTemplateData.preset;
    }
    let filters = tmTemplate.document.getFlag("tokenmagic", "filters");
    let presets = $97b1237a45b106ea$export$480e4c19201e4e74.getPresets((0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).TEMPLATE);
    if (filters && filters instanceof Array && filters.length >= 1) currentPreset = filters[0].tmFilters.tmFilterId;
    // forming our injected html
    let tmfxValues = "";
    let selected = "";
    tmfxValues += `<option value="${0, $165cdb672a404ae7$export$680af52575be3523}"></option>`;
    presets.sort(compare).forEach((preset)=>{
        selected = preset.name === currentPreset ? " selected" : "";
        tmfxValues += `<option value="${preset.name}"${selected}>${preset.name}</option>`;
    });
    let divPreset = `
    <div class="form-group">
        <label>${$97b1237a45b106ea$var$i18n("TMFX.template.opacity")}</label>
        <div class="form-fields">
            <input type="range" name="flags.tokenmagic.templateData.opacity" value="${opacity}" min="0.0" max="1.0" step="0.05" data-dtype="Number"/>
            <span class="range-value">${opacity}</span>
        </div>
    </div>

    <div class="form-group">
        <label>${$97b1237a45b106ea$var$i18n("TMFX.template.fx")}</label>
        <select class="tmfx" name="flags.tokenmagic.templateData.preset" data-dtype="String">
        ${tmfxValues}
        </select>
    </div>

    <div class="form-group">
        <label>${$97b1237a45b106ea$var$i18n("TMFX.template.tint")}</label>
        <div class="form-fields">
            <input class="color" type="text" name="flags.tokenmagic.templateData.tint" value="${tint}"/>
            <input type="color" value="${tint}" data-edit="flags.tokenmagic.templateData.tint"/>
        </div>
    </div>
    `;
    // injecting
    const htmlForm = html.find(".form-group");
    htmlForm.last().after(divPreset);
    $(html).css({
        "min-height": "525px"
    });
}
/* -------------------------------------------- */ /*  Setup Management                            */ /* -------------------------------------------- */ Hooks.on("ready", ()=>{
    $97b1237a45b106ea$export$bef1f36f5486a6a3("Hook -> ready");
    (0, $a48a250facc06caa$export$182eb7a8e7220720)();
    $97b1237a45b106ea$var$initSocketListener();
    window.TokenMagic = $97b1237a45b106ea$export$480e4c19201e4e74;
    if (!game.modules.get("lib-wrapper")?.active && game.user.isGM) ui.notifications.warn("The 'Token Magic FX' module recommends to install and activate the 'libWrapper' module.");
    Hooks.on("renderMeasuredTemplateConfig", $97b1237a45b106ea$var$onMeasuredTemplateConfig);
});
/* -------------------------------------------- */ /*  Canvas Management                           */ /* -------------------------------------------- */ Hooks.once("canvasInit", (canvas1)=>{
    if (!$97b1237a45b106ea$export$4d149f3fface3da5()) {
        $97b1237a45b106ea$export$bef1f36f5486a6a3("Init -> canvasInit -> caching shaders");
        $97b1237a45b106ea$var$compilingShaders();
    }
});
/* -------------------------------------------- */ Hooks.on("canvasInit", (canvas1)=>{
    $97b1237a45b106ea$export$bef1f36f5486a6a3("Hook -> canvasInit");
    $97b1237a45b106ea$export$2bf9d1af56f0b37d();
    (0, $c1844ae22deae2c0$export$b229f242afc35ae9).deactivateAnimation();
    (0, $c1844ae22deae2c0$export$b229f242afc35ae9).resetAnimation();
});
/* -------------------------------------------- */ Hooks.on("canvasReady", (canvas1)=>{
    $97b1237a45b106ea$export$bef1f36f5486a6a3("Hook -> canvasReady");
    if (!window.hasOwnProperty("TokenMagic")) window.TokenMagic = $97b1237a45b106ea$export$480e4c19201e4e74;
    if (canvas1 == null) return;
    const tokens = canvas1.tokens.placeables;
    $97b1237a45b106ea$export$480e4c19201e4e74._loadFilters(tokens);
    const tiles = canvas1.tiles.placeables;
    $97b1237a45b106ea$export$480e4c19201e4e74._loadFilters(tiles);
    const drawings = canvas1.drawings.placeables;
    $97b1237a45b106ea$export$480e4c19201e4e74._loadFilters(drawings);
    const templates = canvas1.templates.placeables;
    $97b1237a45b106ea$export$480e4c19201e4e74._loadFilters(templates);
    (0, $c1844ae22deae2c0$export$b229f242afc35ae9).activateAnimation();
});
/* -------------------------------------------- */ /*  Scenes Management                           */ /* -------------------------------------------- */ Hooks.on("deleteScene", (document1)=>{
    if (document1.id !== game.user.viewedScene) return;
    (0, $c1844ae22deae2c0$export$b229f242afc35ae9).deactivateAnimation();
    (0, $c1844ae22deae2c0$export$b229f242afc35ae9).resetAnimation();
});
/* -------------------------------------------- */ /*  Settings Management                         */ /* -------------------------------------------- */ Hooks.on("closeSettingsConfig", ()=>{
    $97b1237a45b106ea$export$2bf9d1af56f0b37d();
});
/* -------------------------------------------- */ /*  Tokens Management                           */ /* -------------------------------------------- */ Hooks.on("createToken", (document1)=>{
    if (document1.parent.id !== game.user.viewedScene) return;
    if (document1.flags?.tokenmagic?.filters) {
        let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.TOKEN);
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250);
    }
});
/* -------------------------------------------- */ Hooks.on("deleteToken", (_, document1)=>{
    if (!(document1 == null || !document1._id)) (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id);
});
/* -------------------------------------------- */ Hooks.on("updateToken", (document1, options)=>{
    if (document1.parent.id !== game.user.viewedScene) return;
    if ([
        "img",
        "tint",
        "height",
        "width",
        "name"
    ].some((k)=>k in options)) {
        let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.TOKEN);
        (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id); // removing animations on this placeable
        $97b1237a45b106ea$export$480e4c19201e4e74._clearImgFiltersByPlaceable(placeable); // clearing the filters (owned by tokenmagic)
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250);
    } else $97b1237a45b106ea$export$480e4c19201e4e74._updateFilters(document1, options, $97b1237a45b106ea$export$f2f6f02affe07ab5.TOKEN);
});
/* -------------------------------------------- */ /*  Tiles Management                            */ /* -------------------------------------------- */ Hooks.on("createTile", (document1)=>{
    if (document1.parent.id !== game.user.viewedScene) return;
    if (document1.flags?.tokenmagic?.filters) {
        const placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.TILE);
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250);
    }
});
/* -------------------------------------------- */ Hooks.on("deleteTile", (_, document1)=>{
    if (!(document1 == null || !document1._id)) (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id);
});
/* -------------------------------------------- */ Hooks.on("updateTile", (document1, options)=>{
    if (document1.parent.id !== game.user.viewedScene) return;
    if (options.texture?.src || options.overhead) {
        const placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.TILE);
        (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id); // removing animations on this placeable
        $97b1237a45b106ea$export$480e4c19201e4e74._clearImgFiltersByPlaceable(placeable); // clearing the filters (owned by tokenmagic)
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250);
    } else $97b1237a45b106ea$export$480e4c19201e4e74._updateFilters(document1, options, $97b1237a45b106ea$export$f2f6f02affe07ab5.TILE);
});
/* -------------------------------------------- */ /*  Drawings Management                         */ /* -------------------------------------------- */ Hooks.on("createDrawing", (document1)=>{
    if (document1.parent.id !== game.user.viewedScene) return;
    if (document1.flags?.tokenmagic?.filters) {
        let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.DRAWING);
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250);
    }
});
/* -------------------------------------------- */ Hooks.on("deleteDrawing", (_, document1)=>{
    if (!(document1 == null || !document1._id)) (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id);
});
/* -------------------------------------------- */ Hooks.on("updateDrawing", (document1, options)=>{
    if (document1.parent.id !== game.user.viewedScene) return;
    if (!options.flags?.tokenmagic || options.x || options.y) {
        let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.DRAWING);
        (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id); // removing animations on this placeable
        $97b1237a45b106ea$export$480e4c19201e4e74._clearImgFiltersByPlaceable(placeable); // clearing the filters (owned by tokenmagic)
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250);
    } else $97b1237a45b106ea$export$480e4c19201e4e74._updateFilters(document1, options, $97b1237a45b106ea$export$f2f6f02affe07ab5.DRAWING);
});
/* -------------------------------------------- */ /*  Measured Templates Management               */ /* -------------------------------------------- */ Hooks.on("createMeasuredTemplate", (document1)=>{
    const scene = document1.parent;
    if (!(scene == null) && scene.id === game.user.viewedScene && document1.flags?.tokenmagic?.filters) {
        let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE);
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250); // request to load filters (when pixi containers are ready)
    }
});
/* -------------------------------------------- */ Hooks.on("deleteMeasuredTemplate", (_, document1)=>{
    if (!(document1 == null || !document1._id)) (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id);
});
/* -------------------------------------------- */ Hooks.on("updateMeasuredTemplate", (document1, options)=>{
    if (document1.parent.id !== game.user.viewedScene) return;
    let placeable = $97b1237a45b106ea$export$5008448b4c27fa2b(document1._id, $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE);
    if (!placeable) return;
    if (options.texture) {
        (0, $c1844ae22deae2c0$export$b229f242afc35ae9).removeAnimation(document1._id); // removing animations on this placeable
        $97b1237a45b106ea$export$480e4c19201e4e74._clearImgFiltersByPlaceable(placeable); // clearing the filters (owned by tokenmagic)
        $97b1237a45b106ea$var$requestLoadFilters(placeable, 250); // querying filters reload (when pixi containers are ready)
    } else if (!placeable.loadingRequest) {
        $97b1237a45b106ea$export$480e4c19201e4e74._updateFilters(document1, options, $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE);
        $97b1237a45b106ea$export$480e4c19201e4e74._updateTemplateData(document1, options, $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE);
    }
});
/* -------------------------------------------- */ Hooks.on("preUpdateMeasuredTemplate", async (document1, options)=>{
    function getTint() {
        if (options.flags?.tokenmagic?.templateData?.tint !== undefined) return options.flags.tokenmagic.templateData.tint;
        else if (document1.flags?.tokenmagic?.tint !== undefined) return document1.flags.tokenmagic.tint;
        else return "";
    }
    function getFX() {
        if (options.flags?.tokenmagic?.templateData?.preset !== undefined) return options.flags.tokenmagic.templateData.preset;
        else if (document1.flags?.tokenmagic?.templateData?.preset !== undefined) return document1.flags.tokenmagic.templateData.preset;
        else if (document1.tmfxPreset !== undefined) return document1.tmfxPreset;
        else return 0, $165cdb672a404ae7$export$680af52575be3523;
    }
    function getDirection() {
        if (options.direction) return options.direction;
        else if (document1.direction) return document1.direction;
        else return 0;
    }
    function getAngle() {
        if (options.angle) return options.angle;
        else if (document1.angle) return document1.angle;
        else return 0;
    }
    function getShapeType() {
        if (options.t) return options.t;
        else if (document1.t) return document1.t;
        else return "ITSBAD";
    }
    let measuredTemplateInstance = canvas.templates.get(document1._id);
    let templateTint = getTint();
    let presetUpdate = options.flags?.tokenmagic?.templateData?.preset !== undefined;
    let tintUpdate = options.flags?.tokenmagic?.templateData?.tint !== undefined;
    let directionUpdate = options.hasOwnProperty("direction");
    let angleUpdate = options.hasOwnProperty("angle");
    let typeUpdate = options.hasOwnProperty("t");
    if (tintUpdate) options.flags.tokenmagic.templateData.tint = templateTint !== "" ? Color.from(templateTint).valueOf() : null;
    if (presetUpdate || tintUpdate || directionUpdate || typeUpdate || angleUpdate) {
        let templateFX = getFX();
        if (templateFX !== (0, $165cdb672a404ae7$export$680af52575be3523)) {
            let anchor = $97b1237a45b106ea$var$getAnchor(getDirection(), getAngle(), getShapeType());
            let presetOptions = {
                name: templateFX,
                library: (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).TEMPLATE,
                anchorX: anchor.x,
                anchorY: anchor.y
            };
            if (templateTint && templateTint !== "") presetOptions.color = Color.from(templateTint).valueOf();
            let preset = $97b1237a45b106ea$export$480e4c19201e4e74.getPreset(presetOptions);
            if (!(preset == null)) {
                if (presetUpdate) await measuredTemplateInstance.TMFXaddFilters(preset, true);
                else await measuredTemplateInstance.TMFXaddUpdateFilters(preset);
            }
        } else await measuredTemplateInstance.TMFXdeleteFilters();
    }
});
/* -------------------------------------------- */ Hooks.on("preCreateMeasuredTemplate", (document1)=>{
    // Do nothing if we're on a 3D Canvas scene
    if (game.Levels3DPreview?._active) return;
    // Apply auto-preset if needed
    const templates = (0, $4c34bd360e81b010$export$804072f25096732f).getSystemTemplates();
    if (templates?.enabled) templates.preCreateMeasuredTemplate?.(document1);
    const hasFlags = document1.flags;
    let hasPreset = false;
    let hasTint = false;
    let hasOpacity = false;
    let hasFlagsNoOptions = false;
    if (hasFlags && document1.flags.tokenmagic?.options) {
        const opt = document1.flags.tokenmagic.options;
        if (opt.tmfxPreset) {
            document1.tmfxPreset = opt.tmfxPreset;
            hasPreset = true;
        }
        if (opt.tmfxTint) {
            document1.tmfxTint = opt.tmfxTint;
            hasTint = true;
        }
        if (opt.tmfxTextureAlpha) {
            document1.tmfxTextureAlpha = opt.tmfxTextureAlpha;
            hasOpacity = true;
        }
        if (opt.tmfxTexture) {
            document1.texture = opt.tmfxTexture;
            document1.updateSource({
                texture: opt.tmfxTexture
            });
        }
    } else hasFlagsNoOptions = true;
    let hasTexture = document1.texture && document1.texture !== "";
    let newFilters = [];
    let tmfxBaseFlags = {
        tokenmagic: {
            filters: null,
            templateData: null,
            options: null
        }
    };
    if (hasFlags && hasFlagsNoOptions) {
        // the measured template comes with tokenmagic flags ? It is a copy ! We do nothing.
        if (document1.flags.tokenmagic) return;
        document1.flags = mergeObject(document1.flags, tmfxBaseFlags, true, true);
    }
    // normalizing color to value if needed
    if (hasTint && typeof document1.tmfxTint !== "number") document1.tmfxTint = Color.from(document1.tmfxTint).valueOf();
    let tmfxFiltersData = null;
    // FX to add ?
    if (hasPreset) {
        // Compute shader anchor point
        let anchor = $97b1237a45b106ea$var$getAnchor(document1.direction, document1.angle, document1.t);
        // Constructing the preset search object
        let pstSearch = {
            name: document1.tmfxPreset,
            library: (0, $ff7eec2964ce8415$export$19612c32a2f7f4cd).TEMPLATE,
            anchorX: anchor.x,
            anchorY: anchor.y
        };
        // Adding tint if needed
        if (hasTint) pstSearch.color = document1.tmfxTint;
        // Retrieving the preset
        let preset = $97b1237a45b106ea$export$480e4c19201e4e74.getPreset(pstSearch);
        if (!(preset == null) && preset instanceof Array) {
            let defaultTex = $97b1237a45b106ea$export$480e4c19201e4e74._getPresetTemplateDefaultTexture(pstSearch.name);
            if (!(defaultTex == null) && !hasTexture) document1.updateSource({
                texture: defaultTex
            });
            let persist = true;
            // Constructing the filter flag parameters
            for (const params1 of preset){
                if (!params1.filterType || !$97b1237a45b106ea$export$c67e46de1ec7dfa6.hasOwnProperty(params1.filterType)) {
                    // one invalid ? all rejected.
                    persist = false;
                    break;
                }
                // getPreset MUST provide a filter id
                if (!params1.filterId) {
                    persist = false;
                    break;
                }
                if (!params1.enabled || !(typeof params1.enabled === "boolean")) params1.enabled = true;
                params1.placeableId = null;
                params1.filterInternalId = randomID();
                params1.filterOwner = game.data.userId;
                params1.placeableType = $97b1237a45b106ea$export$f2f6f02affe07ab5.TEMPLATE;
                newFilters.push({
                    tmFilters: {
                        tmFilterId: params1.filterId,
                        tmFilterInternalId: params1.filterInternalId,
                        tmFilterType: params1.filterType,
                        tmFilterOwner: params1.filterOwner,
                        tmParams: params1
                    }
                });
            }
            if (persist) tmfxFiltersData = newFilters;
        }
    } else document1.tmfxPreset = (0, $165cdb672a404ae7$export$680af52575be3523);
    if (!hasOpacity) document1.tmfxTextureAlpha = 1;
    if (!hasTint) document1.tmfxTint = null;
    let tmfxFlags = {
        templateData: {
            opacity: document1.tmfxTextureAlpha,
            tint: document1.tmfxTint
        },
        filters: tmfxFiltersData,
        options: null
    };
    document1.updateSource({
        flags: {
            tokenmagic: tmfxFlags
        }
    });
});


export {$97b1237a45b106ea$export$c67e46de1ec7dfa6 as FilterType, $97b1237a45b106ea$export$f2f6f02affe07ab5 as PlaceableType, $97b1237a45b106ea$export$157d7b8c087faa7b as SocketAction, $97b1237a45b106ea$export$24d33a6f4bffea69 as broadcast, $97b1237a45b106ea$export$73ccc1811a23c47 as isActiveModule, $97b1237a45b106ea$export$a3e1d0865041c250 as getMinPadding, $97b1237a45b106ea$export$db02b1003f6b14db as isAdditivePaddingConfig, $97b1237a45b106ea$export$4d149f3fface3da5 as isFilterCachingDisabled, $97b1237a45b106ea$export$62085f0363fc8c9 as isVideoDisabled, $97b1237a45b106ea$export$485113ed30b22bb8 as isTheOne, $97b1237a45b106ea$export$ae4b89d79d01bd2b as mustBroadCast, $97b1237a45b106ea$export$2bf9d1af56f0b37d as autosetPaddingMode, $97b1237a45b106ea$export$222530a21fa4a417 as isZOrderConfig, $97b1237a45b106ea$export$4876a704e2bf90fb as isAnimationDisabled, $97b1237a45b106ea$export$bef1f36f5486a6a3 as log, $97b1237a45b106ea$export$c106dd0671a0fc2d as warn, $97b1237a45b106ea$export$a3bc9b8ed74fc as error, $97b1237a45b106ea$export$3bebb302ab08af33 as fixPath, $97b1237a45b106ea$export$674b9bd489502778 as getControlledPlaceables, $97b1237a45b106ea$export$c0c03469ba031852 as getTargetedTokens, $97b1237a45b106ea$export$5008448b4c27fa2b as getPlaceableById, $97b1237a45b106ea$export$45dd0c4934db71d0 as objectAssign, $97b1237a45b106ea$export$4367b12d875874d3 as TokenMagic, $97b1237a45b106ea$export$480e4c19201e4e74 as Magic};
//# sourceMappingURL=tokenmagicBundle.js.map
